const regionData = [{
        "id": 110000,
        "region_name": "北京市",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 110100,
        "region_name": "北京市",
        "parent_id": 110000,
        "level": 2
    },
    {
        "id": 110101,
        "region_name": "东城区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110102,
        "region_name": "西城区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110105,
        "region_name": "朝阳区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110106,
        "region_name": "丰台区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110107,
        "region_name": "石景山区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110108,
        "region_name": "海淀区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110109,
        "region_name": "门头沟区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110111,
        "region_name": "房山区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110112,
        "region_name": "通州区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110113,
        "region_name": "顺义区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110114,
        "region_name": "昌平区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110115,
        "region_name": "大兴区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110116,
        "region_name": "怀柔区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110117,
        "region_name": "平谷区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110118,
        "region_name": "密云区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 110119,
        "region_name": "延庆区",
        "parent_id": 110100,
        "level": 3
    },
    {
        "id": 120000,
        "region_name": "天津市",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 120100,
        "region_name": "天津市",
        "parent_id": 120000,
        "level": 2
    },
    {
        "id": 120101,
        "region_name": "和平区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120102,
        "region_name": "河东区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120103,
        "region_name": "河西区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120104,
        "region_name": "南开区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120105,
        "region_name": "河北区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120106,
        "region_name": "红桥区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120110,
        "region_name": "东丽区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120111,
        "region_name": "西青区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120112,
        "region_name": "津南区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120113,
        "region_name": "北辰区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120114,
        "region_name": "武清区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120115,
        "region_name": "宝坻区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120116,
        "region_name": "滨海新区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120117,
        "region_name": "宁河区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120118,
        "region_name": "静海区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 120119,
        "region_name": "蓟州区",
        "parent_id": 120100,
        "level": 3
    },
    {
        "id": 130000,
        "region_name": "河北省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 130100,
        "region_name": "石家庄市",
        "parent_id": 130000,
        "level": 2
    },
    {
        "id": 130102,
        "region_name": "长安区",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130104,
        "region_name": "桥西区",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130105,
        "region_name": "新华区",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130107,
        "region_name": "井陉矿区",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130108,
        "region_name": "裕华区",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130109,
        "region_name": "藁城区",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130110,
        "region_name": "鹿泉区",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130111,
        "region_name": "栾城区",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130121,
        "region_name": "井陉县",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130123,
        "region_name": "正定县",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130125,
        "region_name": "行唐县",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130126,
        "region_name": "灵寿县",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130127,
        "region_name": "高邑县",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130128,
        "region_name": "深泽县",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130129,
        "region_name": "赞皇县",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130130,
        "region_name": "无极县",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130131,
        "region_name": "平山县",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130132,
        "region_name": "元氏县",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130133,
        "region_name": "赵县",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130181,
        "region_name": "辛集市",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130183,
        "region_name": "晋州市",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130184,
        "region_name": "新乐市",
        "parent_id": 130100,
        "level": 3
    },
    {
        "id": 130200,
        "region_name": "唐山市",
        "parent_id": 130000,
        "level": 2
    },
    {
        "id": 130202,
        "region_name": "路南区",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130203,
        "region_name": "路北区",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130204,
        "region_name": "古冶区",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130205,
        "region_name": "开平区",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130207,
        "region_name": "丰南区",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130208,
        "region_name": "丰润区",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130209,
        "region_name": "曹妃甸区",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130223,
        "region_name": "滦县",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130224,
        "region_name": "滦南县",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130225,
        "region_name": "乐亭县",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130227,
        "region_name": "迁西县",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130229,
        "region_name": "玉田县",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130281,
        "region_name": "遵化市",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130283,
        "region_name": "迁安市",
        "parent_id": 130200,
        "level": 3
    },
    {
        "id": 130300,
        "region_name": "秦皇岛市",
        "parent_id": 130000,
        "level": 2
    },
    {
        "id": 130302,
        "region_name": "海港区",
        "parent_id": 130300,
        "level": 3
    },
    {
        "id": 130303,
        "region_name": "山海关区",
        "parent_id": 130300,
        "level": 3
    },
    {
        "id": 130304,
        "region_name": "北戴河区",
        "parent_id": 130300,
        "level": 3
    },
    {
        "id": 130306,
        "region_name": "抚宁区",
        "parent_id": 130300,
        "level": 3
    },
    {
        "id": 130321,
        "region_name": "青龙满族自治县",
        "parent_id": 130300,
        "level": 3
    },
    {
        "id": 130322,
        "region_name": "昌黎县",
        "parent_id": 130300,
        "level": 3
    },
    {
        "id": 130324,
        "region_name": "卢龙县",
        "parent_id": 130300,
        "level": 3
    },
    {
        "id": 130400,
        "region_name": "邯郸市",
        "parent_id": 130000,
        "level": 2
    },
    {
        "id": 130402,
        "region_name": "邯山区",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130403,
        "region_name": "丛台区",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130404,
        "region_name": "复兴区",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130406,
        "region_name": "峰峰矿区",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130407,
        "region_name": "肥乡区",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130408,
        "region_name": "永年区",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130423,
        "region_name": "临漳县",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130424,
        "region_name": "成安县",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130425,
        "region_name": "大名县",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130426,
        "region_name": "涉县",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130427,
        "region_name": "磁县",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130430,
        "region_name": "邱县",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130431,
        "region_name": "鸡泽县",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130432,
        "region_name": "广平县",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130433,
        "region_name": "馆陶县",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130434,
        "region_name": "魏县",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130435,
        "region_name": "曲周县",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130481,
        "region_name": "武安市",
        "parent_id": 130400,
        "level": 3
    },
    {
        "id": 130500,
        "region_name": "邢台市",
        "parent_id": 130000,
        "level": 2
    },
    {
        "id": 130502,
        "region_name": "桥东区",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130503,
        "region_name": "桥西区",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130521,
        "region_name": "邢台县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130522,
        "region_name": "临城县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130523,
        "region_name": "内丘县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130524,
        "region_name": "柏乡县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130525,
        "region_name": "隆尧县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130526,
        "region_name": "任县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130527,
        "region_name": "南和县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130528,
        "region_name": "宁晋县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130529,
        "region_name": "巨鹿县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130530,
        "region_name": "新河县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130531,
        "region_name": "广宗县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130532,
        "region_name": "平乡县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130533,
        "region_name": "威县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130534,
        "region_name": "清河县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130535,
        "region_name": "临西县",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130581,
        "region_name": "南宫市",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130582,
        "region_name": "沙河市",
        "parent_id": 130500,
        "level": 3
    },
    {
        "id": 130600,
        "region_name": "保定市",
        "parent_id": 130000,
        "level": 2
    },
    {
        "id": 130602,
        "region_name": "竞秀区",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130606,
        "region_name": "莲池区",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130607,
        "region_name": "满城区",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130608,
        "region_name": "清苑区",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130609,
        "region_name": "徐水区",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130623,
        "region_name": "涞水县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130624,
        "region_name": "阜平县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130626,
        "region_name": "定兴县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130627,
        "region_name": "唐县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130628,
        "region_name": "高阳县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130629,
        "region_name": "容城县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130630,
        "region_name": "涞源县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130631,
        "region_name": "望都县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130632,
        "region_name": "安新县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130633,
        "region_name": "易县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130634,
        "region_name": "曲阳县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130635,
        "region_name": "蠡县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130636,
        "region_name": "顺平县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130637,
        "region_name": "博野县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130638,
        "region_name": "雄县",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130681,
        "region_name": "涿州市",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130682,
        "region_name": "定州市",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130683,
        "region_name": "安国市",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130684,
        "region_name": "高碑店市",
        "parent_id": 130600,
        "level": 3
    },
    {
        "id": 130700,
        "region_name": "张家口市",
        "parent_id": 130000,
        "level": 2
    },
    {
        "id": 130702,
        "region_name": "桥东区",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130703,
        "region_name": "桥西区",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130705,
        "region_name": "宣化区",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130706,
        "region_name": "下花园区",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130708,
        "region_name": "万全区",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130709,
        "region_name": "崇礼区",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130722,
        "region_name": "张北县",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130723,
        "region_name": "康保县",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130724,
        "region_name": "沽源县",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130725,
        "region_name": "尚义县",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130726,
        "region_name": "蔚县",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130727,
        "region_name": "阳原县",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130728,
        "region_name": "怀安县",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130730,
        "region_name": "怀来县",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130731,
        "region_name": "涿鹿县",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130732,
        "region_name": "赤城县",
        "parent_id": 130700,
        "level": 3
    },
    {
        "id": 130800,
        "region_name": "承德市",
        "parent_id": 130000,
        "level": 2
    },
    {
        "id": 130802,
        "region_name": "双桥区",
        "parent_id": 130800,
        "level": 3
    },
    {
        "id": 130803,
        "region_name": "双滦区",
        "parent_id": 130800,
        "level": 3
    },
    {
        "id": 130804,
        "region_name": "鹰手营子矿区",
        "parent_id": 130800,
        "level": 3
    },
    {
        "id": 130821,
        "region_name": "承德县",
        "parent_id": 130800,
        "level": 3
    },
    {
        "id": 130822,
        "region_name": "兴隆县",
        "parent_id": 130800,
        "level": 3
    },
    {
        "id": 130824,
        "region_name": "滦平县",
        "parent_id": 130800,
        "level": 3
    },
    {
        "id": 130825,
        "region_name": "隆化县",
        "parent_id": 130800,
        "level": 3
    },
    {
        "id": 130826,
        "region_name": "丰宁满族自治县",
        "parent_id": 130800,
        "level": 3
    },
    {
        "id": 130827,
        "region_name": "宽城满族自治县",
        "parent_id": 130800,
        "level": 3
    },
    {
        "id": 130828,
        "region_name": "围场满族蒙古族自治县",
        "parent_id": 130800,
        "level": 3
    },
    {
        "id": 130881,
        "region_name": "平泉市",
        "parent_id": 130800,
        "level": 3
    },
    {
        "id": 130900,
        "region_name": "沧州市",
        "parent_id": 130000,
        "level": 2
    },
    {
        "id": 130902,
        "region_name": "新华区",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130903,
        "region_name": "运河区",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130921,
        "region_name": "沧县",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130922,
        "region_name": "青县",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130923,
        "region_name": "东光县",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130924,
        "region_name": "海兴县",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130925,
        "region_name": "盐山县",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130926,
        "region_name": "肃宁县",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130927,
        "region_name": "南皮县",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130928,
        "region_name": "吴桥县",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130929,
        "region_name": "献县",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130930,
        "region_name": "孟村回族自治县",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130981,
        "region_name": "泊头市",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130982,
        "region_name": "任丘市",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130983,
        "region_name": "黄骅市",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 130984,
        "region_name": "河间市",
        "parent_id": 130900,
        "level": 3
    },
    {
        "id": 131000,
        "region_name": "廊坊市",
        "parent_id": 130000,
        "level": 2
    },
    {
        "id": 131002,
        "region_name": "安次区",
        "parent_id": 131000,
        "level": 3
    },
    {
        "id": 131003,
        "region_name": "广阳区",
        "parent_id": 131000,
        "level": 3
    },
    {
        "id": 131022,
        "region_name": "固安县",
        "parent_id": 131000,
        "level": 3
    },
    {
        "id": 131023,
        "region_name": "永清县",
        "parent_id": 131000,
        "level": 3
    },
    {
        "id": 131024,
        "region_name": "香河县",
        "parent_id": 131000,
        "level": 3
    },
    {
        "id": 131025,
        "region_name": "大城县",
        "parent_id": 131000,
        "level": 3
    },
    {
        "id": 131026,
        "region_name": "文安县",
        "parent_id": 131000,
        "level": 3
    },
    {
        "id": 131028,
        "region_name": "大厂回族自治县",
        "parent_id": 131000,
        "level": 3
    },
    {
        "id": 131081,
        "region_name": "霸州市",
        "parent_id": 131000,
        "level": 3
    },
    {
        "id": 131082,
        "region_name": "三河市",
        "parent_id": 131000,
        "level": 3
    },
    {
        "id": 131100,
        "region_name": "衡水市",
        "parent_id": 130000,
        "level": 2
    },
    {
        "id": 131102,
        "region_name": "桃城区",
        "parent_id": 131100,
        "level": 3
    },
    {
        "id": 131103,
        "region_name": "冀州区",
        "parent_id": 131100,
        "level": 3
    },
    {
        "id": 131121,
        "region_name": "枣强县",
        "parent_id": 131100,
        "level": 3
    },
    {
        "id": 131122,
        "region_name": "武邑县",
        "parent_id": 131100,
        "level": 3
    },
    {
        "id": 131123,
        "region_name": "武强县",
        "parent_id": 131100,
        "level": 3
    },
    {
        "id": 131124,
        "region_name": "饶阳县",
        "parent_id": 131100,
        "level": 3
    },
    {
        "id": 131125,
        "region_name": "安平县",
        "parent_id": 131100,
        "level": 3
    },
    {
        "id": 131126,
        "region_name": "故城县",
        "parent_id": 131100,
        "level": 3
    },
    {
        "id": 131127,
        "region_name": "景县",
        "parent_id": 131100,
        "level": 3
    },
    {
        "id": 131128,
        "region_name": "阜城县",
        "parent_id": 131100,
        "level": 3
    },
    {
        "id": 131182,
        "region_name": "深州市",
        "parent_id": 131100,
        "level": 3
    },
    {
        "id": 140000,
        "region_name": "山西省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 140100,
        "region_name": "太原市",
        "parent_id": 140000,
        "level": 2
    },
    {
        "id": 140105,
        "region_name": "小店区",
        "parent_id": 140100,
        "level": 3
    },
    {
        "id": 140106,
        "region_name": "迎泽区",
        "parent_id": 140100,
        "level": 3
    },
    {
        "id": 140107,
        "region_name": "杏花岭区",
        "parent_id": 140100,
        "level": 3
    },
    {
        "id": 140108,
        "region_name": "尖草坪区",
        "parent_id": 140100,
        "level": 3
    },
    {
        "id": 140109,
        "region_name": "万柏林区",
        "parent_id": 140100,
        "level": 3
    },
    {
        "id": 140110,
        "region_name": "晋源区",
        "parent_id": 140100,
        "level": 3
    },
    {
        "id": 140121,
        "region_name": "清徐县",
        "parent_id": 140100,
        "level": 3
    },
    {
        "id": 140122,
        "region_name": "阳曲县",
        "parent_id": 140100,
        "level": 3
    },
    {
        "id": 140123,
        "region_name": "娄烦县",
        "parent_id": 140100,
        "level": 3
    },
    {
        "id": 140181,
        "region_name": "古交市",
        "parent_id": 140100,
        "level": 3
    },
    {
        "id": 140200,
        "region_name": "大同市",
        "parent_id": 140000,
        "level": 2
    },
    {
        "id": 140212,
        "region_name": "新荣区",
        "parent_id": 140200,
        "level": 3
    },
    {
        "id": 140213,
        "region_name": "平城区",
        "parent_id": 140200,
        "level": 3
    },
    {
        "id": 140214,
        "region_name": "云冈区",
        "parent_id": 140200,
        "level": 3
    },
    {
        "id": 140215,
        "region_name": "云州区",
        "parent_id": 140200,
        "level": 3
    },
    {
        "id": 140221,
        "region_name": "阳高县",
        "parent_id": 140200,
        "level": 3
    },
    {
        "id": 140222,
        "region_name": "天镇县",
        "parent_id": 140200,
        "level": 3
    },
    {
        "id": 140223,
        "region_name": "广灵县",
        "parent_id": 140200,
        "level": 3
    },
    {
        "id": 140224,
        "region_name": "灵丘县",
        "parent_id": 140200,
        "level": 3
    },
    {
        "id": 140225,
        "region_name": "浑源县",
        "parent_id": 140200,
        "level": 3
    },
    {
        "id": 140226,
        "region_name": "左云县",
        "parent_id": 140200,
        "level": 3
    },
    {
        "id": 140300,
        "region_name": "阳泉市",
        "parent_id": 140000,
        "level": 2
    },
    {
        "id": 140302,
        "region_name": "城区",
        "parent_id": 140300,
        "level": 3
    },
    {
        "id": 140303,
        "region_name": "矿区",
        "parent_id": 140300,
        "level": 3
    },
    {
        "id": 140311,
        "region_name": "郊区",
        "parent_id": 140300,
        "level": 3
    },
    {
        "id": 140321,
        "region_name": "平定县",
        "parent_id": 140300,
        "level": 3
    },
    {
        "id": 140322,
        "region_name": "盂县",
        "parent_id": 140300,
        "level": 3
    },
    {
        "id": 140400,
        "region_name": "长治市",
        "parent_id": 140000,
        "level": 2
    },
    {
        "id": 140402,
        "region_name": "城区",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140411,
        "region_name": "郊区",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140421,
        "region_name": "长治县",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140423,
        "region_name": "襄垣县",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140424,
        "region_name": "屯留县",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140425,
        "region_name": "平顺县",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140426,
        "region_name": "黎城县",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140427,
        "region_name": "壶关县",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140428,
        "region_name": "长子县",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140429,
        "region_name": "武乡县",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140430,
        "region_name": "沁县",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140431,
        "region_name": "沁源县",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140481,
        "region_name": "潞城市",
        "parent_id": 140400,
        "level": 3
    },
    {
        "id": 140500,
        "region_name": "晋城市",
        "parent_id": 140000,
        "level": 2
    },
    {
        "id": 140502,
        "region_name": "城区",
        "parent_id": 140500,
        "level": 3
    },
    {
        "id": 140521,
        "region_name": "沁水县",
        "parent_id": 140500,
        "level": 3
    },
    {
        "id": 140522,
        "region_name": "阳城县",
        "parent_id": 140500,
        "level": 3
    },
    {
        "id": 140524,
        "region_name": "陵川县",
        "parent_id": 140500,
        "level": 3
    },
    {
        "id": 140525,
        "region_name": "泽州县",
        "parent_id": 140500,
        "level": 3
    },
    {
        "id": 140581,
        "region_name": "高平市",
        "parent_id": 140500,
        "level": 3
    },
    {
        "id": 140600,
        "region_name": "朔州市",
        "parent_id": 140000,
        "level": 2
    },
    {
        "id": 140602,
        "region_name": "朔城区",
        "parent_id": 140600,
        "level": 3
    },
    {
        "id": 140603,
        "region_name": "平鲁区",
        "parent_id": 140600,
        "level": 3
    },
    {
        "id": 140621,
        "region_name": "山阴县",
        "parent_id": 140600,
        "level": 3
    },
    {
        "id": 140622,
        "region_name": "应县",
        "parent_id": 140600,
        "level": 3
    },
    {
        "id": 140623,
        "region_name": "右玉县",
        "parent_id": 140600,
        "level": 3
    },
    {
        "id": 140624,
        "region_name": "怀仁县",
        "parent_id": 140600,
        "level": 3
    },
    {
        "id": 140700,
        "region_name": "晋中市",
        "parent_id": 140000,
        "level": 2
    },
    {
        "id": 140702,
        "region_name": "榆次区",
        "parent_id": 140700,
        "level": 3
    },
    {
        "id": 140721,
        "region_name": "榆社县",
        "parent_id": 140700,
        "level": 3
    },
    {
        "id": 140722,
        "region_name": "左权县",
        "parent_id": 140700,
        "level": 3
    },
    {
        "id": 140723,
        "region_name": "和顺县",
        "parent_id": 140700,
        "level": 3
    },
    {
        "id": 140724,
        "region_name": "昔阳县",
        "parent_id": 140700,
        "level": 3
    },
    {
        "id": 140725,
        "region_name": "寿阳县",
        "parent_id": 140700,
        "level": 3
    },
    {
        "id": 140726,
        "region_name": "太谷县",
        "parent_id": 140700,
        "level": 3
    },
    {
        "id": 140727,
        "region_name": "祁县",
        "parent_id": 140700,
        "level": 3
    },
    {
        "id": 140728,
        "region_name": "平遥县",
        "parent_id": 140700,
        "level": 3
    },
    {
        "id": 140729,
        "region_name": "灵石县",
        "parent_id": 140700,
        "level": 3
    },
    {
        "id": 140781,
        "region_name": "介休市",
        "parent_id": 140700,
        "level": 3
    },
    {
        "id": 140800,
        "region_name": "运城市",
        "parent_id": 140000,
        "level": 2
    },
    {
        "id": 140802,
        "region_name": "盐湖区",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140821,
        "region_name": "临猗县",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140822,
        "region_name": "万荣县",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140823,
        "region_name": "闻喜县",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140824,
        "region_name": "稷山县",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140825,
        "region_name": "新绛县",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140826,
        "region_name": "绛县",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140827,
        "region_name": "垣曲县",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140828,
        "region_name": "夏县",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140829,
        "region_name": "平陆县",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140830,
        "region_name": "芮城县",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140881,
        "region_name": "永济市",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140882,
        "region_name": "河津市",
        "parent_id": 140800,
        "level": 3
    },
    {
        "id": 140900,
        "region_name": "忻州市",
        "parent_id": 140000,
        "level": 2
    },
    {
        "id": 140902,
        "region_name": "忻府区",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140921,
        "region_name": "定襄县",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140922,
        "region_name": "五台县",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140923,
        "region_name": "代县",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140924,
        "region_name": "繁峙县",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140925,
        "region_name": "宁武县",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140926,
        "region_name": "静乐县",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140927,
        "region_name": "神池县",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140928,
        "region_name": "五寨县",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140929,
        "region_name": "岢岚县",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140930,
        "region_name": "河曲县",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140931,
        "region_name": "保德县",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140932,
        "region_name": "偏关县",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 140981,
        "region_name": "原平市",
        "parent_id": 140900,
        "level": 3
    },
    {
        "id": 141000,
        "region_name": "临汾市",
        "parent_id": 140000,
        "level": 2
    },
    {
        "id": 141002,
        "region_name": "尧都区",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141021,
        "region_name": "曲沃县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141022,
        "region_name": "翼城县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141023,
        "region_name": "襄汾县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141024,
        "region_name": "洪洞县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141025,
        "region_name": "古县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141026,
        "region_name": "安泽县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141027,
        "region_name": "浮山县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141028,
        "region_name": "吉县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141029,
        "region_name": "乡宁县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141030,
        "region_name": "大宁县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141031,
        "region_name": "隰县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141032,
        "region_name": "永和县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141033,
        "region_name": "蒲县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141034,
        "region_name": "汾西县",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141081,
        "region_name": "侯马市",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141082,
        "region_name": "霍州市",
        "parent_id": 141000,
        "level": 3
    },
    {
        "id": 141100,
        "region_name": "吕梁市",
        "parent_id": 140000,
        "level": 2
    },
    {
        "id": 141102,
        "region_name": "离石区",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 141121,
        "region_name": "文水县",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 141122,
        "region_name": "交城县",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 141123,
        "region_name": "兴县",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 141124,
        "region_name": "临县",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 141125,
        "region_name": "柳林县",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 141126,
        "region_name": "石楼县",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 141127,
        "region_name": "岚县",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 141128,
        "region_name": "方山县",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 141129,
        "region_name": "中阳县",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 141130,
        "region_name": "交口县",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 141181,
        "region_name": "孝义市",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 141182,
        "region_name": "汾阳市",
        "parent_id": 141100,
        "level": 3
    },
    {
        "id": 150000,
        "region_name": "内蒙古自治区",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 150100,
        "region_name": "呼和浩特市",
        "parent_id": 150000,
        "level": 2
    },
    {
        "id": 150102,
        "region_name": "新城区",
        "parent_id": 150100,
        "level": 3
    },
    {
        "id": 150103,
        "region_name": "回民区",
        "parent_id": 150100,
        "level": 3
    },
    {
        "id": 150104,
        "region_name": "玉泉区",
        "parent_id": 150100,
        "level": 3
    },
    {
        "id": 150105,
        "region_name": "赛罕区",
        "parent_id": 150100,
        "level": 3
    },
    {
        "id": 150121,
        "region_name": "土默特左旗",
        "parent_id": 150100,
        "level": 3
    },
    {
        "id": 150122,
        "region_name": "托克托县",
        "parent_id": 150100,
        "level": 3
    },
    {
        "id": 150123,
        "region_name": "和林格尔县",
        "parent_id": 150100,
        "level": 3
    },
    {
        "id": 150124,
        "region_name": "清水河县",
        "parent_id": 150100,
        "level": 3
    },
    {
        "id": 150125,
        "region_name": "武川县",
        "parent_id": 150100,
        "level": 3
    },
    {
        "id": 150200,
        "region_name": "包头市",
        "parent_id": 150000,
        "level": 2
    },
    {
        "id": 150202,
        "region_name": "东河区",
        "parent_id": 150200,
        "level": 3
    },
    {
        "id": 150203,
        "region_name": "昆都仑区",
        "parent_id": 150200,
        "level": 3
    },
    {
        "id": 150204,
        "region_name": "青山区",
        "parent_id": 150200,
        "level": 3
    },
    {
        "id": 150205,
        "region_name": "石拐区",
        "parent_id": 150200,
        "level": 3
    },
    {
        "id": 150206,
        "region_name": "白云鄂博矿区",
        "parent_id": 150200,
        "level": 3
    },
    {
        "id": 150207,
        "region_name": "九原区",
        "parent_id": 150200,
        "level": 3
    },
    {
        "id": 150221,
        "region_name": "土默特右旗",
        "parent_id": 150200,
        "level": 3
    },
    {
        "id": 150222,
        "region_name": "固阳县",
        "parent_id": 150200,
        "level": 3
    },
    {
        "id": 150223,
        "region_name": "达尔罕茂明安联合旗",
        "parent_id": 150200,
        "level": 3
    },
    {
        "id": 150300,
        "region_name": "乌海市",
        "parent_id": 150000,
        "level": 2
    },
    {
        "id": 150302,
        "region_name": "海勃湾区",
        "parent_id": 150300,
        "level": 3
    },
    {
        "id": 150303,
        "region_name": "海南区",
        "parent_id": 150300,
        "level": 3
    },
    {
        "id": 150304,
        "region_name": "乌达区",
        "parent_id": 150300,
        "level": 3
    },
    {
        "id": 150400,
        "region_name": "赤峰市",
        "parent_id": 150000,
        "level": 2
    },
    {
        "id": 150402,
        "region_name": "红山区",
        "parent_id": 150400,
        "level": 3
    },
    {
        "id": 150403,
        "region_name": "元宝山区",
        "parent_id": 150400,
        "level": 3
    },
    {
        "id": 150404,
        "region_name": "松山区",
        "parent_id": 150400,
        "level": 3
    },
    {
        "id": 150421,
        "region_name": "阿鲁科尔沁旗",
        "parent_id": 150400,
        "level": 3
    },
    {
        "id": 150422,
        "region_name": "巴林左旗",
        "parent_id": 150400,
        "level": 3
    },
    {
        "id": 150423,
        "region_name": "巴林右旗",
        "parent_id": 150400,
        "level": 3
    },
    {
        "id": 150424,
        "region_name": "林西县",
        "parent_id": 150400,
        "level": 3
    },
    {
        "id": 150425,
        "region_name": "克什克腾旗",
        "parent_id": 150400,
        "level": 3
    },
    {
        "id": 150426,
        "region_name": "翁牛特旗",
        "parent_id": 150400,
        "level": 3
    },
    {
        "id": 150428,
        "region_name": "喀喇沁旗",
        "parent_id": 150400,
        "level": 3
    },
    {
        "id": 150429,
        "region_name": "宁城县",
        "parent_id": 150400,
        "level": 3
    },
    {
        "id": 150430,
        "region_name": "敖汉旗",
        "parent_id": 150400,
        "level": 3
    },
    {
        "id": 150500,
        "region_name": "通辽市",
        "parent_id": 150000,
        "level": 2
    },
    {
        "id": 150502,
        "region_name": "科尔沁区",
        "parent_id": 150500,
        "level": 3
    },
    {
        "id": 150521,
        "region_name": "科尔沁左翼中旗",
        "parent_id": 150500,
        "level": 3
    },
    {
        "id": 150522,
        "region_name": "科尔沁左翼后旗",
        "parent_id": 150500,
        "level": 3
    },
    {
        "id": 150523,
        "region_name": "开鲁县",
        "parent_id": 150500,
        "level": 3
    },
    {
        "id": 150524,
        "region_name": "库伦旗",
        "parent_id": 150500,
        "level": 3
    },
    {
        "id": 150525,
        "region_name": "奈曼旗",
        "parent_id": 150500,
        "level": 3
    },
    {
        "id": 150526,
        "region_name": "扎鲁特旗",
        "parent_id": 150500,
        "level": 3
    },
    {
        "id": 150581,
        "region_name": "霍林郭勒市",
        "parent_id": 150500,
        "level": 3
    },
    {
        "id": 150600,
        "region_name": "鄂尔多斯市",
        "parent_id": 150000,
        "level": 2
    },
    {
        "id": 150602,
        "region_name": "东胜区",
        "parent_id": 150600,
        "level": 3
    },
    {
        "id": 150603,
        "region_name": "康巴什区",
        "parent_id": 150600,
        "level": 3
    },
    {
        "id": 150621,
        "region_name": "达拉特旗",
        "parent_id": 150600,
        "level": 3
    },
    {
        "id": 150622,
        "region_name": "准格尔旗",
        "parent_id": 150600,
        "level": 3
    },
    {
        "id": 150623,
        "region_name": "鄂托克前旗",
        "parent_id": 150600,
        "level": 3
    },
    {
        "id": 150624,
        "region_name": "鄂托克旗",
        "parent_id": 150600,
        "level": 3
    },
    {
        "id": 150625,
        "region_name": "杭锦旗",
        "parent_id": 150600,
        "level": 3
    },
    {
        "id": 150626,
        "region_name": "乌审旗",
        "parent_id": 150600,
        "level": 3
    },
    {
        "id": 150627,
        "region_name": "伊金霍洛旗",
        "parent_id": 150600,
        "level": 3
    },
    {
        "id": 150700,
        "region_name": "呼伦贝尔市",
        "parent_id": 150000,
        "level": 2
    },
    {
        "id": 150702,
        "region_name": "海拉尔区",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150703,
        "region_name": "扎赉诺尔区",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150721,
        "region_name": "阿荣旗",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150722,
        "region_name": "莫力达瓦达斡尔族自治旗",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150723,
        "region_name": "鄂伦春自治旗",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150724,
        "region_name": "鄂温克族自治旗",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150725,
        "region_name": "陈巴尔虎旗",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150726,
        "region_name": "新巴尔虎左旗",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150727,
        "region_name": "新巴尔虎右旗",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150781,
        "region_name": "满洲里市",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150782,
        "region_name": "牙克石市",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150783,
        "region_name": "扎兰屯市",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150784,
        "region_name": "额尔古纳市",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150785,
        "region_name": "根河市",
        "parent_id": 150700,
        "level": 3
    },
    {
        "id": 150800,
        "region_name": "巴彦淖尔市",
        "parent_id": 150000,
        "level": 2
    },
    {
        "id": 150802,
        "region_name": "临河区",
        "parent_id": 150800,
        "level": 3
    },
    {
        "id": 150821,
        "region_name": "五原县",
        "parent_id": 150800,
        "level": 3
    },
    {
        "id": 150822,
        "region_name": "磴口县",
        "parent_id": 150800,
        "level": 3
    },
    {
        "id": 150823,
        "region_name": "乌拉特前旗",
        "parent_id": 150800,
        "level": 3
    },
    {
        "id": 150824,
        "region_name": "乌拉特中旗",
        "parent_id": 150800,
        "level": 3
    },
    {
        "id": 150825,
        "region_name": "乌拉特后旗",
        "parent_id": 150800,
        "level": 3
    },
    {
        "id": 150826,
        "region_name": "杭锦后旗",
        "parent_id": 150800,
        "level": 3
    },
    {
        "id": 150900,
        "region_name": "乌兰察布市",
        "parent_id": 150000,
        "level": 2
    },
    {
        "id": 150902,
        "region_name": "集宁区",
        "parent_id": 150900,
        "level": 3
    },
    {
        "id": 150921,
        "region_name": "卓资县",
        "parent_id": 150900,
        "level": 3
    },
    {
        "id": 150922,
        "region_name": "化德县",
        "parent_id": 150900,
        "level": 3
    },
    {
        "id": 150923,
        "region_name": "商都县",
        "parent_id": 150900,
        "level": 3
    },
    {
        "id": 150924,
        "region_name": "兴和县",
        "parent_id": 150900,
        "level": 3
    },
    {
        "id": 150925,
        "region_name": "凉城县",
        "parent_id": 150900,
        "level": 3
    },
    {
        "id": 150926,
        "region_name": "察哈尔右翼前旗",
        "parent_id": 150900,
        "level": 3
    },
    {
        "id": 150927,
        "region_name": "察哈尔右翼中旗",
        "parent_id": 150900,
        "level": 3
    },
    {
        "id": 150928,
        "region_name": "察哈尔右翼后旗",
        "parent_id": 150900,
        "level": 3
    },
    {
        "id": 150929,
        "region_name": "四子王旗",
        "parent_id": 150900,
        "level": 3
    },
    {
        "id": 150981,
        "region_name": "丰镇市",
        "parent_id": 150900,
        "level": 3
    },
    {
        "id": 152200,
        "region_name": "兴安盟",
        "parent_id": 150000,
        "level": 2
    },
    {
        "id": 152201,
        "region_name": "乌兰浩特市",
        "parent_id": 152200,
        "level": 3
    },
    {
        "id": 152202,
        "region_name": "阿尔山市",
        "parent_id": 152200,
        "level": 3
    },
    {
        "id": 152221,
        "region_name": "科尔沁右翼前旗",
        "parent_id": 152200,
        "level": 3
    },
    {
        "id": 152222,
        "region_name": "科尔沁右翼中旗",
        "parent_id": 152200,
        "level": 3
    },
    {
        "id": 152223,
        "region_name": "扎赉特旗",
        "parent_id": 152200,
        "level": 3
    },
    {
        "id": 152224,
        "region_name": "突泉县",
        "parent_id": 152200,
        "level": 3
    },
    {
        "id": 152500,
        "region_name": "锡林郭勒盟",
        "parent_id": 150000,
        "level": 2
    },
    {
        "id": 152501,
        "region_name": "二连浩特市",
        "parent_id": 152500,
        "level": 3
    },
    {
        "id": 152502,
        "region_name": "锡林浩特市",
        "parent_id": 152500,
        "level": 3
    },
    {
        "id": 152522,
        "region_name": "阿巴嘎旗",
        "parent_id": 152500,
        "level": 3
    },
    {
        "id": 152523,
        "region_name": "苏尼特左旗",
        "parent_id": 152500,
        "level": 3
    },
    {
        "id": 152524,
        "region_name": "苏尼特右旗",
        "parent_id": 152500,
        "level": 3
    },
    {
        "id": 152525,
        "region_name": "东乌珠穆沁旗",
        "parent_id": 152500,
        "level": 3
    },
    {
        "id": 152526,
        "region_name": "西乌珠穆沁旗",
        "parent_id": 152500,
        "level": 3
    },
    {
        "id": 152527,
        "region_name": "太仆寺旗",
        "parent_id": 152500,
        "level": 3
    },
    {
        "id": 152528,
        "region_name": "镶黄旗",
        "parent_id": 152500,
        "level": 3
    },
    {
        "id": 152529,
        "region_name": "正镶白旗",
        "parent_id": 152500,
        "level": 3
    },
    {
        "id": 152530,
        "region_name": "正蓝旗",
        "parent_id": 152500,
        "level": 3
    },
    {
        "id": 152531,
        "region_name": "多伦县",
        "parent_id": 152500,
        "level": 3
    },
    {
        "id": 152900,
        "region_name": "阿拉善盟",
        "parent_id": 150000,
        "level": 2
    },
    {
        "id": 152921,
        "region_name": "阿拉善左旗",
        "parent_id": 152900,
        "level": 3
    },
    {
        "id": 152922,
        "region_name": "阿拉善右旗",
        "parent_id": 152900,
        "level": 3
    },
    {
        "id": 152923,
        "region_name": "额济纳旗",
        "parent_id": 152900,
        "level": 3
    },
    {
        "id": 210000,
        "region_name": "辽宁省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 210100,
        "region_name": "沈阳市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 210102,
        "region_name": "和平区",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210103,
        "region_name": "沈河区",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210104,
        "region_name": "大东区",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210105,
        "region_name": "皇姑区",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210106,
        "region_name": "铁西区",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210111,
        "region_name": "苏家屯区",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210112,
        "region_name": "浑南区",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210113,
        "region_name": "沈北新区",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210114,
        "region_name": "于洪区",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210115,
        "region_name": "辽中区",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210123,
        "region_name": "康平县",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210124,
        "region_name": "法库县",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210181,
        "region_name": "新民市",
        "parent_id": 210100,
        "level": 3
    },
    {
        "id": 210200,
        "region_name": "大连市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 210202,
        "region_name": "中山区",
        "parent_id": 210200,
        "level": 3
    },
    {
        "id": 210203,
        "region_name": "西岗区",
        "parent_id": 210200,
        "level": 3
    },
    {
        "id": 210204,
        "region_name": "沙河口区",
        "parent_id": 210200,
        "level": 3
    },
    {
        "id": 210211,
        "region_name": "甘井子区",
        "parent_id": 210200,
        "level": 3
    },
    {
        "id": 210212,
        "region_name": "旅顺口区",
        "parent_id": 210200,
        "level": 3
    },
    {
        "id": 210213,
        "region_name": "金州区",
        "parent_id": 210200,
        "level": 3
    },
    {
        "id": 210214,
        "region_name": "普兰店区",
        "parent_id": 210200,
        "level": 3
    },
    {
        "id": 210224,
        "region_name": "长海县",
        "parent_id": 210200,
        "level": 3
    },
    {
        "id": 210281,
        "region_name": "瓦房店市",
        "parent_id": 210200,
        "level": 3
    },
    {
        "id": 210283,
        "region_name": "庄河市",
        "parent_id": 210200,
        "level": 3
    },
    {
        "id": 210300,
        "region_name": "鞍山市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 210302,
        "region_name": "铁东区",
        "parent_id": 210300,
        "level": 3
    },
    {
        "id": 210303,
        "region_name": "铁西区",
        "parent_id": 210300,
        "level": 3
    },
    {
        "id": 210304,
        "region_name": "立山区",
        "parent_id": 210300,
        "level": 3
    },
    {
        "id": 210311,
        "region_name": "千山区",
        "parent_id": 210300,
        "level": 3
    },
    {
        "id": 210321,
        "region_name": "台安县",
        "parent_id": 210300,
        "level": 3
    },
    {
        "id": 210323,
        "region_name": "岫岩满族自治县",
        "parent_id": 210300,
        "level": 3
    },
    {
        "id": 210381,
        "region_name": "海城市",
        "parent_id": 210300,
        "level": 3
    },
    {
        "id": 210400,
        "region_name": "抚顺市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 210402,
        "region_name": "新抚区",
        "parent_id": 210400,
        "level": 3
    },
    {
        "id": 210403,
        "region_name": "东洲区",
        "parent_id": 210400,
        "level": 3
    },
    {
        "id": 210404,
        "region_name": "望花区",
        "parent_id": 210400,
        "level": 3
    },
    {
        "id": 210411,
        "region_name": "顺城区",
        "parent_id": 210400,
        "level": 3
    },
    {
        "id": 210421,
        "region_name": "抚顺县",
        "parent_id": 210400,
        "level": 3
    },
    {
        "id": 210422,
        "region_name": "新宾满族自治县",
        "parent_id": 210400,
        "level": 3
    },
    {
        "id": 210423,
        "region_name": "清原满族自治县",
        "parent_id": 210400,
        "level": 3
    },
    {
        "id": 210500,
        "region_name": "本溪市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 210502,
        "region_name": "平山区",
        "parent_id": 210500,
        "level": 3
    },
    {
        "id": 210503,
        "region_name": "溪湖区",
        "parent_id": 210500,
        "level": 3
    },
    {
        "id": 210504,
        "region_name": "明山区",
        "parent_id": 210500,
        "level": 3
    },
    {
        "id": 210505,
        "region_name": "南芬区",
        "parent_id": 210500,
        "level": 3
    },
    {
        "id": 210521,
        "region_name": "本溪满族自治县",
        "parent_id": 210500,
        "level": 3
    },
    {
        "id": 210522,
        "region_name": "桓仁满族自治县",
        "parent_id": 210500,
        "level": 3
    },
    {
        "id": 210600,
        "region_name": "丹东市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 210602,
        "region_name": "元宝区",
        "parent_id": 210600,
        "level": 3
    },
    {
        "id": 210603,
        "region_name": "振兴区",
        "parent_id": 210600,
        "level": 3
    },
    {
        "id": 210604,
        "region_name": "振安区",
        "parent_id": 210600,
        "level": 3
    },
    {
        "id": 210624,
        "region_name": "宽甸满族自治县",
        "parent_id": 210600,
        "level": 3
    },
    {
        "id": 210681,
        "region_name": "东港市",
        "parent_id": 210600,
        "level": 3
    },
    {
        "id": 210682,
        "region_name": "凤城市",
        "parent_id": 210600,
        "level": 3
    },
    {
        "id": 210700,
        "region_name": "锦州市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 210702,
        "region_name": "古塔区",
        "parent_id": 210700,
        "level": 3
    },
    {
        "id": 210703,
        "region_name": "凌河区",
        "parent_id": 210700,
        "level": 3
    },
    {
        "id": 210711,
        "region_name": "太和区",
        "parent_id": 210700,
        "level": 3
    },
    {
        "id": 210726,
        "region_name": "黑山县",
        "parent_id": 210700,
        "level": 3
    },
    {
        "id": 210727,
        "region_name": "义县",
        "parent_id": 210700,
        "level": 3
    },
    {
        "id": 210781,
        "region_name": "凌海市",
        "parent_id": 210700,
        "level": 3
    },
    {
        "id": 210782,
        "region_name": "北镇市",
        "parent_id": 210700,
        "level": 3
    },
    {
        "id": 210800,
        "region_name": "营口市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 210802,
        "region_name": "站前区",
        "parent_id": 210800,
        "level": 3
    },
    {
        "id": 210803,
        "region_name": "西市区",
        "parent_id": 210800,
        "level": 3
    },
    {
        "id": 210804,
        "region_name": "鲅鱼圈区",
        "parent_id": 210800,
        "level": 3
    },
    {
        "id": 210811,
        "region_name": "老边区",
        "parent_id": 210800,
        "level": 3
    },
    {
        "id": 210881,
        "region_name": "盖州市",
        "parent_id": 210800,
        "level": 3
    },
    {
        "id": 210882,
        "region_name": "大石桥市",
        "parent_id": 210800,
        "level": 3
    },
    {
        "id": 210900,
        "region_name": "阜新市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 210902,
        "region_name": "海州区",
        "parent_id": 210900,
        "level": 3
    },
    {
        "id": 210903,
        "region_name": "新邱区",
        "parent_id": 210900,
        "level": 3
    },
    {
        "id": 210904,
        "region_name": "太平区",
        "parent_id": 210900,
        "level": 3
    },
    {
        "id": 210905,
        "region_name": "清河门区",
        "parent_id": 210900,
        "level": 3
    },
    {
        "id": 210911,
        "region_name": "细河区",
        "parent_id": 210900,
        "level": 3
    },
    {
        "id": 210921,
        "region_name": "阜新蒙古族自治县",
        "parent_id": 210900,
        "level": 3
    },
    {
        "id": 210922,
        "region_name": "彰武县",
        "parent_id": 210900,
        "level": 3
    },
    {
        "id": 211000,
        "region_name": "辽阳市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 211002,
        "region_name": "白塔区",
        "parent_id": 211000,
        "level": 3
    },
    {
        "id": 211003,
        "region_name": "文圣区",
        "parent_id": 211000,
        "level": 3
    },
    {
        "id": 211004,
        "region_name": "宏伟区",
        "parent_id": 211000,
        "level": 3
    },
    {
        "id": 211005,
        "region_name": "弓长岭区",
        "parent_id": 211000,
        "level": 3
    },
    {
        "id": 211011,
        "region_name": "太子河区",
        "parent_id": 211000,
        "level": 3
    },
    {
        "id": 211021,
        "region_name": "辽阳县",
        "parent_id": 211000,
        "level": 3
    },
    {
        "id": 211081,
        "region_name": "灯塔市",
        "parent_id": 211000,
        "level": 3
    },
    {
        "id": 211100,
        "region_name": "盘锦市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 211102,
        "region_name": "双台子区",
        "parent_id": 211100,
        "level": 3
    },
    {
        "id": 211103,
        "region_name": "兴隆台区",
        "parent_id": 211100,
        "level": 3
    },
    {
        "id": 211104,
        "region_name": "大洼区",
        "parent_id": 211100,
        "level": 3
    },
    {
        "id": 211122,
        "region_name": "盘山县",
        "parent_id": 211100,
        "level": 3
    },
    {
        "id": 211200,
        "region_name": "铁岭市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 211202,
        "region_name": "银州区",
        "parent_id": 211200,
        "level": 3
    },
    {
        "id": 211204,
        "region_name": "清河区",
        "parent_id": 211200,
        "level": 3
    },
    {
        "id": 211221,
        "region_name": "铁岭县",
        "parent_id": 211200,
        "level": 3
    },
    {
        "id": 211223,
        "region_name": "西丰县",
        "parent_id": 211200,
        "level": 3
    },
    {
        "id": 211224,
        "region_name": "昌图县",
        "parent_id": 211200,
        "level": 3
    },
    {
        "id": 211281,
        "region_name": "调兵山市",
        "parent_id": 211200,
        "level": 3
    },
    {
        "id": 211282,
        "region_name": "开原市",
        "parent_id": 211200,
        "level": 3
    },
    {
        "id": 211300,
        "region_name": "朝阳市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 211302,
        "region_name": "双塔区",
        "parent_id": 211300,
        "level": 3
    },
    {
        "id": 211303,
        "region_name": "龙城区",
        "parent_id": 211300,
        "level": 3
    },
    {
        "id": 211321,
        "region_name": "朝阳县",
        "parent_id": 211300,
        "level": 3
    },
    {
        "id": 211322,
        "region_name": "建平县",
        "parent_id": 211300,
        "level": 3
    },
    {
        "id": 211324,
        "region_name": "喀喇沁左翼蒙古族自治县",
        "parent_id": 211300,
        "level": 3
    },
    {
        "id": 211381,
        "region_name": "北票市",
        "parent_id": 211300,
        "level": 3
    },
    {
        "id": 211382,
        "region_name": "凌源市",
        "parent_id": 211300,
        "level": 3
    },
    {
        "id": 211400,
        "region_name": "葫芦岛市",
        "parent_id": 210000,
        "level": 2
    },
    {
        "id": 211402,
        "region_name": "连山区",
        "parent_id": 211400,
        "level": 3
    },
    {
        "id": 211403,
        "region_name": "龙港区",
        "parent_id": 211400,
        "level": 3
    },
    {
        "id": 211404,
        "region_name": "南票区",
        "parent_id": 211400,
        "level": 3
    },
    {
        "id": 211421,
        "region_name": "绥中县",
        "parent_id": 211400,
        "level": 3
    },
    {
        "id": 211422,
        "region_name": "建昌县",
        "parent_id": 211400,
        "level": 3
    },
    {
        "id": 211481,
        "region_name": "兴城市",
        "parent_id": 211400,
        "level": 3
    },
    {
        "id": 220000,
        "region_name": "吉林省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 220100,
        "region_name": "长春市",
        "parent_id": 220000,
        "level": 2
    },
    {
        "id": 220102,
        "region_name": "南关区",
        "parent_id": 220100,
        "level": 3
    },
    {
        "id": 220103,
        "region_name": "宽城区",
        "parent_id": 220100,
        "level": 3
    },
    {
        "id": 220104,
        "region_name": "朝阳区",
        "parent_id": 220100,
        "level": 3
    },
    {
        "id": 220105,
        "region_name": "二道区",
        "parent_id": 220100,
        "level": 3
    },
    {
        "id": 220106,
        "region_name": "绿园区",
        "parent_id": 220100,
        "level": 3
    },
    {
        "id": 220112,
        "region_name": "双阳区",
        "parent_id": 220100,
        "level": 3
    },
    {
        "id": 220113,
        "region_name": "九台区",
        "parent_id": 220100,
        "level": 3
    },
    {
        "id": 220122,
        "region_name": "农安县",
        "parent_id": 220100,
        "level": 3
    },
    {
        "id": 220182,
        "region_name": "榆树市",
        "parent_id": 220100,
        "level": 3
    },
    {
        "id": 220183,
        "region_name": "德惠市",
        "parent_id": 220100,
        "level": 3
    },
    {
        "id": 220200,
        "region_name": "吉林市",
        "parent_id": 220000,
        "level": 2
    },
    {
        "id": 220202,
        "region_name": "昌邑区",
        "parent_id": 220200,
        "level": 3
    },
    {
        "id": 220203,
        "region_name": "龙潭区",
        "parent_id": 220200,
        "level": 3
    },
    {
        "id": 220204,
        "region_name": "船营区",
        "parent_id": 220200,
        "level": 3
    },
    {
        "id": 220211,
        "region_name": "丰满区",
        "parent_id": 220200,
        "level": 3
    },
    {
        "id": 220221,
        "region_name": "永吉县",
        "parent_id": 220200,
        "level": 3
    },
    {
        "id": 220281,
        "region_name": "蛟河市",
        "parent_id": 220200,
        "level": 3
    },
    {
        "id": 220282,
        "region_name": "桦甸市",
        "parent_id": 220200,
        "level": 3
    },
    {
        "id": 220283,
        "region_name": "舒兰市",
        "parent_id": 220200,
        "level": 3
    },
    {
        "id": 220284,
        "region_name": "磐石市",
        "parent_id": 220200,
        "level": 3
    },
    {
        "id": 220300,
        "region_name": "四平市",
        "parent_id": 220000,
        "level": 2
    },
    {
        "id": 220302,
        "region_name": "铁西区",
        "parent_id": 220300,
        "level": 3
    },
    {
        "id": 220303,
        "region_name": "铁东区",
        "parent_id": 220300,
        "level": 3
    },
    {
        "id": 220322,
        "region_name": "梨树县",
        "parent_id": 220300,
        "level": 3
    },
    {
        "id": 220323,
        "region_name": "伊通满族自治县",
        "parent_id": 220300,
        "level": 3
    },
    {
        "id": 220381,
        "region_name": "公主岭市",
        "parent_id": 220300,
        "level": 3
    },
    {
        "id": 220382,
        "region_name": "双辽市",
        "parent_id": 220300,
        "level": 3
    },
    {
        "id": 220400,
        "region_name": "辽源市",
        "parent_id": 220000,
        "level": 2
    },
    {
        "id": 220402,
        "region_name": "龙山区",
        "parent_id": 220400,
        "level": 3
    },
    {
        "id": 220403,
        "region_name": "西安区",
        "parent_id": 220400,
        "level": 3
    },
    {
        "id": 220421,
        "region_name": "东丰县",
        "parent_id": 220400,
        "level": 3
    },
    {
        "id": 220422,
        "region_name": "东辽县",
        "parent_id": 220400,
        "level": 3
    },
    {
        "id": 220500,
        "region_name": "通化市",
        "parent_id": 220000,
        "level": 2
    },
    {
        "id": 220502,
        "region_name": "东昌区",
        "parent_id": 220500,
        "level": 3
    },
    {
        "id": 220503,
        "region_name": "二道江区",
        "parent_id": 220500,
        "level": 3
    },
    {
        "id": 220521,
        "region_name": "通化县",
        "parent_id": 220500,
        "level": 3
    },
    {
        "id": 220523,
        "region_name": "辉南县",
        "parent_id": 220500,
        "level": 3
    },
    {
        "id": 220524,
        "region_name": "柳河县",
        "parent_id": 220500,
        "level": 3
    },
    {
        "id": 220581,
        "region_name": "梅河口市",
        "parent_id": 220500,
        "level": 3
    },
    {
        "id": 220582,
        "region_name": "集安市",
        "parent_id": 220500,
        "level": 3
    },
    {
        "id": 220600,
        "region_name": "白山市",
        "parent_id": 220000,
        "level": 2
    },
    {
        "id": 220602,
        "region_name": "浑江区",
        "parent_id": 220600,
        "level": 3
    },
    {
        "id": 220605,
        "region_name": "江源区",
        "parent_id": 220600,
        "level": 3
    },
    {
        "id": 220621,
        "region_name": "抚松县",
        "parent_id": 220600,
        "level": 3
    },
    {
        "id": 220622,
        "region_name": "靖宇县",
        "parent_id": 220600,
        "level": 3
    },
    {
        "id": 220623,
        "region_name": "长白朝鲜族自治县",
        "parent_id": 220600,
        "level": 3
    },
    {
        "id": 220681,
        "region_name": "临江市",
        "parent_id": 220600,
        "level": 3
    },
    {
        "id": 220700,
        "region_name": "松原市",
        "parent_id": 220000,
        "level": 2
    },
    {
        "id": 220702,
        "region_name": "宁江区",
        "parent_id": 220700,
        "level": 3
    },
    {
        "id": 220721,
        "region_name": "前郭尔罗斯蒙古族自治县",
        "parent_id": 220700,
        "level": 3
    },
    {
        "id": 220722,
        "region_name": "长岭县",
        "parent_id": 220700,
        "level": 3
    },
    {
        "id": 220723,
        "region_name": "乾安县",
        "parent_id": 220700,
        "level": 3
    },
    {
        "id": 220781,
        "region_name": "扶余市",
        "parent_id": 220700,
        "level": 3
    },
    {
        "id": 220800,
        "region_name": "白城市",
        "parent_id": 220000,
        "level": 2
    },
    {
        "id": 220802,
        "region_name": "洮北区",
        "parent_id": 220800,
        "level": 3
    },
    {
        "id": 220821,
        "region_name": "镇赉县",
        "parent_id": 220800,
        "level": 3
    },
    {
        "id": 220822,
        "region_name": "通榆县",
        "parent_id": 220800,
        "level": 3
    },
    {
        "id": 220881,
        "region_name": "洮南市",
        "parent_id": 220800,
        "level": 3
    },
    {
        "id": 220882,
        "region_name": "大安市",
        "parent_id": 220800,
        "level": 3
    },
    {
        "id": 222400,
        "region_name": "延边朝鲜族自治州",
        "parent_id": 220000,
        "level": 2
    },
    {
        "id": 222401,
        "region_name": "延吉市",
        "parent_id": 222400,
        "level": 3
    },
    {
        "id": 222402,
        "region_name": "图们市",
        "parent_id": 222400,
        "level": 3
    },
    {
        "id": 222403,
        "region_name": "敦化市",
        "parent_id": 222400,
        "level": 3
    },
    {
        "id": 222404,
        "region_name": "珲春市",
        "parent_id": 222400,
        "level": 3
    },
    {
        "id": 222405,
        "region_name": "龙井市",
        "parent_id": 222400,
        "level": 3
    },
    {
        "id": 222406,
        "region_name": "和龙市",
        "parent_id": 222400,
        "level": 3
    },
    {
        "id": 222424,
        "region_name": "汪清县",
        "parent_id": 222400,
        "level": 3
    },
    {
        "id": 222426,
        "region_name": "安图县",
        "parent_id": 222400,
        "level": 3
    },
    {
        "id": 230000,
        "region_name": "黑龙江省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 230100,
        "region_name": "哈尔滨市",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 230102,
        "region_name": "道里区",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230103,
        "region_name": "南岗区",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230104,
        "region_name": "道外区",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230108,
        "region_name": "平房区",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230109,
        "region_name": "松北区",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230110,
        "region_name": "香坊区",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230111,
        "region_name": "呼兰区",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230112,
        "region_name": "阿城区",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230113,
        "region_name": "双城区",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230123,
        "region_name": "依兰县",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230124,
        "region_name": "方正县",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230125,
        "region_name": "宾县",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230126,
        "region_name": "巴彦县",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230127,
        "region_name": "木兰县",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230128,
        "region_name": "通河县",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230129,
        "region_name": "延寿县",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230183,
        "region_name": "尚志市",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230184,
        "region_name": "五常市",
        "parent_id": 230100,
        "level": 3
    },
    {
        "id": 230200,
        "region_name": "齐齐哈尔市",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 230202,
        "region_name": "龙沙区",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230203,
        "region_name": "建华区",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230204,
        "region_name": "铁锋区",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230205,
        "region_name": "昂昂溪区",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230206,
        "region_name": "富拉尔基区",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230207,
        "region_name": "碾子山区",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230208,
        "region_name": "梅里斯达斡尔族区",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230221,
        "region_name": "龙江县",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230223,
        "region_name": "依安县",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230224,
        "region_name": "泰来县",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230225,
        "region_name": "甘南县",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230227,
        "region_name": "富裕县",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230229,
        "region_name": "克山县",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230230,
        "region_name": "克东县",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230231,
        "region_name": "拜泉县",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230281,
        "region_name": "讷河市",
        "parent_id": 230200,
        "level": 3
    },
    {
        "id": 230300,
        "region_name": "鸡西市",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 230302,
        "region_name": "鸡冠区",
        "parent_id": 230300,
        "level": 3
    },
    {
        "id": 230303,
        "region_name": "恒山区",
        "parent_id": 230300,
        "level": 3
    },
    {
        "id": 230304,
        "region_name": "滴道区",
        "parent_id": 230300,
        "level": 3
    },
    {
        "id": 230305,
        "region_name": "梨树区",
        "parent_id": 230300,
        "level": 3
    },
    {
        "id": 230306,
        "region_name": "城子河区",
        "parent_id": 230300,
        "level": 3
    },
    {
        "id": 230307,
        "region_name": "麻山区",
        "parent_id": 230300,
        "level": 3
    },
    {
        "id": 230321,
        "region_name": "鸡东县",
        "parent_id": 230300,
        "level": 3
    },
    {
        "id": 230381,
        "region_name": "虎林市",
        "parent_id": 230300,
        "level": 3
    },
    {
        "id": 230382,
        "region_name": "密山市",
        "parent_id": 230300,
        "level": 3
    },
    {
        "id": 230400,
        "region_name": "鹤岗市",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 230402,
        "region_name": "向阳区",
        "parent_id": 230400,
        "level": 3
    },
    {
        "id": 230403,
        "region_name": "工农区",
        "parent_id": 230400,
        "level": 3
    },
    {
        "id": 230404,
        "region_name": "南山区",
        "parent_id": 230400,
        "level": 3
    },
    {
        "id": 230405,
        "region_name": "兴安区",
        "parent_id": 230400,
        "level": 3
    },
    {
        "id": 230406,
        "region_name": "东山区",
        "parent_id": 230400,
        "level": 3
    },
    {
        "id": 230407,
        "region_name": "兴山区",
        "parent_id": 230400,
        "level": 3
    },
    {
        "id": 230421,
        "region_name": "萝北县",
        "parent_id": 230400,
        "level": 3
    },
    {
        "id": 230422,
        "region_name": "绥滨县",
        "parent_id": 230400,
        "level": 3
    },
    {
        "id": 230500,
        "region_name": "双鸭山市",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 230502,
        "region_name": "尖山区",
        "parent_id": 230500,
        "level": 3
    },
    {
        "id": 230503,
        "region_name": "岭东区",
        "parent_id": 230500,
        "level": 3
    },
    {
        "id": 230505,
        "region_name": "四方台区",
        "parent_id": 230500,
        "level": 3
    },
    {
        "id": 230506,
        "region_name": "宝山区",
        "parent_id": 230500,
        "level": 3
    },
    {
        "id": 230521,
        "region_name": "集贤县",
        "parent_id": 230500,
        "level": 3
    },
    {
        "id": 230522,
        "region_name": "友谊县",
        "parent_id": 230500,
        "level": 3
    },
    {
        "id": 230523,
        "region_name": "宝清县",
        "parent_id": 230500,
        "level": 3
    },
    {
        "id": 230524,
        "region_name": "饶河县",
        "parent_id": 230500,
        "level": 3
    },
    {
        "id": 230600,
        "region_name": "大庆市",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 230602,
        "region_name": "萨尔图区",
        "parent_id": 230600,
        "level": 3
    },
    {
        "id": 230603,
        "region_name": "龙凤区",
        "parent_id": 230600,
        "level": 3
    },
    {
        "id": 230604,
        "region_name": "让胡路区",
        "parent_id": 230600,
        "level": 3
    },
    {
        "id": 230605,
        "region_name": "红岗区",
        "parent_id": 230600,
        "level": 3
    },
    {
        "id": 230606,
        "region_name": "大同区",
        "parent_id": 230600,
        "level": 3
    },
    {
        "id": 230621,
        "region_name": "肇州县",
        "parent_id": 230600,
        "level": 3
    },
    {
        "id": 230622,
        "region_name": "肇源县",
        "parent_id": 230600,
        "level": 3
    },
    {
        "id": 230623,
        "region_name": "林甸县",
        "parent_id": 230600,
        "level": 3
    },
    {
        "id": 230624,
        "region_name": "杜尔伯特蒙古族自治县",
        "parent_id": 230600,
        "level": 3
    },
    {
        "id": 230700,
        "region_name": "伊春市",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 230702,
        "region_name": "伊春区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230703,
        "region_name": "南岔区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230704,
        "region_name": "友好区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230705,
        "region_name": "西林区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230706,
        "region_name": "翠峦区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230707,
        "region_name": "新青区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230708,
        "region_name": "美溪区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230709,
        "region_name": "金山屯区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230710,
        "region_name": "五营区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230711,
        "region_name": "乌马河区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230712,
        "region_name": "汤旺河区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230713,
        "region_name": "带岭区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230714,
        "region_name": "乌伊岭区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230715,
        "region_name": "红星区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230716,
        "region_name": "上甘岭区",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230722,
        "region_name": "嘉荫县",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230781,
        "region_name": "铁力市",
        "parent_id": 230700,
        "level": 3
    },
    {
        "id": 230800,
        "region_name": "佳木斯市",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 230803,
        "region_name": "向阳区",
        "parent_id": 230800,
        "level": 3
    },
    {
        "id": 230804,
        "region_name": "前进区",
        "parent_id": 230800,
        "level": 3
    },
    {
        "id": 230805,
        "region_name": "东风区",
        "parent_id": 230800,
        "level": 3
    },
    {
        "id": 230811,
        "region_name": "郊区",
        "parent_id": 230800,
        "level": 3
    },
    {
        "id": 230822,
        "region_name": "桦南县",
        "parent_id": 230800,
        "level": 3
    },
    {
        "id": 230826,
        "region_name": "桦川县",
        "parent_id": 230800,
        "level": 3
    },
    {
        "id": 230828,
        "region_name": "汤原县",
        "parent_id": 230800,
        "level": 3
    },
    {
        "id": 230881,
        "region_name": "同江市",
        "parent_id": 230800,
        "level": 3
    },
    {
        "id": 230882,
        "region_name": "富锦市",
        "parent_id": 230800,
        "level": 3
    },
    {
        "id": 230883,
        "region_name": "抚远市",
        "parent_id": 230800,
        "level": 3
    },
    {
        "id": 230900,
        "region_name": "七台河市",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 230902,
        "region_name": "新兴区",
        "parent_id": 230900,
        "level": 3
    },
    {
        "id": 230903,
        "region_name": "桃山区",
        "parent_id": 230900,
        "level": 3
    },
    {
        "id": 230904,
        "region_name": "茄子河区",
        "parent_id": 230900,
        "level": 3
    },
    {
        "id": 230921,
        "region_name": "勃利县",
        "parent_id": 230900,
        "level": 3
    },
    {
        "id": 231000,
        "region_name": "牡丹江市",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 231002,
        "region_name": "东安区",
        "parent_id": 231000,
        "level": 3
    },
    {
        "id": 231003,
        "region_name": "阳明区",
        "parent_id": 231000,
        "level": 3
    },
    {
        "id": 231004,
        "region_name": "爱民区",
        "parent_id": 231000,
        "level": 3
    },
    {
        "id": 231005,
        "region_name": "西安区",
        "parent_id": 231000,
        "level": 3
    },
    {
        "id": 231025,
        "region_name": "林口县",
        "parent_id": 231000,
        "level": 3
    },
    {
        "id": 231081,
        "region_name": "绥芬河市",
        "parent_id": 231000,
        "level": 3
    },
    {
        "id": 231083,
        "region_name": "海林市",
        "parent_id": 231000,
        "level": 3
    },
    {
        "id": 231084,
        "region_name": "宁安市",
        "parent_id": 231000,
        "level": 3
    },
    {
        "id": 231085,
        "region_name": "穆棱市",
        "parent_id": 231000,
        "level": 3
    },
    {
        "id": 231086,
        "region_name": "东宁市",
        "parent_id": 231000,
        "level": 3
    },
    {
        "id": 231100,
        "region_name": "黑河市",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 231102,
        "region_name": "爱辉区",
        "parent_id": 231100,
        "level": 3
    },
    {
        "id": 231121,
        "region_name": "嫩江县",
        "parent_id": 231100,
        "level": 3
    },
    {
        "id": 231123,
        "region_name": "逊克县",
        "parent_id": 231100,
        "level": 3
    },
    {
        "id": 231124,
        "region_name": "孙吴县",
        "parent_id": 231100,
        "level": 3
    },
    {
        "id": 231181,
        "region_name": "北安市",
        "parent_id": 231100,
        "level": 3
    },
    {
        "id": 231182,
        "region_name": "五大连池市",
        "parent_id": 231100,
        "level": 3
    },
    {
        "id": 231200,
        "region_name": "绥化市",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 231202,
        "region_name": "北林区",
        "parent_id": 231200,
        "level": 3
    },
    {
        "id": 231221,
        "region_name": "望奎县",
        "parent_id": 231200,
        "level": 3
    },
    {
        "id": 231222,
        "region_name": "兰西县",
        "parent_id": 231200,
        "level": 3
    },
    {
        "id": 231223,
        "region_name": "青冈县",
        "parent_id": 231200,
        "level": 3
    },
    {
        "id": 231224,
        "region_name": "庆安县",
        "parent_id": 231200,
        "level": 3
    },
    {
        "id": 231225,
        "region_name": "明水县",
        "parent_id": 231200,
        "level": 3
    },
    {
        "id": 231226,
        "region_name": "绥棱县",
        "parent_id": 231200,
        "level": 3
    },
    {
        "id": 231281,
        "region_name": "安达市",
        "parent_id": 231200,
        "level": 3
    },
    {
        "id": 231282,
        "region_name": "肇东市",
        "parent_id": 231200,
        "level": 3
    },
    {
        "id": 231283,
        "region_name": "海伦市",
        "parent_id": 231200,
        "level": 3
    },
    {
        "id": 232700,
        "region_name": "大兴安岭地区",
        "parent_id": 230000,
        "level": 2
    },
    {
        "id": 232721,
        "region_name": "呼玛县",
        "parent_id": 232700,
        "level": 3
    },
    {
        "id": 232722,
        "region_name": "塔河县",
        "parent_id": 232700,
        "level": 3
    },
    {
        "id": 232723,
        "region_name": "漠河县",
        "parent_id": 232700,
        "level": 3
    },
    {
        "id": 310000,
        "region_name": "上海市",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 310100,
        "region_name": "上海市",
        "parent_id": 310000,
        "level": 2
    },
    {
        "id": 310101,
        "region_name": "黄浦区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310104,
        "region_name": "徐汇区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310105,
        "region_name": "长宁区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310106,
        "region_name": "静安区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310107,
        "region_name": "普陀区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310109,
        "region_name": "虹口区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310110,
        "region_name": "杨浦区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310112,
        "region_name": "闵行区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310113,
        "region_name": "宝山区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310114,
        "region_name": "嘉定区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310115,
        "region_name": "浦东新区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310116,
        "region_name": "金山区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310117,
        "region_name": "松江区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310118,
        "region_name": "青浦区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310120,
        "region_name": "奉贤区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 310151,
        "region_name": "崇明区",
        "parent_id": 310100,
        "level": 3
    },
    {
        "id": 320000,
        "region_name": "江苏省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 320100,
        "region_name": "南京市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 320102,
        "region_name": "玄武区",
        "parent_id": 320100,
        "level": 3
    },
    {
        "id": 320104,
        "region_name": "秦淮区",
        "parent_id": 320100,
        "level": 3
    },
    {
        "id": 320105,
        "region_name": "建邺区",
        "parent_id": 320100,
        "level": 3
    },
    {
        "id": 320106,
        "region_name": "鼓楼区",
        "parent_id": 320100,
        "level": 3
    },
    {
        "id": 320111,
        "region_name": "浦口区",
        "parent_id": 320100,
        "level": 3
    },
    {
        "id": 320113,
        "region_name": "栖霞区",
        "parent_id": 320100,
        "level": 3
    },
    {
        "id": 320114,
        "region_name": "雨花台区",
        "parent_id": 320100,
        "level": 3
    },
    {
        "id": 320115,
        "region_name": "江宁区",
        "parent_id": 320100,
        "level": 3
    },
    {
        "id": 320116,
        "region_name": "六合区",
        "parent_id": 320100,
        "level": 3
    },
    {
        "id": 320117,
        "region_name": "溧水区",
        "parent_id": 320100,
        "level": 3
    },
    {
        "id": 320118,
        "region_name": "高淳区",
        "parent_id": 320100,
        "level": 3
    },
    {
        "id": 320200,
        "region_name": "无锡市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 320205,
        "region_name": "锡山区",
        "parent_id": 320200,
        "level": 3
    },
    {
        "id": 320206,
        "region_name": "惠山区",
        "parent_id": 320200,
        "level": 3
    },
    {
        "id": 320211,
        "region_name": "滨湖区",
        "parent_id": 320200,
        "level": 3
    },
    {
        "id": 320213,
        "region_name": "梁溪区",
        "parent_id": 320200,
        "level": 3
    },
    {
        "id": 320214,
        "region_name": "新吴区",
        "parent_id": 320200,
        "level": 3
    },
    {
        "id": 320281,
        "region_name": "江阴市",
        "parent_id": 320200,
        "level": 3
    },
    {
        "id": 320282,
        "region_name": "宜兴市",
        "parent_id": 320200,
        "level": 3
    },
    {
        "id": 320300,
        "region_name": "徐州市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 320302,
        "region_name": "鼓楼区",
        "parent_id": 320300,
        "level": 3
    },
    {
        "id": 320303,
        "region_name": "云龙区",
        "parent_id": 320300,
        "level": 3
    },
    {
        "id": 320305,
        "region_name": "贾汪区",
        "parent_id": 320300,
        "level": 3
    },
    {
        "id": 320311,
        "region_name": "泉山区",
        "parent_id": 320300,
        "level": 3
    },
    {
        "id": 320312,
        "region_name": "铜山区",
        "parent_id": 320300,
        "level": 3
    },
    {
        "id": 320321,
        "region_name": "丰县",
        "parent_id": 320300,
        "level": 3
    },
    {
        "id": 320322,
        "region_name": "沛县",
        "parent_id": 320300,
        "level": 3
    },
    {
        "id": 320324,
        "region_name": "睢宁县",
        "parent_id": 320300,
        "level": 3
    },
    {
        "id": 320381,
        "region_name": "新沂市",
        "parent_id": 320300,
        "level": 3
    },
    {
        "id": 320382,
        "region_name": "邳州市",
        "parent_id": 320300,
        "level": 3
    },
    {
        "id": 320400,
        "region_name": "常州市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 320402,
        "region_name": "天宁区",
        "parent_id": 320400,
        "level": 3
    },
    {
        "id": 320404,
        "region_name": "钟楼区",
        "parent_id": 320400,
        "level": 3
    },
    {
        "id": 320411,
        "region_name": "新北区",
        "parent_id": 320400,
        "level": 3
    },
    {
        "id": 320412,
        "region_name": "武进区",
        "parent_id": 320400,
        "level": 3
    },
    {
        "id": 320413,
        "region_name": "金坛区",
        "parent_id": 320400,
        "level": 3
    },
    {
        "id": 320481,
        "region_name": "溧阳市",
        "parent_id": 320400,
        "level": 3
    },
    {
        "id": 320500,
        "region_name": "苏州市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 320505,
        "region_name": "虎丘区",
        "parent_id": 320500,
        "level": 3
    },
    {
        "id": 320506,
        "region_name": "吴中区",
        "parent_id": 320500,
        "level": 3
    },
    {
        "id": 320507,
        "region_name": "相城区",
        "parent_id": 320500,
        "level": 3
    },
    {
        "id": 320508,
        "region_name": "姑苏区",
        "parent_id": 320500,
        "level": 3
    },
    {
        "id": 320509,
        "region_name": "吴江区",
        "parent_id": 320500,
        "level": 3
    },
    {
        "id": 320581,
        "region_name": "常熟市",
        "parent_id": 320500,
        "level": 3
    },
    {
        "id": 320582,
        "region_name": "张家港市",
        "parent_id": 320500,
        "level": 3
    },
    {
        "id": 320583,
        "region_name": "昆山市",
        "parent_id": 320500,
        "level": 3
    },
    {
        "id": 320585,
        "region_name": "太仓市",
        "parent_id": 320500,
        "level": 3
    },
    {
        "id": 320600,
        "region_name": "南通市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 320602,
        "region_name": "崇川区",
        "parent_id": 320600,
        "level": 3
    },
    {
        "id": 320611,
        "region_name": "港闸区",
        "parent_id": 320600,
        "level": 3
    },
    {
        "id": 320612,
        "region_name": "通州区",
        "parent_id": 320600,
        "level": 3
    },
    {
        "id": 320623,
        "region_name": "如东县",
        "parent_id": 320600,
        "level": 3
    },
    {
        "id": 320681,
        "region_name": "启东市",
        "parent_id": 320600,
        "level": 3
    },
    {
        "id": 320682,
        "region_name": "如皋市",
        "parent_id": 320600,
        "level": 3
    },
    {
        "id": 320684,
        "region_name": "海门市",
        "parent_id": 320600,
        "level": 3
    },
    {
        "id": 320685,
        "region_name": "海安市",
        "parent_id": 320600,
        "level": 3
    },
    {
        "id": 320700,
        "region_name": "连云港市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 320703,
        "region_name": "连云区",
        "parent_id": 320700,
        "level": 3
    },
    {
        "id": 320706,
        "region_name": "海州区",
        "parent_id": 320700,
        "level": 3
    },
    {
        "id": 320707,
        "region_name": "赣榆区",
        "parent_id": 320700,
        "level": 3
    },
    {
        "id": 320722,
        "region_name": "东海县",
        "parent_id": 320700,
        "level": 3
    },
    {
        "id": 320723,
        "region_name": "灌云县",
        "parent_id": 320700,
        "level": 3
    },
    {
        "id": 320724,
        "region_name": "灌南县",
        "parent_id": 320700,
        "level": 3
    },
    {
        "id": 320800,
        "region_name": "淮安市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 320803,
        "region_name": "淮安区",
        "parent_id": 320800,
        "level": 3
    },
    {
        "id": 320804,
        "region_name": "淮阴区",
        "parent_id": 320800,
        "level": 3
    },
    {
        "id": 320812,
        "region_name": "清江浦区",
        "parent_id": 320800,
        "level": 3
    },
    {
        "id": 320813,
        "region_name": "洪泽区",
        "parent_id": 320800,
        "level": 3
    },
    {
        "id": 320826,
        "region_name": "涟水县",
        "parent_id": 320800,
        "level": 3
    },
    {
        "id": 320830,
        "region_name": "盱眙县",
        "parent_id": 320800,
        "level": 3
    },
    {
        "id": 320831,
        "region_name": "金湖县",
        "parent_id": 320800,
        "level": 3
    },
    {
        "id": 320900,
        "region_name": "盐城市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 320902,
        "region_name": "亭湖区",
        "parent_id": 320900,
        "level": 3
    },
    {
        "id": 320903,
        "region_name": "盐都区",
        "parent_id": 320900,
        "level": 3
    },
    {
        "id": 320904,
        "region_name": "大丰区",
        "parent_id": 320900,
        "level": 3
    },
    {
        "id": 320921,
        "region_name": "响水县",
        "parent_id": 320900,
        "level": 3
    },
    {
        "id": 320922,
        "region_name": "滨海县",
        "parent_id": 320900,
        "level": 3
    },
    {
        "id": 320923,
        "region_name": "阜宁县",
        "parent_id": 320900,
        "level": 3
    },
    {
        "id": 320924,
        "region_name": "射阳县",
        "parent_id": 320900,
        "level": 3
    },
    {
        "id": 320925,
        "region_name": "建湖县",
        "parent_id": 320900,
        "level": 3
    },
    {
        "id": 320981,
        "region_name": "东台市",
        "parent_id": 320900,
        "level": 3
    },
    {
        "id": 321000,
        "region_name": "扬州市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 321002,
        "region_name": "广陵区",
        "parent_id": 321000,
        "level": 3
    },
    {
        "id": 321003,
        "region_name": "邗江区",
        "parent_id": 321000,
        "level": 3
    },
    {
        "id": 321012,
        "region_name": "江都区",
        "parent_id": 321000,
        "level": 3
    },
    {
        "id": 321023,
        "region_name": "宝应县",
        "parent_id": 321000,
        "level": 3
    },
    {
        "id": 321081,
        "region_name": "仪征市",
        "parent_id": 321000,
        "level": 3
    },
    {
        "id": 321084,
        "region_name": "高邮市",
        "parent_id": 321000,
        "level": 3
    },
    {
        "id": 321100,
        "region_name": "镇江市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 321102,
        "region_name": "京口区",
        "parent_id": 321100,
        "level": 3
    },
    {
        "id": 321111,
        "region_name": "润州区",
        "parent_id": 321100,
        "level": 3
    },
    {
        "id": 321112,
        "region_name": "丹徒区",
        "parent_id": 321100,
        "level": 3
    },
    {
        "id": 321181,
        "region_name": "丹阳市",
        "parent_id": 321100,
        "level": 3
    },
    {
        "id": 321182,
        "region_name": "扬中市",
        "parent_id": 321100,
        "level": 3
    },
    {
        "id": 321183,
        "region_name": "句容市",
        "parent_id": 321100,
        "level": 3
    },
    {
        "id": 321200,
        "region_name": "泰州市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 321202,
        "region_name": "海陵区",
        "parent_id": 321200,
        "level": 3
    },
    {
        "id": 321203,
        "region_name": "高港区",
        "parent_id": 321200,
        "level": 3
    },
    {
        "id": 321204,
        "region_name": "姜堰区",
        "parent_id": 321200,
        "level": 3
    },
    {
        "id": 321281,
        "region_name": "兴化市",
        "parent_id": 321200,
        "level": 3
    },
    {
        "id": 321282,
        "region_name": "靖江市",
        "parent_id": 321200,
        "level": 3
    },
    {
        "id": 321283,
        "region_name": "泰兴市",
        "parent_id": 321200,
        "level": 3
    },
    {
        "id": 321300,
        "region_name": "宿迁市",
        "parent_id": 320000,
        "level": 2
    },
    {
        "id": 321302,
        "region_name": "宿城区",
        "parent_id": 321300,
        "level": 3
    },
    {
        "id": 321311,
        "region_name": "宿豫区",
        "parent_id": 321300,
        "level": 3
    },
    {
        "id": 321322,
        "region_name": "沭阳县",
        "parent_id": 321300,
        "level": 3
    },
    {
        "id": 321323,
        "region_name": "泗阳县",
        "parent_id": 321300,
        "level": 3
    },
    {
        "id": 321324,
        "region_name": "泗洪县",
        "parent_id": 321300,
        "level": 3
    },
    {
        "id": 330000,
        "region_name": "浙江省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 330100,
        "region_name": "杭州市",
        "parent_id": 330000,
        "level": 2
    },
    {
        "id": 330102,
        "region_name": "上城区",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330103,
        "region_name": "下城区",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330104,
        "region_name": "江干区",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330105,
        "region_name": "拱墅区",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330106,
        "region_name": "西湖区",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330108,
        "region_name": "滨江区",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330109,
        "region_name": "萧山区",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330110,
        "region_name": "余杭区",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330111,
        "region_name": "富阳区",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330112,
        "region_name": "临安区",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330122,
        "region_name": "桐庐县",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330127,
        "region_name": "淳安县",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330182,
        "region_name": "建德市",
        "parent_id": 330100,
        "level": 3
    },
    {
        "id": 330200,
        "region_name": "宁波市",
        "parent_id": 330000,
        "level": 2
    },
    {
        "id": 330203,
        "region_name": "海曙区",
        "parent_id": 330200,
        "level": 3
    },
    {
        "id": 330205,
        "region_name": "江北区",
        "parent_id": 330200,
        "level": 3
    },
    {
        "id": 330206,
        "region_name": "北仑区",
        "parent_id": 330200,
        "level": 3
    },
    {
        "id": 330211,
        "region_name": "镇海区",
        "parent_id": 330200,
        "level": 3
    },
    {
        "id": 330212,
        "region_name": "鄞州区",
        "parent_id": 330200,
        "level": 3
    },
    {
        "id": 330213,
        "region_name": "奉化区",
        "parent_id": 330200,
        "level": 3
    },
    {
        "id": 330225,
        "region_name": "象山县",
        "parent_id": 330200,
        "level": 3
    },
    {
        "id": 330226,
        "region_name": "宁海县",
        "parent_id": 330200,
        "level": 3
    },
    {
        "id": 330281,
        "region_name": "余姚市",
        "parent_id": 330200,
        "level": 3
    },
    {
        "id": 330282,
        "region_name": "慈溪市",
        "parent_id": 330200,
        "level": 3
    },
    {
        "id": 330300,
        "region_name": "温州市",
        "parent_id": 330000,
        "level": 2
    },
    {
        "id": 330302,
        "region_name": "鹿城区",
        "parent_id": 330300,
        "level": 3
    },
    {
        "id": 330303,
        "region_name": "龙湾区",
        "parent_id": 330300,
        "level": 3
    },
    {
        "id": 330304,
        "region_name": "瓯海区",
        "parent_id": 330300,
        "level": 3
    },
    {
        "id": 330305,
        "region_name": "洞头区",
        "parent_id": 330300,
        "level": 3
    },
    {
        "id": 330324,
        "region_name": "永嘉县",
        "parent_id": 330300,
        "level": 3
    },
    {
        "id": 330326,
        "region_name": "平阳县",
        "parent_id": 330300,
        "level": 3
    },
    {
        "id": 330327,
        "region_name": "苍南县",
        "parent_id": 330300,
        "level": 3
    },
    {
        "id": 330328,
        "region_name": "文成县",
        "parent_id": 330300,
        "level": 3
    },
    {
        "id": 330329,
        "region_name": "泰顺县",
        "parent_id": 330300,
        "level": 3
    },
    {
        "id": 330381,
        "region_name": "瑞安市",
        "parent_id": 330300,
        "level": 3
    },
    {
        "id": 330382,
        "region_name": "乐清市",
        "parent_id": 330300,
        "level": 3
    },
    {
        "id": 330400,
        "region_name": "嘉兴市",
        "parent_id": 330000,
        "level": 2
    },
    {
        "id": 330402,
        "region_name": "南湖区",
        "parent_id": 330400,
        "level": 3
    },
    {
        "id": 330411,
        "region_name": "秀洲区",
        "parent_id": 330400,
        "level": 3
    },
    {
        "id": 330421,
        "region_name": "嘉善县",
        "parent_id": 330400,
        "level": 3
    },
    {
        "id": 330424,
        "region_name": "海盐县",
        "parent_id": 330400,
        "level": 3
    },
    {
        "id": 330481,
        "region_name": "海宁市",
        "parent_id": 330400,
        "level": 3
    },
    {
        "id": 330482,
        "region_name": "平湖市",
        "parent_id": 330400,
        "level": 3
    },
    {
        "id": 330483,
        "region_name": "桐乡市",
        "parent_id": 330400,
        "level": 3
    },
    {
        "id": 330500,
        "region_name": "湖州市",
        "parent_id": 330000,
        "level": 2
    },
    {
        "id": 330502,
        "region_name": "吴兴区",
        "parent_id": 330500,
        "level": 3
    },
    {
        "id": 330503,
        "region_name": "南浔区",
        "parent_id": 330500,
        "level": 3
    },
    {
        "id": 330521,
        "region_name": "德清县",
        "parent_id": 330500,
        "level": 3
    },
    {
        "id": 330522,
        "region_name": "长兴县",
        "parent_id": 330500,
        "level": 3
    },
    {
        "id": 330523,
        "region_name": "安吉县",
        "parent_id": 330500,
        "level": 3
    },
    {
        "id": 330600,
        "region_name": "绍兴市",
        "parent_id": 330000,
        "level": 2
    },
    {
        "id": 330602,
        "region_name": "越城区",
        "parent_id": 330600,
        "level": 3
    },
    {
        "id": 330603,
        "region_name": "柯桥区",
        "parent_id": 330600,
        "level": 3
    },
    {
        "id": 330604,
        "region_name": "上虞区",
        "parent_id": 330600,
        "level": 3
    },
    {
        "id": 330624,
        "region_name": "新昌县",
        "parent_id": 330600,
        "level": 3
    },
    {
        "id": 330681,
        "region_name": "诸暨市",
        "parent_id": 330600,
        "level": 3
    },
    {
        "id": 330683,
        "region_name": "嵊州市",
        "parent_id": 330600,
        "level": 3
    },
    {
        "id": 330700,
        "region_name": "金华市",
        "parent_id": 330000,
        "level": 2
    },
    {
        "id": 330702,
        "region_name": "婺城区",
        "parent_id": 330700,
        "level": 3
    },
    {
        "id": 330703,
        "region_name": "金东区",
        "parent_id": 330700,
        "level": 3
    },
    {
        "id": 330723,
        "region_name": "武义县",
        "parent_id": 330700,
        "level": 3
    },
    {
        "id": 330726,
        "region_name": "浦江县",
        "parent_id": 330700,
        "level": 3
    },
    {
        "id": 330727,
        "region_name": "磐安县",
        "parent_id": 330700,
        "level": 3
    },
    {
        "id": 330781,
        "region_name": "兰溪市",
        "parent_id": 330700,
        "level": 3
    },
    {
        "id": 330782,
        "region_name": "义乌市",
        "parent_id": 330700,
        "level": 3
    },
    {
        "id": 330783,
        "region_name": "东阳市",
        "parent_id": 330700,
        "level": 3
    },
    {
        "id": 330784,
        "region_name": "永康市",
        "parent_id": 330700,
        "level": 3
    },
    {
        "id": 330800,
        "region_name": "衢州市",
        "parent_id": 330000,
        "level": 2
    },
    {
        "id": 330802,
        "region_name": "柯城区",
        "parent_id": 330800,
        "level": 3
    },
    {
        "id": 330803,
        "region_name": "衢江区",
        "parent_id": 330800,
        "level": 3
    },
    {
        "id": 330822,
        "region_name": "常山县",
        "parent_id": 330800,
        "level": 3
    },
    {
        "id": 330824,
        "region_name": "开化县",
        "parent_id": 330800,
        "level": 3
    },
    {
        "id": 330825,
        "region_name": "龙游县",
        "parent_id": 330800,
        "level": 3
    },
    {
        "id": 330881,
        "region_name": "江山市",
        "parent_id": 330800,
        "level": 3
    },
    {
        "id": 330900,
        "region_name": "舟山市",
        "parent_id": 330000,
        "level": 2
    },
    {
        "id": 330902,
        "region_name": "定海区",
        "parent_id": 330900,
        "level": 3
    },
    {
        "id": 330903,
        "region_name": "普陀区",
        "parent_id": 330900,
        "level": 3
    },
    {
        "id": 330921,
        "region_name": "岱山县",
        "parent_id": 330900,
        "level": 3
    },
    {
        "id": 330922,
        "region_name": "嵊泗县",
        "parent_id": 330900,
        "level": 3
    },
    {
        "id": 331000,
        "region_name": "台州市",
        "parent_id": 330000,
        "level": 2
    },
    {
        "id": 331002,
        "region_name": "椒江区",
        "parent_id": 331000,
        "level": 3
    },
    {
        "id": 331003,
        "region_name": "黄岩区",
        "parent_id": 331000,
        "level": 3
    },
    {
        "id": 331004,
        "region_name": "路桥区",
        "parent_id": 331000,
        "level": 3
    },
    {
        "id": 331022,
        "region_name": "三门县",
        "parent_id": 331000,
        "level": 3
    },
    {
        "id": 331023,
        "region_name": "天台县",
        "parent_id": 331000,
        "level": 3
    },
    {
        "id": 331024,
        "region_name": "仙居县",
        "parent_id": 331000,
        "level": 3
    },
    {
        "id": 331081,
        "region_name": "温岭市",
        "parent_id": 331000,
        "level": 3
    },
    {
        "id": 331082,
        "region_name": "临海市",
        "parent_id": 331000,
        "level": 3
    },
    {
        "id": 331083,
        "region_name": "玉环市",
        "parent_id": 331000,
        "level": 3
    },
    {
        "id": 331100,
        "region_name": "丽水市",
        "parent_id": 330000,
        "level": 2
    },
    {
        "id": 331102,
        "region_name": "莲都区",
        "parent_id": 331100,
        "level": 3
    },
    {
        "id": 331121,
        "region_name": "青田县",
        "parent_id": 331100,
        "level": 3
    },
    {
        "id": 331122,
        "region_name": "缙云县",
        "parent_id": 331100,
        "level": 3
    },
    {
        "id": 331123,
        "region_name": "遂昌县",
        "parent_id": 331100,
        "level": 3
    },
    {
        "id": 331124,
        "region_name": "松阳县",
        "parent_id": 331100,
        "level": 3
    },
    {
        "id": 331125,
        "region_name": "云和县",
        "parent_id": 331100,
        "level": 3
    },
    {
        "id": 331126,
        "region_name": "庆元县",
        "parent_id": 331100,
        "level": 3
    },
    {
        "id": 331127,
        "region_name": "景宁畲族自治县",
        "parent_id": 331100,
        "level": 3
    },
    {
        "id": 331181,
        "region_name": "龙泉市",
        "parent_id": 331100,
        "level": 3
    },
    {
        "id": 340000,
        "region_name": "安徽省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 340100,
        "region_name": "合肥市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 340102,
        "region_name": "瑶海区",
        "parent_id": 340100,
        "level": 3
    },
    {
        "id": 340103,
        "region_name": "庐阳区",
        "parent_id": 340100,
        "level": 3
    },
    {
        "id": 340104,
        "region_name": "蜀山区",
        "parent_id": 340100,
        "level": 3
    },
    {
        "id": 340111,
        "region_name": "包河区",
        "parent_id": 340100,
        "level": 3
    },
    {
        "id": 340121,
        "region_name": "长丰县",
        "parent_id": 340100,
        "level": 3
    },
    {
        "id": 340122,
        "region_name": "肥东县",
        "parent_id": 340100,
        "level": 3
    },
    {
        "id": 340123,
        "region_name": "肥西县",
        "parent_id": 340100,
        "level": 3
    },
    {
        "id": 340124,
        "region_name": "庐江县",
        "parent_id": 340100,
        "level": 3
    },
    {
        "id": 340181,
        "region_name": "巢湖市",
        "parent_id": 340100,
        "level": 3
    },
    {
        "id": 340200,
        "region_name": "芜湖市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 340202,
        "region_name": "镜湖区",
        "parent_id": 340200,
        "level": 3
    },
    {
        "id": 340203,
        "region_name": "弋江区",
        "parent_id": 340200,
        "level": 3
    },
    {
        "id": 340207,
        "region_name": "鸠江区",
        "parent_id": 340200,
        "level": 3
    },
    {
        "id": 340208,
        "region_name": "三山区",
        "parent_id": 340200,
        "level": 3
    },
    {
        "id": 340221,
        "region_name": "芜湖县",
        "parent_id": 340200,
        "level": 3
    },
    {
        "id": 340222,
        "region_name": "繁昌县",
        "parent_id": 340200,
        "level": 3
    },
    {
        "id": 340223,
        "region_name": "南陵县",
        "parent_id": 340200,
        "level": 3
    },
    {
        "id": 340225,
        "region_name": "无为县",
        "parent_id": 340200,
        "level": 3
    },
    {
        "id": 340300,
        "region_name": "蚌埠市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 340302,
        "region_name": "龙子湖区",
        "parent_id": 340300,
        "level": 3
    },
    {
        "id": 340303,
        "region_name": "蚌山区",
        "parent_id": 340300,
        "level": 3
    },
    {
        "id": 340304,
        "region_name": "禹会区",
        "parent_id": 340300,
        "level": 3
    },
    {
        "id": 340311,
        "region_name": "淮上区",
        "parent_id": 340300,
        "level": 3
    },
    {
        "id": 340321,
        "region_name": "怀远县",
        "parent_id": 340300,
        "level": 3
    },
    {
        "id": 340322,
        "region_name": "五河县",
        "parent_id": 340300,
        "level": 3
    },
    {
        "id": 340323,
        "region_name": "固镇县",
        "parent_id": 340300,
        "level": 3
    },
    {
        "id": 340400,
        "region_name": "淮南市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 340402,
        "region_name": "大通区",
        "parent_id": 340400,
        "level": 3
    },
    {
        "id": 340403,
        "region_name": "田家庵区",
        "parent_id": 340400,
        "level": 3
    },
    {
        "id": 340404,
        "region_name": "谢家集区",
        "parent_id": 340400,
        "level": 3
    },
    {
        "id": 340405,
        "region_name": "八公山区",
        "parent_id": 340400,
        "level": 3
    },
    {
        "id": 340406,
        "region_name": "潘集区",
        "parent_id": 340400,
        "level": 3
    },
    {
        "id": 340421,
        "region_name": "凤台县",
        "parent_id": 340400,
        "level": 3
    },
    {
        "id": 340422,
        "region_name": "寿县",
        "parent_id": 340400,
        "level": 3
    },
    {
        "id": 340500,
        "region_name": "马鞍山市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 340503,
        "region_name": "花山区",
        "parent_id": 340500,
        "level": 3
    },
    {
        "id": 340504,
        "region_name": "雨山区",
        "parent_id": 340500,
        "level": 3
    },
    {
        "id": 340506,
        "region_name": "博望区",
        "parent_id": 340500,
        "level": 3
    },
    {
        "id": 340521,
        "region_name": "当涂县",
        "parent_id": 340500,
        "level": 3
    },
    {
        "id": 340522,
        "region_name": "含山县",
        "parent_id": 340500,
        "level": 3
    },
    {
        "id": 340523,
        "region_name": "和县",
        "parent_id": 340500,
        "level": 3
    },
    {
        "id": 340600,
        "region_name": "淮北市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 340602,
        "region_name": "杜集区",
        "parent_id": 340600,
        "level": 3
    },
    {
        "id": 340603,
        "region_name": "相山区",
        "parent_id": 340600,
        "level": 3
    },
    {
        "id": 340604,
        "region_name": "烈山区",
        "parent_id": 340600,
        "level": 3
    },
    {
        "id": 340621,
        "region_name": "濉溪县",
        "parent_id": 340600,
        "level": 3
    },
    {
        "id": 340700,
        "region_name": "铜陵市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 340705,
        "region_name": "铜官区",
        "parent_id": 340700,
        "level": 3
    },
    {
        "id": 340706,
        "region_name": "义安区",
        "parent_id": 340700,
        "level": 3
    },
    {
        "id": 340711,
        "region_name": "郊区",
        "parent_id": 340700,
        "level": 3
    },
    {
        "id": 340722,
        "region_name": "枞阳县",
        "parent_id": 340700,
        "level": 3
    },
    {
        "id": 340800,
        "region_name": "安庆市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 340802,
        "region_name": "迎江区",
        "parent_id": 340800,
        "level": 3
    },
    {
        "id": 340803,
        "region_name": "大观区",
        "parent_id": 340800,
        "level": 3
    },
    {
        "id": 340811,
        "region_name": "宜秀区",
        "parent_id": 340800,
        "level": 3
    },
    {
        "id": 340822,
        "region_name": "怀宁县",
        "parent_id": 340800,
        "level": 3
    },
    {
        "id": 340824,
        "region_name": "潜山县",
        "parent_id": 340800,
        "level": 3
    },
    {
        "id": 340825,
        "region_name": "太湖县",
        "parent_id": 340800,
        "level": 3
    },
    {
        "id": 340826,
        "region_name": "宿松县",
        "parent_id": 340800,
        "level": 3
    },
    {
        "id": 340827,
        "region_name": "望江县",
        "parent_id": 340800,
        "level": 3
    },
    {
        "id": 340828,
        "region_name": "岳西县",
        "parent_id": 340800,
        "level": 3
    },
    {
        "id": 340881,
        "region_name": "桐城市",
        "parent_id": 340800,
        "level": 3
    },
    {
        "id": 341000,
        "region_name": "黄山市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 341002,
        "region_name": "屯溪区",
        "parent_id": 341000,
        "level": 3
    },
    {
        "id": 341003,
        "region_name": "黄山区",
        "parent_id": 341000,
        "level": 3
    },
    {
        "id": 341004,
        "region_name": "徽州区",
        "parent_id": 341000,
        "level": 3
    },
    {
        "id": 341021,
        "region_name": "歙县",
        "parent_id": 341000,
        "level": 3
    },
    {
        "id": 341022,
        "region_name": "休宁县",
        "parent_id": 341000,
        "level": 3
    },
    {
        "id": 341023,
        "region_name": "黟县",
        "parent_id": 341000,
        "level": 3
    },
    {
        "id": 341024,
        "region_name": "祁门县",
        "parent_id": 341000,
        "level": 3
    },
    {
        "id": 341100,
        "region_name": "滁州市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 341102,
        "region_name": "琅琊区",
        "parent_id": 341100,
        "level": 3
    },
    {
        "id": 341103,
        "region_name": "南谯区",
        "parent_id": 341100,
        "level": 3
    },
    {
        "id": 341122,
        "region_name": "来安县",
        "parent_id": 341100,
        "level": 3
    },
    {
        "id": 341124,
        "region_name": "全椒县",
        "parent_id": 341100,
        "level": 3
    },
    {
        "id": 341125,
        "region_name": "定远县",
        "parent_id": 341100,
        "level": 3
    },
    {
        "id": 341126,
        "region_name": "凤阳县",
        "parent_id": 341100,
        "level": 3
    },
    {
        "id": 341181,
        "region_name": "天长市",
        "parent_id": 341100,
        "level": 3
    },
    {
        "id": 341182,
        "region_name": "明光市",
        "parent_id": 341100,
        "level": 3
    },
    {
        "id": 341200,
        "region_name": "阜阳市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 341202,
        "region_name": "颍州区",
        "parent_id": 341200,
        "level": 3
    },
    {
        "id": 341203,
        "region_name": "颍东区",
        "parent_id": 341200,
        "level": 3
    },
    {
        "id": 341204,
        "region_name": "颍泉区",
        "parent_id": 341200,
        "level": 3
    },
    {
        "id": 341221,
        "region_name": "临泉县",
        "parent_id": 341200,
        "level": 3
    },
    {
        "id": 341222,
        "region_name": "太和县",
        "parent_id": 341200,
        "level": 3
    },
    {
        "id": 341225,
        "region_name": "阜南县",
        "parent_id": 341200,
        "level": 3
    },
    {
        "id": 341226,
        "region_name": "颍上县",
        "parent_id": 341200,
        "level": 3
    },
    {
        "id": 341282,
        "region_name": "界首市",
        "parent_id": 341200,
        "level": 3
    },
    {
        "id": 341300,
        "region_name": "宿州市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 341302,
        "region_name": "埇桥区",
        "parent_id": 341300,
        "level": 3
    },
    {
        "id": 341321,
        "region_name": "砀山县",
        "parent_id": 341300,
        "level": 3
    },
    {
        "id": 341322,
        "region_name": "萧县",
        "parent_id": 341300,
        "level": 3
    },
    {
        "id": 341323,
        "region_name": "灵璧县",
        "parent_id": 341300,
        "level": 3
    },
    {
        "id": 341324,
        "region_name": "泗县",
        "parent_id": 341300,
        "level": 3
    },
    {
        "id": 341500,
        "region_name": "六安市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 341502,
        "region_name": "金安区",
        "parent_id": 341500,
        "level": 3
    },
    {
        "id": 341503,
        "region_name": "裕安区",
        "parent_id": 341500,
        "level": 3
    },
    {
        "id": 341504,
        "region_name": "叶集区",
        "parent_id": 341500,
        "level": 3
    },
    {
        "id": 341522,
        "region_name": "霍邱县",
        "parent_id": 341500,
        "level": 3
    },
    {
        "id": 341523,
        "region_name": "舒城县",
        "parent_id": 341500,
        "level": 3
    },
    {
        "id": 341524,
        "region_name": "金寨县",
        "parent_id": 341500,
        "level": 3
    },
    {
        "id": 341525,
        "region_name": "霍山县",
        "parent_id": 341500,
        "level": 3
    },
    {
        "id": 341600,
        "region_name": "亳州市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 341602,
        "region_name": "谯城区",
        "parent_id": 341600,
        "level": 3
    },
    {
        "id": 341621,
        "region_name": "涡阳县",
        "parent_id": 341600,
        "level": 3
    },
    {
        "id": 341622,
        "region_name": "蒙城县",
        "parent_id": 341600,
        "level": 3
    },
    {
        "id": 341623,
        "region_name": "利辛县",
        "parent_id": 341600,
        "level": 3
    },
    {
        "id": 341700,
        "region_name": "池州市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 341702,
        "region_name": "贵池区",
        "parent_id": 341700,
        "level": 3
    },
    {
        "id": 341721,
        "region_name": "东至县",
        "parent_id": 341700,
        "level": 3
    },
    {
        "id": 341722,
        "region_name": "石台县",
        "parent_id": 341700,
        "level": 3
    },
    {
        "id": 341723,
        "region_name": "青阳县",
        "parent_id": 341700,
        "level": 3
    },
    {
        "id": 341800,
        "region_name": "宣城市",
        "parent_id": 340000,
        "level": 2
    },
    {
        "id": 341802,
        "region_name": "宣州区",
        "parent_id": 341800,
        "level": 3
    },
    {
        "id": 341821,
        "region_name": "郎溪县",
        "parent_id": 341800,
        "level": 3
    },
    {
        "id": 341822,
        "region_name": "广德县",
        "parent_id": 341800,
        "level": 3
    },
    {
        "id": 341823,
        "region_name": "泾县",
        "parent_id": 341800,
        "level": 3
    },
    {
        "id": 341824,
        "region_name": "绩溪县",
        "parent_id": 341800,
        "level": 3
    },
    {
        "id": 341825,
        "region_name": "旌德县",
        "parent_id": 341800,
        "level": 3
    },
    {
        "id": 341881,
        "region_name": "宁国市",
        "parent_id": 341800,
        "level": 3
    },
    {
        "id": 350000,
        "region_name": "福建省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 350100,
        "region_name": "福州市",
        "parent_id": 350000,
        "level": 2
    },
    {
        "id": 350102,
        "region_name": "鼓楼区",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350103,
        "region_name": "台江区",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350104,
        "region_name": "仓山区",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350105,
        "region_name": "马尾区",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350111,
        "region_name": "晋安区",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350112,
        "region_name": "长乐区",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350121,
        "region_name": "闽侯县",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350122,
        "region_name": "连江县",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350123,
        "region_name": "罗源县",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350124,
        "region_name": "闽清县",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350125,
        "region_name": "永泰县",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350128,
        "region_name": "平潭县",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350181,
        "region_name": "福清市",
        "parent_id": 350100,
        "level": 3
    },
    {
        "id": 350200,
        "region_name": "厦门市",
        "parent_id": 350000,
        "level": 2
    },
    {
        "id": 350203,
        "region_name": "思明区",
        "parent_id": 350200,
        "level": 3
    },
    {
        "id": 350205,
        "region_name": "海沧区",
        "parent_id": 350200,
        "level": 3
    },
    {
        "id": 350206,
        "region_name": "湖里区",
        "parent_id": 350200,
        "level": 3
    },
    {
        "id": 350211,
        "region_name": "集美区",
        "parent_id": 350200,
        "level": 3
    },
    {
        "id": 350212,
        "region_name": "同安区",
        "parent_id": 350200,
        "level": 3
    },
    {
        "id": 350213,
        "region_name": "翔安区",
        "parent_id": 350200,
        "level": 3
    },
    {
        "id": 350300,
        "region_name": "莆田市",
        "parent_id": 350000,
        "level": 2
    },
    {
        "id": 350302,
        "region_name": "城厢区",
        "parent_id": 350300,
        "level": 3
    },
    {
        "id": 350303,
        "region_name": "涵江区",
        "parent_id": 350300,
        "level": 3
    },
    {
        "id": 350304,
        "region_name": "荔城区",
        "parent_id": 350300,
        "level": 3
    },
    {
        "id": 350305,
        "region_name": "秀屿区",
        "parent_id": 350300,
        "level": 3
    },
    {
        "id": 350322,
        "region_name": "仙游县",
        "parent_id": 350300,
        "level": 3
    },
    {
        "id": 350400,
        "region_name": "三明市",
        "parent_id": 350000,
        "level": 2
    },
    {
        "id": 350402,
        "region_name": "梅列区",
        "parent_id": 350400,
        "level": 3
    },
    {
        "id": 350403,
        "region_name": "三元区",
        "parent_id": 350400,
        "level": 3
    },
    {
        "id": 350421,
        "region_name": "明溪县",
        "parent_id": 350400,
        "level": 3
    },
    {
        "id": 350423,
        "region_name": "清流县",
        "parent_id": 350400,
        "level": 3
    },
    {
        "id": 350424,
        "region_name": "宁化县",
        "parent_id": 350400,
        "level": 3
    },
    {
        "id": 350425,
        "region_name": "大田县",
        "parent_id": 350400,
        "level": 3
    },
    {
        "id": 350426,
        "region_name": "尤溪县",
        "parent_id": 350400,
        "level": 3
    },
    {
        "id": 350427,
        "region_name": "沙县",
        "parent_id": 350400,
        "level": 3
    },
    {
        "id": 350428,
        "region_name": "将乐县",
        "parent_id": 350400,
        "level": 3
    },
    {
        "id": 350429,
        "region_name": "泰宁县",
        "parent_id": 350400,
        "level": 3
    },
    {
        "id": 350430,
        "region_name": "建宁县",
        "parent_id": 350400,
        "level": 3
    },
    {
        "id": 350481,
        "region_name": "永安市",
        "parent_id": 350400,
        "level": 3
    },
    {
        "id": 350500,
        "region_name": "泉州市",
        "parent_id": 350000,
        "level": 2
    },
    {
        "id": 350502,
        "region_name": "鲤城区",
        "parent_id": 350500,
        "level": 3
    },
    {
        "id": 350503,
        "region_name": "丰泽区",
        "parent_id": 350500,
        "level": 3
    },
    {
        "id": 350504,
        "region_name": "洛江区",
        "parent_id": 350500,
        "level": 3
    },
    {
        "id": 350505,
        "region_name": "泉港区",
        "parent_id": 350500,
        "level": 3
    },
    {
        "id": 350521,
        "region_name": "惠安县",
        "parent_id": 350500,
        "level": 3
    },
    {
        "id": 350524,
        "region_name": "安溪县",
        "parent_id": 350500,
        "level": 3
    },
    {
        "id": 350525,
        "region_name": "永春县",
        "parent_id": 350500,
        "level": 3
    },
    {
        "id": 350526,
        "region_name": "德化县",
        "parent_id": 350500,
        "level": 3
    },
    {
        "id": 350527,
        "region_name": "金门县",
        "parent_id": 350500,
        "level": 3
    },
    {
        "id": 350581,
        "region_name": "石狮市",
        "parent_id": 350500,
        "level": 3
    },
    {
        "id": 350582,
        "region_name": "晋江市",
        "parent_id": 350500,
        "level": 3
    },
    {
        "id": 350583,
        "region_name": "南安市",
        "parent_id": 350500,
        "level": 3
    },
    {
        "id": 350600,
        "region_name": "漳州市",
        "parent_id": 350000,
        "level": 2
    },
    {
        "id": 350602,
        "region_name": "芗城区",
        "parent_id": 350600,
        "level": 3
    },
    {
        "id": 350603,
        "region_name": "龙文区",
        "parent_id": 350600,
        "level": 3
    },
    {
        "id": 350622,
        "region_name": "云霄县",
        "parent_id": 350600,
        "level": 3
    },
    {
        "id": 350623,
        "region_name": "漳浦县",
        "parent_id": 350600,
        "level": 3
    },
    {
        "id": 350624,
        "region_name": "诏安县",
        "parent_id": 350600,
        "level": 3
    },
    {
        "id": 350625,
        "region_name": "长泰县",
        "parent_id": 350600,
        "level": 3
    },
    {
        "id": 350626,
        "region_name": "东山县",
        "parent_id": 350600,
        "level": 3
    },
    {
        "id": 350627,
        "region_name": "南靖县",
        "parent_id": 350600,
        "level": 3
    },
    {
        "id": 350628,
        "region_name": "平和县",
        "parent_id": 350600,
        "level": 3
    },
    {
        "id": 350629,
        "region_name": "华安县",
        "parent_id": 350600,
        "level": 3
    },
    {
        "id": 350681,
        "region_name": "龙海市",
        "parent_id": 350600,
        "level": 3
    },
    {
        "id": 350700,
        "region_name": "南平市",
        "parent_id": 350000,
        "level": 2
    },
    {
        "id": 350702,
        "region_name": "延平区",
        "parent_id": 350700,
        "level": 3
    },
    {
        "id": 350703,
        "region_name": "建阳区",
        "parent_id": 350700,
        "level": 3
    },
    {
        "id": 350721,
        "region_name": "顺昌县",
        "parent_id": 350700,
        "level": 3
    },
    {
        "id": 350722,
        "region_name": "浦城县",
        "parent_id": 350700,
        "level": 3
    },
    {
        "id": 350723,
        "region_name": "光泽县",
        "parent_id": 350700,
        "level": 3
    },
    {
        "id": 350724,
        "region_name": "松溪县",
        "parent_id": 350700,
        "level": 3
    },
    {
        "id": 350725,
        "region_name": "政和县",
        "parent_id": 350700,
        "level": 3
    },
    {
        "id": 350781,
        "region_name": "邵武市",
        "parent_id": 350700,
        "level": 3
    },
    {
        "id": 350782,
        "region_name": "武夷山市",
        "parent_id": 350700,
        "level": 3
    },
    {
        "id": 350783,
        "region_name": "建瓯市",
        "parent_id": 350700,
        "level": 3
    },
    {
        "id": 350800,
        "region_name": "龙岩市",
        "parent_id": 350000,
        "level": 2
    },
    {
        "id": 350802,
        "region_name": "新罗区",
        "parent_id": 350800,
        "level": 3
    },
    {
        "id": 350803,
        "region_name": "永定区",
        "parent_id": 350800,
        "level": 3
    },
    {
        "id": 350821,
        "region_name": "长汀县",
        "parent_id": 350800,
        "level": 3
    },
    {
        "id": 350823,
        "region_name": "上杭县",
        "parent_id": 350800,
        "level": 3
    },
    {
        "id": 350824,
        "region_name": "武平县",
        "parent_id": 350800,
        "level": 3
    },
    {
        "id": 350825,
        "region_name": "连城县",
        "parent_id": 350800,
        "level": 3
    },
    {
        "id": 350881,
        "region_name": "漳平市",
        "parent_id": 350800,
        "level": 3
    },
    {
        "id": 350900,
        "region_name": "宁德市",
        "parent_id": 350000,
        "level": 2
    },
    {
        "id": 350902,
        "region_name": "蕉城区",
        "parent_id": 350900,
        "level": 3
    },
    {
        "id": 350921,
        "region_name": "霞浦县",
        "parent_id": 350900,
        "level": 3
    },
    {
        "id": 350922,
        "region_name": "古田县",
        "parent_id": 350900,
        "level": 3
    },
    {
        "id": 350923,
        "region_name": "屏南县",
        "parent_id": 350900,
        "level": 3
    },
    {
        "id": 350924,
        "region_name": "寿宁县",
        "parent_id": 350900,
        "level": 3
    },
    {
        "id": 350925,
        "region_name": "周宁县",
        "parent_id": 350900,
        "level": 3
    },
    {
        "id": 350926,
        "region_name": "柘荣县",
        "parent_id": 350900,
        "level": 3
    },
    {
        "id": 350981,
        "region_name": "福安市",
        "parent_id": 350900,
        "level": 3
    },
    {
        "id": 350982,
        "region_name": "福鼎市",
        "parent_id": 350900,
        "level": 3
    },
    {
        "id": 360000,
        "region_name": "江西省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 360100,
        "region_name": "南昌市",
        "parent_id": 360000,
        "level": 2
    },
    {
        "id": 360102,
        "region_name": "东湖区",
        "parent_id": 360100,
        "level": 3
    },
    {
        "id": 360103,
        "region_name": "西湖区",
        "parent_id": 360100,
        "level": 3
    },
    {
        "id": 360104,
        "region_name": "青云谱区",
        "parent_id": 360100,
        "level": 3
    },
    {
        "id": 360105,
        "region_name": "湾里区",
        "parent_id": 360100,
        "level": 3
    },
    {
        "id": 360111,
        "region_name": "青山湖区",
        "parent_id": 360100,
        "level": 3
    },
    {
        "id": 360112,
        "region_name": "新建区",
        "parent_id": 360100,
        "level": 3
    },
    {
        "id": 360121,
        "region_name": "南昌县",
        "parent_id": 360100,
        "level": 3
    },
    {
        "id": 360123,
        "region_name": "安义县",
        "parent_id": 360100,
        "level": 3
    },
    {
        "id": 360124,
        "region_name": "进贤县",
        "parent_id": 360100,
        "level": 3
    },
    {
        "id": 360200,
        "region_name": "景德镇市",
        "parent_id": 360000,
        "level": 2
    },
    {
        "id": 360202,
        "region_name": "昌江区",
        "parent_id": 360200,
        "level": 3
    },
    {
        "id": 360203,
        "region_name": "珠山区",
        "parent_id": 360200,
        "level": 3
    },
    {
        "id": 360222,
        "region_name": "浮梁县",
        "parent_id": 360200,
        "level": 3
    },
    {
        "id": 360281,
        "region_name": "乐平市",
        "parent_id": 360200,
        "level": 3
    },
    {
        "id": 360300,
        "region_name": "萍乡市",
        "parent_id": 360000,
        "level": 2
    },
    {
        "id": 360302,
        "region_name": "安源区",
        "parent_id": 360300,
        "level": 3
    },
    {
        "id": 360313,
        "region_name": "湘东区",
        "parent_id": 360300,
        "level": 3
    },
    {
        "id": 360321,
        "region_name": "莲花县",
        "parent_id": 360300,
        "level": 3
    },
    {
        "id": 360322,
        "region_name": "上栗县",
        "parent_id": 360300,
        "level": 3
    },
    {
        "id": 360323,
        "region_name": "芦溪县",
        "parent_id": 360300,
        "level": 3
    },
    {
        "id": 360400,
        "region_name": "九江市",
        "parent_id": 360000,
        "level": 2
    },
    {
        "id": 360402,
        "region_name": "濂溪区",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360403,
        "region_name": "浔阳区",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360404,
        "region_name": "柴桑区",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360423,
        "region_name": "武宁县",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360424,
        "region_name": "修水县",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360425,
        "region_name": "永修县",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360426,
        "region_name": "德安县",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360428,
        "region_name": "都昌县",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360429,
        "region_name": "湖口县",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360430,
        "region_name": "彭泽县",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360481,
        "region_name": "瑞昌市",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360482,
        "region_name": "共青城市",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360483,
        "region_name": "庐山市",
        "parent_id": 360400,
        "level": 3
    },
    {
        "id": 360500,
        "region_name": "新余市",
        "parent_id": 360000,
        "level": 2
    },
    {
        "id": 360502,
        "region_name": "渝水区",
        "parent_id": 360500,
        "level": 3
    },
    {
        "id": 360521,
        "region_name": "分宜县",
        "parent_id": 360500,
        "level": 3
    },
    {
        "id": 360600,
        "region_name": "鹰潭市",
        "parent_id": 360000,
        "level": 2
    },
    {
        "id": 360602,
        "region_name": "月湖区",
        "parent_id": 360600,
        "level": 3
    },
    {
        "id": 360622,
        "region_name": "余江县",
        "parent_id": 360600,
        "level": 3
    },
    {
        "id": 360681,
        "region_name": "贵溪市",
        "parent_id": 360600,
        "level": 3
    },
    {
        "id": 360700,
        "region_name": "赣州市",
        "parent_id": 360000,
        "level": 2
    },
    {
        "id": 360702,
        "region_name": "章贡区",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360703,
        "region_name": "南康区",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360704,
        "region_name": "赣县区",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360722,
        "region_name": "信丰县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360723,
        "region_name": "大余县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360724,
        "region_name": "上犹县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360725,
        "region_name": "崇义县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360726,
        "region_name": "安远县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360727,
        "region_name": "龙南县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360728,
        "region_name": "定南县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360729,
        "region_name": "全南县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360730,
        "region_name": "宁都县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360731,
        "region_name": "于都县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360732,
        "region_name": "兴国县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360733,
        "region_name": "会昌县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360734,
        "region_name": "寻乌县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360735,
        "region_name": "石城县",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360781,
        "region_name": "瑞金市",
        "parent_id": 360700,
        "level": 3
    },
    {
        "id": 360800,
        "region_name": "吉安市",
        "parent_id": 360000,
        "level": 2
    },
    {
        "id": 360802,
        "region_name": "吉州区",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360803,
        "region_name": "青原区",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360821,
        "region_name": "吉安县",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360822,
        "region_name": "吉水县",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360823,
        "region_name": "峡江县",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360824,
        "region_name": "新干县",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360825,
        "region_name": "永丰县",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360826,
        "region_name": "泰和县",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360827,
        "region_name": "遂川县",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360828,
        "region_name": "万安县",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360829,
        "region_name": "安福县",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360830,
        "region_name": "永新县",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360881,
        "region_name": "井冈山市",
        "parent_id": 360800,
        "level": 3
    },
    {
        "id": 360900,
        "region_name": "宜春市",
        "parent_id": 360000,
        "level": 2
    },
    {
        "id": 360902,
        "region_name": "袁州区",
        "parent_id": 360900,
        "level": 3
    },
    {
        "id": 360921,
        "region_name": "奉新县",
        "parent_id": 360900,
        "level": 3
    },
    {
        "id": 360922,
        "region_name": "万载县",
        "parent_id": 360900,
        "level": 3
    },
    {
        "id": 360923,
        "region_name": "上高县",
        "parent_id": 360900,
        "level": 3
    },
    {
        "id": 360924,
        "region_name": "宜丰县",
        "parent_id": 360900,
        "level": 3
    },
    {
        "id": 360925,
        "region_name": "靖安县",
        "parent_id": 360900,
        "level": 3
    },
    {
        "id": 360926,
        "region_name": "铜鼓县",
        "parent_id": 360900,
        "level": 3
    },
    {
        "id": 360981,
        "region_name": "丰城市",
        "parent_id": 360900,
        "level": 3
    },
    {
        "id": 360982,
        "region_name": "樟树市",
        "parent_id": 360900,
        "level": 3
    },
    {
        "id": 360983,
        "region_name": "高安市",
        "parent_id": 360900,
        "level": 3
    },
    {
        "id": 361000,
        "region_name": "抚州市",
        "parent_id": 360000,
        "level": 2
    },
    {
        "id": 361002,
        "region_name": "临川区",
        "parent_id": 361000,
        "level": 3
    },
    {
        "id": 361003,
        "region_name": "东乡区",
        "parent_id": 361000,
        "level": 3
    },
    {
        "id": 361021,
        "region_name": "南城县",
        "parent_id": 361000,
        "level": 3
    },
    {
        "id": 361022,
        "region_name": "黎川县",
        "parent_id": 361000,
        "level": 3
    },
    {
        "id": 361023,
        "region_name": "南丰县",
        "parent_id": 361000,
        "level": 3
    },
    {
        "id": 361024,
        "region_name": "崇仁县",
        "parent_id": 361000,
        "level": 3
    },
    {
        "id": 361025,
        "region_name": "乐安县",
        "parent_id": 361000,
        "level": 3
    },
    {
        "id": 361026,
        "region_name": "宜黄县",
        "parent_id": 361000,
        "level": 3
    },
    {
        "id": 361027,
        "region_name": "金溪县",
        "parent_id": 361000,
        "level": 3
    },
    {
        "id": 361028,
        "region_name": "资溪县",
        "parent_id": 361000,
        "level": 3
    },
    {
        "id": 361030,
        "region_name": "广昌县",
        "parent_id": 361000,
        "level": 3
    },
    {
        "id": 361100,
        "region_name": "上饶市",
        "parent_id": 360000,
        "level": 2
    },
    {
        "id": 361102,
        "region_name": "信州区",
        "parent_id": 361100,
        "level": 3
    },
    {
        "id": 361103,
        "region_name": "广丰区",
        "parent_id": 361100,
        "level": 3
    },
    {
        "id": 361121,
        "region_name": "上饶县",
        "parent_id": 361100,
        "level": 3
    },
    {
        "id": 361123,
        "region_name": "玉山县",
        "parent_id": 361100,
        "level": 3
    },
    {
        "id": 361124,
        "region_name": "铅山县",
        "parent_id": 361100,
        "level": 3
    },
    {
        "id": 361125,
        "region_name": "横峰县",
        "parent_id": 361100,
        "level": 3
    },
    {
        "id": 361126,
        "region_name": "弋阳县",
        "parent_id": 361100,
        "level": 3
    },
    {
        "id": 361127,
        "region_name": "余干县",
        "parent_id": 361100,
        "level": 3
    },
    {
        "id": 361128,
        "region_name": "鄱阳县",
        "parent_id": 361100,
        "level": 3
    },
    {
        "id": 361129,
        "region_name": "万年县",
        "parent_id": 361100,
        "level": 3
    },
    {
        "id": 361130,
        "region_name": "婺源县",
        "parent_id": 361100,
        "level": 3
    },
    {
        "id": 361181,
        "region_name": "德兴市",
        "parent_id": 361100,
        "level": 3
    },
    {
        "id": 370000,
        "region_name": "山东省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 370100,
        "region_name": "济南市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 370102,
        "region_name": "历下区",
        "parent_id": 370100,
        "level": 3
    },
    {
        "id": 370103,
        "region_name": "市中区",
        "parent_id": 370100,
        "level": 3
    },
    {
        "id": 370104,
        "region_name": "槐荫区",
        "parent_id": 370100,
        "level": 3
    },
    {
        "id": 370105,
        "region_name": "天桥区",
        "parent_id": 370100,
        "level": 3
    },
    {
        "id": 370112,
        "region_name": "历城区",
        "parent_id": 370100,
        "level": 3
    },
    {
        "id": 370113,
        "region_name": "长清区",
        "parent_id": 370100,
        "level": 3
    },
    {
        "id": 370114,
        "region_name": "章丘区",
        "parent_id": 370100,
        "level": 3
    },
    {
        "id": 370124,
        "region_name": "平阴县",
        "parent_id": 370100,
        "level": 3
    },
    {
        "id": 370125,
        "region_name": "济阳县",
        "parent_id": 370100,
        "level": 3
    },
    {
        "id": 370126,
        "region_name": "商河县",
        "parent_id": 370100,
        "level": 3
    },
    {
        "id": 370200,
        "region_name": "青岛市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 370202,
        "region_name": "市南区",
        "parent_id": 370200,
        "level": 3
    },
    {
        "id": 370203,
        "region_name": "市北区",
        "parent_id": 370200,
        "level": 3
    },
    {
        "id": 370211,
        "region_name": "黄岛区",
        "parent_id": 370200,
        "level": 3
    },
    {
        "id": 370212,
        "region_name": "崂山区",
        "parent_id": 370200,
        "level": 3
    },
    {
        "id": 370213,
        "region_name": "李沧区",
        "parent_id": 370200,
        "level": 3
    },
    {
        "id": 370214,
        "region_name": "城阳区",
        "parent_id": 370200,
        "level": 3
    },
    {
        "id": 370215,
        "region_name": "即墨区",
        "parent_id": 370200,
        "level": 3
    },
    {
        "id": 370281,
        "region_name": "胶州市",
        "parent_id": 370200,
        "level": 3
    },
    {
        "id": 370283,
        "region_name": "平度市",
        "parent_id": 370200,
        "level": 3
    },
    {
        "id": 370285,
        "region_name": "莱西市",
        "parent_id": 370200,
        "level": 3
    },
    {
        "id": 370300,
        "region_name": "淄博市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 370302,
        "region_name": "淄川区",
        "parent_id": 370300,
        "level": 3
    },
    {
        "id": 370303,
        "region_name": "张店区",
        "parent_id": 370300,
        "level": 3
    },
    {
        "id": 370304,
        "region_name": "博山区",
        "parent_id": 370300,
        "level": 3
    },
    {
        "id": 370305,
        "region_name": "临淄区",
        "parent_id": 370300,
        "level": 3
    },
    {
        "id": 370306,
        "region_name": "周村区",
        "parent_id": 370300,
        "level": 3
    },
    {
        "id": 370321,
        "region_name": "桓台县",
        "parent_id": 370300,
        "level": 3
    },
    {
        "id": 370322,
        "region_name": "高青县",
        "parent_id": 370300,
        "level": 3
    },
    {
        "id": 370323,
        "region_name": "沂源县",
        "parent_id": 370300,
        "level": 3
    },
    {
        "id": 370400,
        "region_name": "枣庄市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 370402,
        "region_name": "市中区",
        "parent_id": 370400,
        "level": 3
    },
    {
        "id": 370403,
        "region_name": "薛城区",
        "parent_id": 370400,
        "level": 3
    },
    {
        "id": 370404,
        "region_name": "峄城区",
        "parent_id": 370400,
        "level": 3
    },
    {
        "id": 370405,
        "region_name": "台儿庄区",
        "parent_id": 370400,
        "level": 3
    },
    {
        "id": 370406,
        "region_name": "山亭区",
        "parent_id": 370400,
        "level": 3
    },
    {
        "id": 370481,
        "region_name": "滕州市",
        "parent_id": 370400,
        "level": 3
    },
    {
        "id": 370500,
        "region_name": "东营市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 370502,
        "region_name": "东营区",
        "parent_id": 370500,
        "level": 3
    },
    {
        "id": 370503,
        "region_name": "河口区",
        "parent_id": 370500,
        "level": 3
    },
    {
        "id": 370505,
        "region_name": "垦利区",
        "parent_id": 370500,
        "level": 3
    },
    {
        "id": 370522,
        "region_name": "利津县",
        "parent_id": 370500,
        "level": 3
    },
    {
        "id": 370523,
        "region_name": "广饶县",
        "parent_id": 370500,
        "level": 3
    },
    {
        "id": 370600,
        "region_name": "烟台市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 370602,
        "region_name": "芝罘区",
        "parent_id": 370600,
        "level": 3
    },
    {
        "id": 370611,
        "region_name": "福山区",
        "parent_id": 370600,
        "level": 3
    },
    {
        "id": 370612,
        "region_name": "牟平区",
        "parent_id": 370600,
        "level": 3
    },
    {
        "id": 370613,
        "region_name": "莱山区",
        "parent_id": 370600,
        "level": 3
    },
    {
        "id": 370634,
        "region_name": "长岛县",
        "parent_id": 370600,
        "level": 3
    },
    {
        "id": 370681,
        "region_name": "龙口市",
        "parent_id": 370600,
        "level": 3
    },
    {
        "id": 370682,
        "region_name": "莱阳市",
        "parent_id": 370600,
        "level": 3
    },
    {
        "id": 370683,
        "region_name": "莱州市",
        "parent_id": 370600,
        "level": 3
    },
    {
        "id": 370684,
        "region_name": "蓬莱市",
        "parent_id": 370600,
        "level": 3
    },
    {
        "id": 370685,
        "region_name": "招远市",
        "parent_id": 370600,
        "level": 3
    },
    {
        "id": 370686,
        "region_name": "栖霞市",
        "parent_id": 370600,
        "level": 3
    },
    {
        "id": 370687,
        "region_name": "海阳市",
        "parent_id": 370600,
        "level": 3
    },
    {
        "id": 370700,
        "region_name": "潍坊市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 370702,
        "region_name": "潍城区",
        "parent_id": 370700,
        "level": 3
    },
    {
        "id": 370703,
        "region_name": "寒亭区",
        "parent_id": 370700,
        "level": 3
    },
    {
        "id": 370704,
        "region_name": "坊子区",
        "parent_id": 370700,
        "level": 3
    },
    {
        "id": 370705,
        "region_name": "奎文区",
        "parent_id": 370700,
        "level": 3
    },
    {
        "id": 370724,
        "region_name": "临朐县",
        "parent_id": 370700,
        "level": 3
    },
    {
        "id": 370725,
        "region_name": "昌乐县",
        "parent_id": 370700,
        "level": 3
    },
    {
        "id": 370781,
        "region_name": "青州市",
        "parent_id": 370700,
        "level": 3
    },
    {
        "id": 370782,
        "region_name": "诸城市",
        "parent_id": 370700,
        "level": 3
    },
    {
        "id": 370783,
        "region_name": "寿光市",
        "parent_id": 370700,
        "level": 3
    },
    {
        "id": 370784,
        "region_name": "安丘市",
        "parent_id": 370700,
        "level": 3
    },
    {
        "id": 370785,
        "region_name": "高密市",
        "parent_id": 370700,
        "level": 3
    },
    {
        "id": 370786,
        "region_name": "昌邑市",
        "parent_id": 370700,
        "level": 3
    },
    {
        "id": 370800,
        "region_name": "济宁市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 370811,
        "region_name": "任城区",
        "parent_id": 370800,
        "level": 3
    },
    {
        "id": 370812,
        "region_name": "兖州区",
        "parent_id": 370800,
        "level": 3
    },
    {
        "id": 370826,
        "region_name": "微山县",
        "parent_id": 370800,
        "level": 3
    },
    {
        "id": 370827,
        "region_name": "鱼台县",
        "parent_id": 370800,
        "level": 3
    },
    {
        "id": 370828,
        "region_name": "金乡县",
        "parent_id": 370800,
        "level": 3
    },
    {
        "id": 370829,
        "region_name": "嘉祥县",
        "parent_id": 370800,
        "level": 3
    },
    {
        "id": 370830,
        "region_name": "汶上县",
        "parent_id": 370800,
        "level": 3
    },
    {
        "id": 370831,
        "region_name": "泗水县",
        "parent_id": 370800,
        "level": 3
    },
    {
        "id": 370832,
        "region_name": "梁山县",
        "parent_id": 370800,
        "level": 3
    },
    {
        "id": 370881,
        "region_name": "曲阜市",
        "parent_id": 370800,
        "level": 3
    },
    {
        "id": 370883,
        "region_name": "邹城市",
        "parent_id": 370800,
        "level": 3
    },
    {
        "id": 370900,
        "region_name": "泰安市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 370902,
        "region_name": "泰山区",
        "parent_id": 370900,
        "level": 3
    },
    {
        "id": 370911,
        "region_name": "岱岳区",
        "parent_id": 370900,
        "level": 3
    },
    {
        "id": 370921,
        "region_name": "宁阳县",
        "parent_id": 370900,
        "level": 3
    },
    {
        "id": 370923,
        "region_name": "东平县",
        "parent_id": 370900,
        "level": 3
    },
    {
        "id": 370982,
        "region_name": "新泰市",
        "parent_id": 370900,
        "level": 3
    },
    {
        "id": 370983,
        "region_name": "肥城市",
        "parent_id": 370900,
        "level": 3
    },
    {
        "id": 371000,
        "region_name": "威海市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 371002,
        "region_name": "环翠区",
        "parent_id": 371000,
        "level": 3
    },
    {
        "id": 371003,
        "region_name": "文登区",
        "parent_id": 371000,
        "level": 3
    },
    {
        "id": 371082,
        "region_name": "荣成市",
        "parent_id": 371000,
        "level": 3
    },
    {
        "id": 371083,
        "region_name": "乳山市",
        "parent_id": 371000,
        "level": 3
    },
    {
        "id": 371100,
        "region_name": "日照市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 371102,
        "region_name": "东港区",
        "parent_id": 371100,
        "level": 3
    },
    {
        "id": 371103,
        "region_name": "岚山区",
        "parent_id": 371100,
        "level": 3
    },
    {
        "id": 371121,
        "region_name": "五莲县",
        "parent_id": 371100,
        "level": 3
    },
    {
        "id": 371122,
        "region_name": "莒县",
        "parent_id": 371100,
        "level": 3
    },
    {
        "id": 371200,
        "region_name": "莱芜市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 371202,
        "region_name": "莱城区",
        "parent_id": 371200,
        "level": 3
    },
    {
        "id": 371203,
        "region_name": "钢城区",
        "parent_id": 371200,
        "level": 3
    },
    {
        "id": 371300,
        "region_name": "临沂市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 371302,
        "region_name": "兰山区",
        "parent_id": 371300,
        "level": 3
    },
    {
        "id": 371311,
        "region_name": "罗庄区",
        "parent_id": 371300,
        "level": 3
    },
    {
        "id": 371312,
        "region_name": "河东区",
        "parent_id": 371300,
        "level": 3
    },
    {
        "id": 371321,
        "region_name": "沂南县",
        "parent_id": 371300,
        "level": 3
    },
    {
        "id": 371322,
        "region_name": "郯城县",
        "parent_id": 371300,
        "level": 3
    },
    {
        "id": 371323,
        "region_name": "沂水县",
        "parent_id": 371300,
        "level": 3
    },
    {
        "id": 371324,
        "region_name": "兰陵县",
        "parent_id": 371300,
        "level": 3
    },
    {
        "id": 371325,
        "region_name": "费县",
        "parent_id": 371300,
        "level": 3
    },
    {
        "id": 371326,
        "region_name": "平邑县",
        "parent_id": 371300,
        "level": 3
    },
    {
        "id": 371327,
        "region_name": "莒南县",
        "parent_id": 371300,
        "level": 3
    },
    {
        "id": 371328,
        "region_name": "蒙阴县",
        "parent_id": 371300,
        "level": 3
    },
    {
        "id": 371329,
        "region_name": "临沭县",
        "parent_id": 371300,
        "level": 3
    },
    {
        "id": 371400,
        "region_name": "德州市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 371402,
        "region_name": "德城区",
        "parent_id": 371400,
        "level": 3
    },
    {
        "id": 371403,
        "region_name": "陵城区",
        "parent_id": 371400,
        "level": 3
    },
    {
        "id": 371422,
        "region_name": "宁津县",
        "parent_id": 371400,
        "level": 3
    },
    {
        "id": 371423,
        "region_name": "庆云县",
        "parent_id": 371400,
        "level": 3
    },
    {
        "id": 371424,
        "region_name": "临邑县",
        "parent_id": 371400,
        "level": 3
    },
    {
        "id": 371425,
        "region_name": "齐河县",
        "parent_id": 371400,
        "level": 3
    },
    {
        "id": 371426,
        "region_name": "平原县",
        "parent_id": 371400,
        "level": 3
    },
    {
        "id": 371427,
        "region_name": "夏津县",
        "parent_id": 371400,
        "level": 3
    },
    {
        "id": 371428,
        "region_name": "武城县",
        "parent_id": 371400,
        "level": 3
    },
    {
        "id": 371481,
        "region_name": "乐陵市",
        "parent_id": 371400,
        "level": 3
    },
    {
        "id": 371482,
        "region_name": "禹城市",
        "parent_id": 371400,
        "level": 3
    },
    {
        "id": 371500,
        "region_name": "聊城市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 371502,
        "region_name": "东昌府区",
        "parent_id": 371500,
        "level": 3
    },
    {
        "id": 371521,
        "region_name": "阳谷县",
        "parent_id": 371500,
        "level": 3
    },
    {
        "id": 371522,
        "region_name": "莘县",
        "parent_id": 371500,
        "level": 3
    },
    {
        "id": 371523,
        "region_name": "茌平县",
        "parent_id": 371500,
        "level": 3
    },
    {
        "id": 371524,
        "region_name": "东阿县",
        "parent_id": 371500,
        "level": 3
    },
    {
        "id": 371525,
        "region_name": "冠县",
        "parent_id": 371500,
        "level": 3
    },
    {
        "id": 371526,
        "region_name": "高唐县",
        "parent_id": 371500,
        "level": 3
    },
    {
        "id": 371581,
        "region_name": "临清市",
        "parent_id": 371500,
        "level": 3
    },
    {
        "id": 371600,
        "region_name": "滨州市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 371602,
        "region_name": "滨城区",
        "parent_id": 371600,
        "level": 3
    },
    {
        "id": 371603,
        "region_name": "沾化区",
        "parent_id": 371600,
        "level": 3
    },
    {
        "id": 371621,
        "region_name": "惠民县",
        "parent_id": 371600,
        "level": 3
    },
    {
        "id": 371622,
        "region_name": "阳信县",
        "parent_id": 371600,
        "level": 3
    },
    {
        "id": 371623,
        "region_name": "无棣县",
        "parent_id": 371600,
        "level": 3
    },
    {
        "id": 371625,
        "region_name": "博兴县",
        "parent_id": 371600,
        "level": 3
    },
    {
        "id": 371626,
        "region_name": "邹平县",
        "parent_id": 371600,
        "level": 3
    },
    {
        "id": 371700,
        "region_name": "菏泽市",
        "parent_id": 370000,
        "level": 2
    },
    {
        "id": 371702,
        "region_name": "牡丹区",
        "parent_id": 371700,
        "level": 3
    },
    {
        "id": 371703,
        "region_name": "定陶区",
        "parent_id": 371700,
        "level": 3
    },
    {
        "id": 371721,
        "region_name": "曹县",
        "parent_id": 371700,
        "level": 3
    },
    {
        "id": 371722,
        "region_name": "单县",
        "parent_id": 371700,
        "level": 3
    },
    {
        "id": 371723,
        "region_name": "成武县",
        "parent_id": 371700,
        "level": 3
    },
    {
        "id": 371724,
        "region_name": "巨野县",
        "parent_id": 371700,
        "level": 3
    },
    {
        "id": 371725,
        "region_name": "郓城县",
        "parent_id": 371700,
        "level": 3
    },
    {
        "id": 371726,
        "region_name": "鄄城县",
        "parent_id": 371700,
        "level": 3
    },
    {
        "id": 371728,
        "region_name": "东明县",
        "parent_id": 371700,
        "level": 3
    },
    {
        "id": 410000,
        "region_name": "河南省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 410100,
        "region_name": "郑州市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 410102,
        "region_name": "中原区",
        "parent_id": 410100,
        "level": 3
    },
    {
        "id": 410103,
        "region_name": "二七区",
        "parent_id": 410100,
        "level": 3
    },
    {
        "id": 410104,
        "region_name": "管城回族区",
        "parent_id": 410100,
        "level": 3
    },
    {
        "id": 410105,
        "region_name": "金水区",
        "parent_id": 410100,
        "level": 3
    },
    {
        "id": 410106,
        "region_name": "上街区",
        "parent_id": 410100,
        "level": 3
    },
    {
        "id": 410108,
        "region_name": "惠济区",
        "parent_id": 410100,
        "level": 3
    },
    {
        "id": 410122,
        "region_name": "中牟县",
        "parent_id": 410100,
        "level": 3
    },
    {
        "id": 410181,
        "region_name": "巩义市",
        "parent_id": 410100,
        "level": 3
    },
    {
        "id": 410182,
        "region_name": "荥阳市",
        "parent_id": 410100,
        "level": 3
    },
    {
        "id": 410183,
        "region_name": "新密市",
        "parent_id": 410100,
        "level": 3
    },
    {
        "id": 410184,
        "region_name": "新郑市",
        "parent_id": 410100,
        "level": 3
    },
    {
        "id": 410185,
        "region_name": "登封市",
        "parent_id": 410100,
        "level": 3
    },
    {
        "id": 410200,
        "region_name": "开封市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 410202,
        "region_name": "龙亭区",
        "parent_id": 410200,
        "level": 3
    },
    {
        "id": 410203,
        "region_name": "顺河回族区",
        "parent_id": 410200,
        "level": 3
    },
    {
        "id": 410204,
        "region_name": "鼓楼区",
        "parent_id": 410200,
        "level": 3
    },
    {
        "id": 410205,
        "region_name": "禹王台区",
        "parent_id": 410200,
        "level": 3
    },
    {
        "id": 410212,
        "region_name": "祥符区",
        "parent_id": 410200,
        "level": 3
    },
    {
        "id": 410221,
        "region_name": "杞县",
        "parent_id": 410200,
        "level": 3
    },
    {
        "id": 410222,
        "region_name": "通许县",
        "parent_id": 410200,
        "level": 3
    },
    {
        "id": 410223,
        "region_name": "尉氏县",
        "parent_id": 410200,
        "level": 3
    },
    {
        "id": 410225,
        "region_name": "兰考县",
        "parent_id": 410200,
        "level": 3
    },
    {
        "id": 410300,
        "region_name": "洛阳市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 410302,
        "region_name": "老城区",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410303,
        "region_name": "西工区",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410304,
        "region_name": "瀍河回族区",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410305,
        "region_name": "涧西区",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410306,
        "region_name": "吉利区",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410311,
        "region_name": "洛龙区",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410322,
        "region_name": "孟津县",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410323,
        "region_name": "新安县",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410324,
        "region_name": "栾川县",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410325,
        "region_name": "嵩县",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410326,
        "region_name": "汝阳县",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410327,
        "region_name": "宜阳县",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410328,
        "region_name": "洛宁县",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410329,
        "region_name": "伊川县",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410381,
        "region_name": "偃师市",
        "parent_id": 410300,
        "level": 3
    },
    {
        "id": 410400,
        "region_name": "平顶山市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 410402,
        "region_name": "新华区",
        "parent_id": 410400,
        "level": 3
    },
    {
        "id": 410403,
        "region_name": "卫东区",
        "parent_id": 410400,
        "level": 3
    },
    {
        "id": 410404,
        "region_name": "石龙区",
        "parent_id": 410400,
        "level": 3
    },
    {
        "id": 410411,
        "region_name": "湛河区",
        "parent_id": 410400,
        "level": 3
    },
    {
        "id": 410421,
        "region_name": "宝丰县",
        "parent_id": 410400,
        "level": 3
    },
    {
        "id": 410422,
        "region_name": "叶县",
        "parent_id": 410400,
        "level": 3
    },
    {
        "id": 410423,
        "region_name": "鲁山县",
        "parent_id": 410400,
        "level": 3
    },
    {
        "id": 410425,
        "region_name": "郏县",
        "parent_id": 410400,
        "level": 3
    },
    {
        "id": 410481,
        "region_name": "舞钢市",
        "parent_id": 410400,
        "level": 3
    },
    {
        "id": 410482,
        "region_name": "汝州市",
        "parent_id": 410400,
        "level": 3
    },
    {
        "id": 410500,
        "region_name": "安阳市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 410502,
        "region_name": "文峰区",
        "parent_id": 410500,
        "level": 3
    },
    {
        "id": 410503,
        "region_name": "北关区",
        "parent_id": 410500,
        "level": 3
    },
    {
        "id": 410505,
        "region_name": "殷都区",
        "parent_id": 410500,
        "level": 3
    },
    {
        "id": 410506,
        "region_name": "龙安区",
        "parent_id": 410500,
        "level": 3
    },
    {
        "id": 410522,
        "region_name": "安阳县",
        "parent_id": 410500,
        "level": 3
    },
    {
        "id": 410523,
        "region_name": "汤阴县",
        "parent_id": 410500,
        "level": 3
    },
    {
        "id": 410526,
        "region_name": "滑县",
        "parent_id": 410500,
        "level": 3
    },
    {
        "id": 410527,
        "region_name": "内黄县",
        "parent_id": 410500,
        "level": 3
    },
    {
        "id": 410581,
        "region_name": "林州市",
        "parent_id": 410500,
        "level": 3
    },
    {
        "id": 410600,
        "region_name": "鹤壁市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 410602,
        "region_name": "鹤山区",
        "parent_id": 410600,
        "level": 3
    },
    {
        "id": 410603,
        "region_name": "山城区",
        "parent_id": 410600,
        "level": 3
    },
    {
        "id": 410611,
        "region_name": "淇滨区",
        "parent_id": 410600,
        "level": 3
    },
    {
        "id": 410621,
        "region_name": "浚县",
        "parent_id": 410600,
        "level": 3
    },
    {
        "id": 410622,
        "region_name": "淇县",
        "parent_id": 410600,
        "level": 3
    },
    {
        "id": 410700,
        "region_name": "新乡市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 410702,
        "region_name": "红旗区",
        "parent_id": 410700,
        "level": 3
    },
    {
        "id": 410703,
        "region_name": "卫滨区",
        "parent_id": 410700,
        "level": 3
    },
    {
        "id": 410704,
        "region_name": "凤泉区",
        "parent_id": 410700,
        "level": 3
    },
    {
        "id": 410711,
        "region_name": "牧野区",
        "parent_id": 410700,
        "level": 3
    },
    {
        "id": 410721,
        "region_name": "新乡县",
        "parent_id": 410700,
        "level": 3
    },
    {
        "id": 410724,
        "region_name": "获嘉县",
        "parent_id": 410700,
        "level": 3
    },
    {
        "id": 410725,
        "region_name": "原阳县",
        "parent_id": 410700,
        "level": 3
    },
    {
        "id": 410726,
        "region_name": "延津县",
        "parent_id": 410700,
        "level": 3
    },
    {
        "id": 410727,
        "region_name": "封丘县",
        "parent_id": 410700,
        "level": 3
    },
    {
        "id": 410728,
        "region_name": "长垣县",
        "parent_id": 410700,
        "level": 3
    },
    {
        "id": 410781,
        "region_name": "卫辉市",
        "parent_id": 410700,
        "level": 3
    },
    {
        "id": 410782,
        "region_name": "辉县市",
        "parent_id": 410700,
        "level": 3
    },
    {
        "id": 410800,
        "region_name": "焦作市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 410802,
        "region_name": "解放区",
        "parent_id": 410800,
        "level": 3
    },
    {
        "id": 410803,
        "region_name": "中站区",
        "parent_id": 410800,
        "level": 3
    },
    {
        "id": 410804,
        "region_name": "马村区",
        "parent_id": 410800,
        "level": 3
    },
    {
        "id": 410811,
        "region_name": "山阳区",
        "parent_id": 410800,
        "level": 3
    },
    {
        "id": 410821,
        "region_name": "修武县",
        "parent_id": 410800,
        "level": 3
    },
    {
        "id": 410822,
        "region_name": "博爱县",
        "parent_id": 410800,
        "level": 3
    },
    {
        "id": 410823,
        "region_name": "武陟县",
        "parent_id": 410800,
        "level": 3
    },
    {
        "id": 410825,
        "region_name": "温县",
        "parent_id": 410800,
        "level": 3
    },
    {
        "id": 410882,
        "region_name": "沁阳市",
        "parent_id": 410800,
        "level": 3
    },
    {
        "id": 410883,
        "region_name": "孟州市",
        "parent_id": 410800,
        "level": 3
    },
    {
        "id": 410900,
        "region_name": "濮阳市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 410902,
        "region_name": "华龙区",
        "parent_id": 410900,
        "level": 3
    },
    {
        "id": 410922,
        "region_name": "清丰县",
        "parent_id": 410900,
        "level": 3
    },
    {
        "id": 410923,
        "region_name": "南乐县",
        "parent_id": 410900,
        "level": 3
    },
    {
        "id": 410926,
        "region_name": "范县",
        "parent_id": 410900,
        "level": 3
    },
    {
        "id": 410927,
        "region_name": "台前县",
        "parent_id": 410900,
        "level": 3
    },
    {
        "id": 410928,
        "region_name": "濮阳县",
        "parent_id": 410900,
        "level": 3
    },
    {
        "id": 411000,
        "region_name": "许昌市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 411002,
        "region_name": "魏都区",
        "parent_id": 411000,
        "level": 3
    },
    {
        "id": 411003,
        "region_name": "建安区",
        "parent_id": 411000,
        "level": 3
    },
    {
        "id": 411024,
        "region_name": "鄢陵县",
        "parent_id": 411000,
        "level": 3
    },
    {
        "id": 411025,
        "region_name": "襄城县",
        "parent_id": 411000,
        "level": 3
    },
    {
        "id": 411081,
        "region_name": "禹州市",
        "parent_id": 411000,
        "level": 3
    },
    {
        "id": 411082,
        "region_name": "长葛市",
        "parent_id": 411000,
        "level": 3
    },
    {
        "id": 411100,
        "region_name": "漯河市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 411102,
        "region_name": "源汇区",
        "parent_id": 411100,
        "level": 3
    },
    {
        "id": 411103,
        "region_name": "郾城区",
        "parent_id": 411100,
        "level": 3
    },
    {
        "id": 411104,
        "region_name": "召陵区",
        "parent_id": 411100,
        "level": 3
    },
    {
        "id": 411121,
        "region_name": "舞阳县",
        "parent_id": 411100,
        "level": 3
    },
    {
        "id": 411122,
        "region_name": "临颍县",
        "parent_id": 411100,
        "level": 3
    },
    {
        "id": 411200,
        "region_name": "三门峡市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 411202,
        "region_name": "湖滨区",
        "parent_id": 411200,
        "level": 3
    },
    {
        "id": 411203,
        "region_name": "陕州区",
        "parent_id": 411200,
        "level": 3
    },
    {
        "id": 411221,
        "region_name": "渑池县",
        "parent_id": 411200,
        "level": 3
    },
    {
        "id": 411224,
        "region_name": "卢氏县",
        "parent_id": 411200,
        "level": 3
    },
    {
        "id": 411281,
        "region_name": "义马市",
        "parent_id": 411200,
        "level": 3
    },
    {
        "id": 411282,
        "region_name": "灵宝市",
        "parent_id": 411200,
        "level": 3
    },
    {
        "id": 411300,
        "region_name": "南阳市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 411302,
        "region_name": "宛城区",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411303,
        "region_name": "卧龙区",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411321,
        "region_name": "南召县",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411322,
        "region_name": "方城县",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411323,
        "region_name": "西峡县",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411324,
        "region_name": "镇平县",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411325,
        "region_name": "内乡县",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411326,
        "region_name": "淅川县",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411327,
        "region_name": "社旗县",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411328,
        "region_name": "唐河县",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411329,
        "region_name": "新野县",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411330,
        "region_name": "桐柏县",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411381,
        "region_name": "邓州市",
        "parent_id": 411300,
        "level": 3
    },
    {
        "id": 411400,
        "region_name": "商丘市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 411402,
        "region_name": "梁园区",
        "parent_id": 411400,
        "level": 3
    },
    {
        "id": 411403,
        "region_name": "睢阳区",
        "parent_id": 411400,
        "level": 3
    },
    {
        "id": 411421,
        "region_name": "民权县",
        "parent_id": 411400,
        "level": 3
    },
    {
        "id": 411422,
        "region_name": "睢县",
        "parent_id": 411400,
        "level": 3
    },
    {
        "id": 411423,
        "region_name": "宁陵县",
        "parent_id": 411400,
        "level": 3
    },
    {
        "id": 411424,
        "region_name": "柘城县",
        "parent_id": 411400,
        "level": 3
    },
    {
        "id": 411425,
        "region_name": "虞城县",
        "parent_id": 411400,
        "level": 3
    },
    {
        "id": 411426,
        "region_name": "夏邑县",
        "parent_id": 411400,
        "level": 3
    },
    {
        "id": 411481,
        "region_name": "永城市",
        "parent_id": 411400,
        "level": 3
    },
    {
        "id": 411500,
        "region_name": "信阳市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 411502,
        "region_name": "浉河区",
        "parent_id": 411500,
        "level": 3
    },
    {
        "id": 411503,
        "region_name": "平桥区",
        "parent_id": 411500,
        "level": 3
    },
    {
        "id": 411521,
        "region_name": "罗山县",
        "parent_id": 411500,
        "level": 3
    },
    {
        "id": 411522,
        "region_name": "光山县",
        "parent_id": 411500,
        "level": 3
    },
    {
        "id": 411523,
        "region_name": "新县",
        "parent_id": 411500,
        "level": 3
    },
    {
        "id": 411524,
        "region_name": "商城县",
        "parent_id": 411500,
        "level": 3
    },
    {
        "id": 411525,
        "region_name": "固始县",
        "parent_id": 411500,
        "level": 3
    },
    {
        "id": 411526,
        "region_name": "潢川县",
        "parent_id": 411500,
        "level": 3
    },
    {
        "id": 411527,
        "region_name": "淮滨县",
        "parent_id": 411500,
        "level": 3
    },
    {
        "id": 411528,
        "region_name": "息县",
        "parent_id": 411500,
        "level": 3
    },
    {
        "id": 411600,
        "region_name": "周口市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 411602,
        "region_name": "川汇区",
        "parent_id": 411600,
        "level": 3
    },
    {
        "id": 411621,
        "region_name": "扶沟县",
        "parent_id": 411600,
        "level": 3
    },
    {
        "id": 411622,
        "region_name": "西华县",
        "parent_id": 411600,
        "level": 3
    },
    {
        "id": 411623,
        "region_name": "商水县",
        "parent_id": 411600,
        "level": 3
    },
    {
        "id": 411624,
        "region_name": "沈丘县",
        "parent_id": 411600,
        "level": 3
    },
    {
        "id": 411625,
        "region_name": "郸城县",
        "parent_id": 411600,
        "level": 3
    },
    {
        "id": 411626,
        "region_name": "淮阳县",
        "parent_id": 411600,
        "level": 3
    },
    {
        "id": 411627,
        "region_name": "太康县",
        "parent_id": 411600,
        "level": 3
    },
    {
        "id": 411628,
        "region_name": "鹿邑县",
        "parent_id": 411600,
        "level": 3
    },
    {
        "id": 411681,
        "region_name": "项城市",
        "parent_id": 411600,
        "level": 3
    },
    {
        "id": 411700,
        "region_name": "驻马店市",
        "parent_id": 410000,
        "level": 2
    },
    {
        "id": 411702,
        "region_name": "驿城区",
        "parent_id": 411700,
        "level": 3
    },
    {
        "id": 411721,
        "region_name": "西平县",
        "parent_id": 411700,
        "level": 3
    },
    {
        "id": 411722,
        "region_name": "上蔡县",
        "parent_id": 411700,
        "level": 3
    },
    {
        "id": 411723,
        "region_name": "平舆县",
        "parent_id": 411700,
        "level": 3
    },
    {
        "id": 411724,
        "region_name": "正阳县",
        "parent_id": 411700,
        "level": 3
    },
    {
        "id": 411725,
        "region_name": "确山县",
        "parent_id": 411700,
        "level": 3
    },
    {
        "id": 411726,
        "region_name": "泌阳县",
        "parent_id": 411700,
        "level": 3
    },
    {
        "id": 411727,
        "region_name": "汝南县",
        "parent_id": 411700,
        "level": 3
    },
    {
        "id": 411728,
        "region_name": "遂平县",
        "parent_id": 411700,
        "level": 3
    },
    {
        "id": 411729,
        "region_name": "新蔡县",
        "parent_id": 411700,
        "level": 3
    },
    {
        "id": 419001,
        "region_name": "济源市",
        "parent_id": 419000,
        "level": 3
    },
    {
        "id": 420000,
        "region_name": "湖北省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 420100,
        "region_name": "武汉市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 420102,
        "region_name": "江岸区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420103,
        "region_name": "江汉区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420104,
        "region_name": "硚口区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420105,
        "region_name": "汉阳区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420106,
        "region_name": "武昌区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420107,
        "region_name": "青山区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420111,
        "region_name": "洪山区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420112,
        "region_name": "东西湖区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420113,
        "region_name": "汉南区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420114,
        "region_name": "蔡甸区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420115,
        "region_name": "江夏区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420116,
        "region_name": "黄陂区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420117,
        "region_name": "新洲区",
        "parent_id": 420100,
        "level": 3
    },
    {
        "id": 420200,
        "region_name": "黄石市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 420202,
        "region_name": "黄石港区",
        "parent_id": 420200,
        "level": 3
    },
    {
        "id": 420203,
        "region_name": "西塞山区",
        "parent_id": 420200,
        "level": 3
    },
    {
        "id": 420204,
        "region_name": "下陆区",
        "parent_id": 420200,
        "level": 3
    },
    {
        "id": 420205,
        "region_name": "铁山区",
        "parent_id": 420200,
        "level": 3
    },
    {
        "id": 420222,
        "region_name": "阳新县",
        "parent_id": 420200,
        "level": 3
    },
    {
        "id": 420281,
        "region_name": "大冶市",
        "parent_id": 420200,
        "level": 3
    },
    {
        "id": 420300,
        "region_name": "十堰市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 420302,
        "region_name": "茅箭区",
        "parent_id": 420300,
        "level": 3
    },
    {
        "id": 420303,
        "region_name": "张湾区",
        "parent_id": 420300,
        "level": 3
    },
    {
        "id": 420304,
        "region_name": "郧阳区",
        "parent_id": 420300,
        "level": 3
    },
    {
        "id": 420322,
        "region_name": "郧西县",
        "parent_id": 420300,
        "level": 3
    },
    {
        "id": 420323,
        "region_name": "竹山县",
        "parent_id": 420300,
        "level": 3
    },
    {
        "id": 420324,
        "region_name": "竹溪县",
        "parent_id": 420300,
        "level": 3
    },
    {
        "id": 420325,
        "region_name": "房县",
        "parent_id": 420300,
        "level": 3
    },
    {
        "id": 420381,
        "region_name": "丹江口市",
        "parent_id": 420300,
        "level": 3
    },
    {
        "id": 420500,
        "region_name": "宜昌市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 420502,
        "region_name": "西陵区",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420503,
        "region_name": "伍家岗区",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420504,
        "region_name": "点军区",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420505,
        "region_name": "猇亭区",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420506,
        "region_name": "夷陵区",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420525,
        "region_name": "远安县",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420526,
        "region_name": "兴山县",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420527,
        "region_name": "秭归县",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420528,
        "region_name": "长阳土家族自治县",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420529,
        "region_name": "五峰土家族自治县",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420581,
        "region_name": "宜都市",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420582,
        "region_name": "当阳市",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420583,
        "region_name": "枝江市",
        "parent_id": 420500,
        "level": 3
    },
    {
        "id": 420600,
        "region_name": "襄阳市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 420602,
        "region_name": "襄城区",
        "parent_id": 420600,
        "level": 3
    },
    {
        "id": 420606,
        "region_name": "樊城区",
        "parent_id": 420600,
        "level": 3
    },
    {
        "id": 420607,
        "region_name": "襄州区",
        "parent_id": 420600,
        "level": 3
    },
    {
        "id": 420624,
        "region_name": "南漳县",
        "parent_id": 420600,
        "level": 3
    },
    {
        "id": 420625,
        "region_name": "谷城县",
        "parent_id": 420600,
        "level": 3
    },
    {
        "id": 420626,
        "region_name": "保康县",
        "parent_id": 420600,
        "level": 3
    },
    {
        "id": 420682,
        "region_name": "老河口市",
        "parent_id": 420600,
        "level": 3
    },
    {
        "id": 420683,
        "region_name": "枣阳市",
        "parent_id": 420600,
        "level": 3
    },
    {
        "id": 420684,
        "region_name": "宜城市",
        "parent_id": 420600,
        "level": 3
    },
    {
        "id": 420700,
        "region_name": "鄂州市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 420702,
        "region_name": "梁子湖区",
        "parent_id": 420700,
        "level": 3
    },
    {
        "id": 420703,
        "region_name": "华容区",
        "parent_id": 420700,
        "level": 3
    },
    {
        "id": 420704,
        "region_name": "鄂城区",
        "parent_id": 420700,
        "level": 3
    },
    {
        "id": 420800,
        "region_name": "荆门市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 420802,
        "region_name": "东宝区",
        "parent_id": 420800,
        "level": 3
    },
    {
        "id": 420804,
        "region_name": "掇刀区",
        "parent_id": 420800,
        "level": 3
    },
    {
        "id": 420821,
        "region_name": "京山县",
        "parent_id": 420800,
        "level": 3
    },
    {
        "id": 420822,
        "region_name": "沙洋县",
        "parent_id": 420800,
        "level": 3
    },
    {
        "id": 420881,
        "region_name": "钟祥市",
        "parent_id": 420800,
        "level": 3
    },
    {
        "id": 420900,
        "region_name": "孝感市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 420902,
        "region_name": "孝南区",
        "parent_id": 420900,
        "level": 3
    },
    {
        "id": 420921,
        "region_name": "孝昌县",
        "parent_id": 420900,
        "level": 3
    },
    {
        "id": 420922,
        "region_name": "大悟县",
        "parent_id": 420900,
        "level": 3
    },
    {
        "id": 420923,
        "region_name": "云梦县",
        "parent_id": 420900,
        "level": 3
    },
    {
        "id": 420981,
        "region_name": "应城市",
        "parent_id": 420900,
        "level": 3
    },
    {
        "id": 420982,
        "region_name": "安陆市",
        "parent_id": 420900,
        "level": 3
    },
    {
        "id": 420984,
        "region_name": "汉川市",
        "parent_id": 420900,
        "level": 3
    },
    {
        "id": 421000,
        "region_name": "荆州市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 421002,
        "region_name": "沙市区",
        "parent_id": 421000,
        "level": 3
    },
    {
        "id": 421003,
        "region_name": "荆州区",
        "parent_id": 421000,
        "level": 3
    },
    {
        "id": 421022,
        "region_name": "公安县",
        "parent_id": 421000,
        "level": 3
    },
    {
        "id": 421023,
        "region_name": "监利县",
        "parent_id": 421000,
        "level": 3
    },
    {
        "id": 421024,
        "region_name": "江陵县",
        "parent_id": 421000,
        "level": 3
    },
    {
        "id": 421081,
        "region_name": "石首市",
        "parent_id": 421000,
        "level": 3
    },
    {
        "id": 421083,
        "region_name": "洪湖市",
        "parent_id": 421000,
        "level": 3
    },
    {
        "id": 421087,
        "region_name": "松滋市",
        "parent_id": 421000,
        "level": 3
    },
    {
        "id": 421100,
        "region_name": "黄冈市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 421102,
        "region_name": "黄州区",
        "parent_id": 421100,
        "level": 3
    },
    {
        "id": 421121,
        "region_name": "团风县",
        "parent_id": 421100,
        "level": 3
    },
    {
        "id": 421122,
        "region_name": "红安县",
        "parent_id": 421100,
        "level": 3
    },
    {
        "id": 421123,
        "region_name": "罗田县",
        "parent_id": 421100,
        "level": 3
    },
    {
        "id": 421124,
        "region_name": "英山县",
        "parent_id": 421100,
        "level": 3
    },
    {
        "id": 421125,
        "region_name": "浠水县",
        "parent_id": 421100,
        "level": 3
    },
    {
        "id": 421126,
        "region_name": "蕲春县",
        "parent_id": 421100,
        "level": 3
    },
    {
        "id": 421127,
        "region_name": "黄梅县",
        "parent_id": 421100,
        "level": 3
    },
    {
        "id": 421181,
        "region_name": "麻城市",
        "parent_id": 421100,
        "level": 3
    },
    {
        "id": 421182,
        "region_name": "武穴市",
        "parent_id": 421100,
        "level": 3
    },
    {
        "id": 421200,
        "region_name": "咸宁市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 421202,
        "region_name": "咸安区",
        "parent_id": 421200,
        "level": 3
    },
    {
        "id": 421221,
        "region_name": "嘉鱼县",
        "parent_id": 421200,
        "level": 3
    },
    {
        "id": 421222,
        "region_name": "通城县",
        "parent_id": 421200,
        "level": 3
    },
    {
        "id": 421223,
        "region_name": "崇阳县",
        "parent_id": 421200,
        "level": 3
    },
    {
        "id": 421224,
        "region_name": "通山县",
        "parent_id": 421200,
        "level": 3
    },
    {
        "id": 421281,
        "region_name": "赤壁市",
        "parent_id": 421200,
        "level": 3
    },
    {
        "id": 421300,
        "region_name": "随州市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 421303,
        "region_name": "曾都区",
        "parent_id": 421300,
        "level": 3
    },
    {
        "id": 421321,
        "region_name": "随县",
        "parent_id": 421300,
        "level": 3
    },
    {
        "id": 421381,
        "region_name": "广水市",
        "parent_id": 421300,
        "level": 3
    },
    {
        "id": 422800,
        "region_name": "恩施土家族苗族自治州",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 422801,
        "region_name": "恩施市",
        "parent_id": 422800,
        "level": 3
    },
    {
        "id": 422802,
        "region_name": "利川市",
        "parent_id": 422800,
        "level": 3
    },
    {
        "id": 422822,
        "region_name": "建始县",
        "parent_id": 422800,
        "level": 3
    },
    {
        "id": 422823,
        "region_name": "巴东县",
        "parent_id": 422800,
        "level": 3
    },
    {
        "id": 422825,
        "region_name": "宣恩县",
        "parent_id": 422800,
        "level": 3
    },
    {
        "id": 422826,
        "region_name": "咸丰县",
        "parent_id": 422800,
        "level": 3
    },
    {
        "id": 422827,
        "region_name": "来凤县",
        "parent_id": 422800,
        "level": 3
    },
    {
        "id": 422828,
        "region_name": "鹤峰县",
        "parent_id": 422800,
        "level": 3
    },
    {
        "id": 429000,
        "region_name": "直辖县市",
        "parent_id": 420000,
        "level": 2
    },
    {
        "id": 429004,
        "region_name": "仙桃市",
        "parent_id": 429000,
        "level": 3
    },
    {
        "id": 429005,
        "region_name": "潜江市",
        "parent_id": 429000,
        "level": 3
    },
    {
        "id": 429006,
        "region_name": "天门市",
        "parent_id": 429000,
        "level": 3
    },
    {
        "id": 429021,
        "region_name": "神农架林区",
        "parent_id": 429000,
        "level": 3
    },
    {
        "id": 430000,
        "region_name": "湖南省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 430100,
        "region_name": "长沙市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 430102,
        "region_name": "芙蓉区",
        "parent_id": 430100,
        "level": 3
    },
    {
        "id": 430103,
        "region_name": "天心区",
        "parent_id": 430100,
        "level": 3
    },
    {
        "id": 430104,
        "region_name": "岳麓区",
        "parent_id": 430100,
        "level": 3
    },
    {
        "id": 430105,
        "region_name": "开福区",
        "parent_id": 430100,
        "level": 3
    },
    {
        "id": 430111,
        "region_name": "雨花区",
        "parent_id": 430100,
        "level": 3
    },
    {
        "id": 430112,
        "region_name": "望城区",
        "parent_id": 430100,
        "level": 3
    },
    {
        "id": 430121,
        "region_name": "长沙县",
        "parent_id": 430100,
        "level": 3
    },
    {
        "id": 430181,
        "region_name": "浏阳市",
        "parent_id": 430100,
        "level": 3
    },
    {
        "id": 430182,
        "region_name": "宁乡市",
        "parent_id": 430100,
        "level": 3
    },
    {
        "id": 430200,
        "region_name": "株洲市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 430202,
        "region_name": "荷塘区",
        "parent_id": 430200,
        "level": 3
    },
    {
        "id": 430203,
        "region_name": "芦淞区",
        "parent_id": 430200,
        "level": 3
    },
    {
        "id": 430204,
        "region_name": "石峰区",
        "parent_id": 430200,
        "level": 3
    },
    {
        "id": 430211,
        "region_name": "天元区",
        "parent_id": 430200,
        "level": 3
    },
    {
        "id": 430221,
        "region_name": "株洲县",
        "parent_id": 430200,
        "level": 3
    },
    {
        "id": 430223,
        "region_name": "攸县",
        "parent_id": 430200,
        "level": 3
    },
    {
        "id": 430224,
        "region_name": "茶陵县",
        "parent_id": 430200,
        "level": 3
    },
    {
        "id": 430225,
        "region_name": "炎陵县",
        "parent_id": 430200,
        "level": 3
    },
    {
        "id": 430281,
        "region_name": "醴陵市",
        "parent_id": 430200,
        "level": 3
    },
    {
        "id": 430300,
        "region_name": "湘潭市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 430302,
        "region_name": "雨湖区",
        "parent_id": 430300,
        "level": 3
    },
    {
        "id": 430304,
        "region_name": "岳塘区",
        "parent_id": 430300,
        "level": 3
    },
    {
        "id": 430321,
        "region_name": "湘潭县",
        "parent_id": 430300,
        "level": 3
    },
    {
        "id": 430381,
        "region_name": "湘乡市",
        "parent_id": 430300,
        "level": 3
    },
    {
        "id": 430382,
        "region_name": "韶山市",
        "parent_id": 430300,
        "level": 3
    },
    {
        "id": 430400,
        "region_name": "衡阳市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 430405,
        "region_name": "珠晖区",
        "parent_id": 430400,
        "level": 3
    },
    {
        "id": 430406,
        "region_name": "雁峰区",
        "parent_id": 430400,
        "level": 3
    },
    {
        "id": 430407,
        "region_name": "石鼓区",
        "parent_id": 430400,
        "level": 3
    },
    {
        "id": 430408,
        "region_name": "蒸湘区",
        "parent_id": 430400,
        "level": 3
    },
    {
        "id": 430412,
        "region_name": "南岳区",
        "parent_id": 430400,
        "level": 3
    },
    {
        "id": 430421,
        "region_name": "衡阳县",
        "parent_id": 430400,
        "level": 3
    },
    {
        "id": 430422,
        "region_name": "衡南县",
        "parent_id": 430400,
        "level": 3
    },
    {
        "id": 430423,
        "region_name": "衡山县",
        "parent_id": 430400,
        "level": 3
    },
    {
        "id": 430424,
        "region_name": "衡东县",
        "parent_id": 430400,
        "level": 3
    },
    {
        "id": 430426,
        "region_name": "祁东县",
        "parent_id": 430400,
        "level": 3
    },
    {
        "id": 430481,
        "region_name": "耒阳市",
        "parent_id": 430400,
        "level": 3
    },
    {
        "id": 430482,
        "region_name": "常宁市",
        "parent_id": 430400,
        "level": 3
    },
    {
        "id": 430500,
        "region_name": "邵阳市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 430502,
        "region_name": "双清区",
        "parent_id": 430500,
        "level": 3
    },
    {
        "id": 430503,
        "region_name": "大祥区",
        "parent_id": 430500,
        "level": 3
    },
    {
        "id": 430511,
        "region_name": "北塔区",
        "parent_id": 430500,
        "level": 3
    },
    {
        "id": 430521,
        "region_name": "邵东县",
        "parent_id": 430500,
        "level": 3
    },
    {
        "id": 430522,
        "region_name": "新邵县",
        "parent_id": 430500,
        "level": 3
    },
    {
        "id": 430523,
        "region_name": "邵阳县",
        "parent_id": 430500,
        "level": 3
    },
    {
        "id": 430524,
        "region_name": "隆回县",
        "parent_id": 430500,
        "level": 3
    },
    {
        "id": 430525,
        "region_name": "洞口县",
        "parent_id": 430500,
        "level": 3
    },
    {
        "id": 430527,
        "region_name": "绥宁县",
        "parent_id": 430500,
        "level": 3
    },
    {
        "id": 430528,
        "region_name": "新宁县",
        "parent_id": 430500,
        "level": 3
    },
    {
        "id": 430529,
        "region_name": "城步苗族自治县",
        "parent_id": 430500,
        "level": 3
    },
    {
        "id": 430581,
        "region_name": "武冈市",
        "parent_id": 430500,
        "level": 3
    },
    {
        "id": 430600,
        "region_name": "岳阳市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 430602,
        "region_name": "岳阳楼区",
        "parent_id": 430600,
        "level": 3
    },
    {
        "id": 430603,
        "region_name": "云溪区",
        "parent_id": 430600,
        "level": 3
    },
    {
        "id": 430611,
        "region_name": "君山区",
        "parent_id": 430600,
        "level": 3
    },
    {
        "id": 430621,
        "region_name": "岳阳县",
        "parent_id": 430600,
        "level": 3
    },
    {
        "id": 430623,
        "region_name": "华容县",
        "parent_id": 430600,
        "level": 3
    },
    {
        "id": 430624,
        "region_name": "湘阴县",
        "parent_id": 430600,
        "level": 3
    },
    {
        "id": 430626,
        "region_name": "平江县",
        "parent_id": 430600,
        "level": 3
    },
    {
        "id": 430681,
        "region_name": "汨罗市",
        "parent_id": 430600,
        "level": 3
    },
    {
        "id": 430682,
        "region_name": "临湘市",
        "parent_id": 430600,
        "level": 3
    },
    {
        "id": 430700,
        "region_name": "常德市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 430702,
        "region_name": "武陵区",
        "parent_id": 430700,
        "level": 3
    },
    {
        "id": 430703,
        "region_name": "鼎城区",
        "parent_id": 430700,
        "level": 3
    },
    {
        "id": 430721,
        "region_name": "安乡县",
        "parent_id": 430700,
        "level": 3
    },
    {
        "id": 430722,
        "region_name": "汉寿县",
        "parent_id": 430700,
        "level": 3
    },
    {
        "id": 430723,
        "region_name": "澧县",
        "parent_id": 430700,
        "level": 3
    },
    {
        "id": 430724,
        "region_name": "临澧县",
        "parent_id": 430700,
        "level": 3
    },
    {
        "id": 430725,
        "region_name": "桃源县",
        "parent_id": 430700,
        "level": 3
    },
    {
        "id": 430726,
        "region_name": "石门县",
        "parent_id": 430700,
        "level": 3
    },
    {
        "id": 430781,
        "region_name": "津市市",
        "parent_id": 430700,
        "level": 3
    },
    {
        "id": 430800,
        "region_name": "张家界市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 430802,
        "region_name": "永定区",
        "parent_id": 430800,
        "level": 3
    },
    {
        "id": 430811,
        "region_name": "武陵源区",
        "parent_id": 430800,
        "level": 3
    },
    {
        "id": 430821,
        "region_name": "慈利县",
        "parent_id": 430800,
        "level": 3
    },
    {
        "id": 430822,
        "region_name": "桑植县",
        "parent_id": 430800,
        "level": 3
    },
    {
        "id": 430900,
        "region_name": "益阳市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 430902,
        "region_name": "资阳区",
        "parent_id": 430900,
        "level": 3
    },
    {
        "id": 430903,
        "region_name": "赫山区",
        "parent_id": 430900,
        "level": 3
    },
    {
        "id": 430921,
        "region_name": "南县",
        "parent_id": 430900,
        "level": 3
    },
    {
        "id": 430922,
        "region_name": "桃江县",
        "parent_id": 430900,
        "level": 3
    },
    {
        "id": 430923,
        "region_name": "安化县",
        "parent_id": 430900,
        "level": 3
    },
    {
        "id": 430981,
        "region_name": "沅江市",
        "parent_id": 430900,
        "level": 3
    },
    {
        "id": 431000,
        "region_name": "郴州市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 431002,
        "region_name": "北湖区",
        "parent_id": 431000,
        "level": 3
    },
    {
        "id": 431003,
        "region_name": "苏仙区",
        "parent_id": 431000,
        "level": 3
    },
    {
        "id": 431021,
        "region_name": "桂阳县",
        "parent_id": 431000,
        "level": 3
    },
    {
        "id": 431022,
        "region_name": "宜章县",
        "parent_id": 431000,
        "level": 3
    },
    {
        "id": 431023,
        "region_name": "永兴县",
        "parent_id": 431000,
        "level": 3
    },
    {
        "id": 431024,
        "region_name": "嘉禾县",
        "parent_id": 431000,
        "level": 3
    },
    {
        "id": 431025,
        "region_name": "临武县",
        "parent_id": 431000,
        "level": 3
    },
    {
        "id": 431026,
        "region_name": "汝城县",
        "parent_id": 431000,
        "level": 3
    },
    {
        "id": 431027,
        "region_name": "桂东县",
        "parent_id": 431000,
        "level": 3
    },
    {
        "id": 431028,
        "region_name": "安仁县",
        "parent_id": 431000,
        "level": 3
    },
    {
        "id": 431081,
        "region_name": "资兴市",
        "parent_id": 431000,
        "level": 3
    },
    {
        "id": 431100,
        "region_name": "永州市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 431102,
        "region_name": "零陵区",
        "parent_id": 431100,
        "level": 3
    },
    {
        "id": 431103,
        "region_name": "冷水滩区",
        "parent_id": 431100,
        "level": 3
    },
    {
        "id": 431121,
        "region_name": "祁阳县",
        "parent_id": 431100,
        "level": 3
    },
    {
        "id": 431122,
        "region_name": "东安县",
        "parent_id": 431100,
        "level": 3
    },
    {
        "id": 431123,
        "region_name": "双牌县",
        "parent_id": 431100,
        "level": 3
    },
    {
        "id": 431124,
        "region_name": "道县",
        "parent_id": 431100,
        "level": 3
    },
    {
        "id": 431125,
        "region_name": "江永县",
        "parent_id": 431100,
        "level": 3
    },
    {
        "id": 431126,
        "region_name": "宁远县",
        "parent_id": 431100,
        "level": 3
    },
    {
        "id": 431127,
        "region_name": "蓝山县",
        "parent_id": 431100,
        "level": 3
    },
    {
        "id": 431128,
        "region_name": "新田县",
        "parent_id": 431100,
        "level": 3
    },
    {
        "id": 431129,
        "region_name": "江华瑶族自治县",
        "parent_id": 431100,
        "level": 3
    },
    {
        "id": 431200,
        "region_name": "怀化市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 431202,
        "region_name": "鹤城区",
        "parent_id": 431200,
        "level": 3
    },
    {
        "id": 431221,
        "region_name": "中方县",
        "parent_id": 431200,
        "level": 3
    },
    {
        "id": 431222,
        "region_name": "沅陵县",
        "parent_id": 431200,
        "level": 3
    },
    {
        "id": 431223,
        "region_name": "辰溪县",
        "parent_id": 431200,
        "level": 3
    },
    {
        "id": 431224,
        "region_name": "溆浦县",
        "parent_id": 431200,
        "level": 3
    },
    {
        "id": 431225,
        "region_name": "会同县",
        "parent_id": 431200,
        "level": 3
    },
    {
        "id": 431226,
        "region_name": "麻阳苗族自治县",
        "parent_id": 431200,
        "level": 3
    },
    {
        "id": 431227,
        "region_name": "新晃侗族自治县",
        "parent_id": 431200,
        "level": 3
    },
    {
        "id": 431228,
        "region_name": "芷江侗族自治县",
        "parent_id": 431200,
        "level": 3
    },
    {
        "id": 431229,
        "region_name": "靖州苗族侗族自治县",
        "parent_id": 431200,
        "level": 3
    },
    {
        "id": 431230,
        "region_name": "通道侗族自治县",
        "parent_id": 431200,
        "level": 3
    },
    {
        "id": 431281,
        "region_name": "洪江市",
        "parent_id": 431200,
        "level": 3
    },
    {
        "id": 431300,
        "region_name": "娄底市",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 431302,
        "region_name": "娄星区",
        "parent_id": 431300,
        "level": 3
    },
    {
        "id": 431321,
        "region_name": "双峰县",
        "parent_id": 431300,
        "level": 3
    },
    {
        "id": 431322,
        "region_name": "新化县",
        "parent_id": 431300,
        "level": 3
    },
    {
        "id": 431381,
        "region_name": "冷水江市",
        "parent_id": 431300,
        "level": 3
    },
    {
        "id": 431382,
        "region_name": "涟源市",
        "parent_id": 431300,
        "level": 3
    },
    {
        "id": 433100,
        "region_name": "湘西土家族苗族自治州",
        "parent_id": 430000,
        "level": 2
    },
    {
        "id": 433101,
        "region_name": "吉首市",
        "parent_id": 433100,
        "level": 3
    },
    {
        "id": 433122,
        "region_name": "泸溪县",
        "parent_id": 433100,
        "level": 3
    },
    {
        "id": 433123,
        "region_name": "凤凰县",
        "parent_id": 433100,
        "level": 3
    },
    {
        "id": 433124,
        "region_name": "花垣县",
        "parent_id": 433100,
        "level": 3
    },
    {
        "id": 433125,
        "region_name": "保靖县",
        "parent_id": 433100,
        "level": 3
    },
    {
        "id": 433126,
        "region_name": "古丈县",
        "parent_id": 433100,
        "level": 3
    },
    {
        "id": 433127,
        "region_name": "永顺县",
        "parent_id": 433100,
        "level": 3
    },
    {
        "id": 433130,
        "region_name": "龙山县",
        "parent_id": 433100,
        "level": 3
    },
    {
        "id": 440000,
        "region_name": "广东省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 440100,
        "region_name": "广州市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 440103,
        "region_name": "荔湾区",
        "parent_id": 440100,
        "level": 3
    },
    {
        "id": 440104,
        "region_name": "越秀区",
        "parent_id": 440100,
        "level": 3
    },
    {
        "id": 440105,
        "region_name": "海珠区",
        "parent_id": 440100,
        "level": 3
    },
    {
        "id": 440106,
        "region_name": "天河区",
        "parent_id": 440100,
        "level": 3
    },
    {
        "id": 440111,
        "region_name": "白云区",
        "parent_id": 440100,
        "level": 3
    },
    {
        "id": 440112,
        "region_name": "黄埔区",
        "parent_id": 440100,
        "level": 3
    },
    {
        "id": 440113,
        "region_name": "番禺区",
        "parent_id": 440100,
        "level": 3
    },
    {
        "id": 440114,
        "region_name": "花都区",
        "parent_id": 440100,
        "level": 3
    },
    {
        "id": 440115,
        "region_name": "南沙区",
        "parent_id": 440100,
        "level": 3
    },
    {
        "id": 440117,
        "region_name": "从化区",
        "parent_id": 440100,
        "level": 3
    },
    {
        "id": 440118,
        "region_name": "增城区",
        "parent_id": 440100,
        "level": 3
    },
    {
        "id": 440200,
        "region_name": "韶关市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 440203,
        "region_name": "武江区",
        "parent_id": 440200,
        "level": 3
    },
    {
        "id": 440204,
        "region_name": "浈江区",
        "parent_id": 440200,
        "level": 3
    },
    {
        "id": 440205,
        "region_name": "曲江区",
        "parent_id": 440200,
        "level": 3
    },
    {
        "id": 440222,
        "region_name": "始兴县",
        "parent_id": 440200,
        "level": 3
    },
    {
        "id": 440224,
        "region_name": "仁化县",
        "parent_id": 440200,
        "level": 3
    },
    {
        "id": 440229,
        "region_name": "翁源县",
        "parent_id": 440200,
        "level": 3
    },
    {
        "id": 440232,
        "region_name": "乳源瑶族自治县",
        "parent_id": 440200,
        "level": 3
    },
    {
        "id": 440233,
        "region_name": "新丰县",
        "parent_id": 440200,
        "level": 3
    },
    {
        "id": 440281,
        "region_name": "乐昌市",
        "parent_id": 440200,
        "level": 3
    },
    {
        "id": 440282,
        "region_name": "南雄市",
        "parent_id": 440200,
        "level": 3
    },
    {
        "id": 440300,
        "region_name": "深圳市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 440303,
        "region_name": "罗湖区",
        "parent_id": 440300,
        "level": 3
    },
    {
        "id": 440304,
        "region_name": "福田区",
        "parent_id": 440300,
        "level": 3
    },
    {
        "id": 440305,
        "region_name": "南山区",
        "parent_id": 440300,
        "level": 3
    },
    {
        "id": 440306,
        "region_name": "宝安区",
        "parent_id": 440300,
        "level": 3
    },
    {
        "id": 440307,
        "region_name": "龙岗区",
        "parent_id": 440300,
        "level": 3
    },
    {
        "id": 440308,
        "region_name": "盐田区",
        "parent_id": 440300,
        "level": 3
    },
    {
        "id": 440309,
        "region_name": "龙华区",
        "parent_id": 440300,
        "level": 3
    },
    {
        "id": 440310,
        "region_name": "坪山区",
        "parent_id": 440300,
        "level": 3
    },
    {
        "id": 440400,
        "region_name": "珠海市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 440402,
        "region_name": "香洲区",
        "parent_id": 440400,
        "level": 3
    },
    {
        "id": 440403,
        "region_name": "斗门区",
        "parent_id": 440400,
        "level": 3
    },
    {
        "id": 440404,
        "region_name": "金湾区",
        "parent_id": 440400,
        "level": 3
    },
    {
        "id": 440500,
        "region_name": "汕头市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 440507,
        "region_name": "龙湖区",
        "parent_id": 440500,
        "level": 3
    },
    {
        "id": 440511,
        "region_name": "金平区",
        "parent_id": 440500,
        "level": 3
    },
    {
        "id": 440512,
        "region_name": "濠江区",
        "parent_id": 440500,
        "level": 3
    },
    {
        "id": 440513,
        "region_name": "潮阳区",
        "parent_id": 440500,
        "level": 3
    },
    {
        "id": 440514,
        "region_name": "潮南区",
        "parent_id": 440500,
        "level": 3
    },
    {
        "id": 440515,
        "region_name": "澄海区",
        "parent_id": 440500,
        "level": 3
    },
    {
        "id": 440523,
        "region_name": "南澳县",
        "parent_id": 440500,
        "level": 3
    },
    {
        "id": 440600,
        "region_name": "佛山市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 440604,
        "region_name": "禅城区",
        "parent_id": 440600,
        "level": 3
    },
    {
        "id": 440605,
        "region_name": "南海区",
        "parent_id": 440600,
        "level": 3
    },
    {
        "id": 440606,
        "region_name": "顺德区",
        "parent_id": 440600,
        "level": 3
    },
    {
        "id": 440607,
        "region_name": "三水区",
        "parent_id": 440600,
        "level": 3
    },
    {
        "id": 440608,
        "region_name": "高明区",
        "parent_id": 440600,
        "level": 3
    },
    {
        "id": 440700,
        "region_name": "江门市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 440703,
        "region_name": "蓬江区",
        "parent_id": 440700,
        "level": 3
    },
    {
        "id": 440704,
        "region_name": "江海区",
        "parent_id": 440700,
        "level": 3
    },
    {
        "id": 440705,
        "region_name": "新会区",
        "parent_id": 440700,
        "level": 3
    },
    {
        "id": 440781,
        "region_name": "台山市",
        "parent_id": 440700,
        "level": 3
    },
    {
        "id": 440783,
        "region_name": "开平市",
        "parent_id": 440700,
        "level": 3
    },
    {
        "id": 440784,
        "region_name": "鹤山市",
        "parent_id": 440700,
        "level": 3
    },
    {
        "id": 440785,
        "region_name": "恩平市",
        "parent_id": 440700,
        "level": 3
    },
    {
        "id": 440800,
        "region_name": "湛江市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 440802,
        "region_name": "赤坎区",
        "parent_id": 440800,
        "level": 3
    },
    {
        "id": 440803,
        "region_name": "霞山区",
        "parent_id": 440800,
        "level": 3
    },
    {
        "id": 440804,
        "region_name": "坡头区",
        "parent_id": 440800,
        "level": 3
    },
    {
        "id": 440811,
        "region_name": "麻章区",
        "parent_id": 440800,
        "level": 3
    },
    {
        "id": 440823,
        "region_name": "遂溪县",
        "parent_id": 440800,
        "level": 3
    },
    {
        "id": 440825,
        "region_name": "徐闻县",
        "parent_id": 440800,
        "level": 3
    },
    {
        "id": 440881,
        "region_name": "廉江市",
        "parent_id": 440800,
        "level": 3
    },
    {
        "id": 440882,
        "region_name": "雷州市",
        "parent_id": 440800,
        "level": 3
    },
    {
        "id": 440883,
        "region_name": "吴川市",
        "parent_id": 440800,
        "level": 3
    },
    {
        "id": 440900,
        "region_name": "茂名市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 440902,
        "region_name": "茂南区",
        "parent_id": 440900,
        "level": 3
    },
    {
        "id": 440904,
        "region_name": "电白区",
        "parent_id": 440900,
        "level": 3
    },
    {
        "id": 440981,
        "region_name": "高州市",
        "parent_id": 440900,
        "level": 3
    },
    {
        "id": 440982,
        "region_name": "化州市",
        "parent_id": 440900,
        "level": 3
    },
    {
        "id": 440983,
        "region_name": "信宜市",
        "parent_id": 440900,
        "level": 3
    },
    {
        "id": 441200,
        "region_name": "肇庆市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 441202,
        "region_name": "端州区",
        "parent_id": 441200,
        "level": 3
    },
    {
        "id": 441203,
        "region_name": "鼎湖区",
        "parent_id": 441200,
        "level": 3
    },
    {
        "id": 441204,
        "region_name": "高要区",
        "parent_id": 441200,
        "level": 3
    },
    {
        "id": 441223,
        "region_name": "广宁县",
        "parent_id": 441200,
        "level": 3
    },
    {
        "id": 441224,
        "region_name": "怀集县",
        "parent_id": 441200,
        "level": 3
    },
    {
        "id": 441225,
        "region_name": "封开县",
        "parent_id": 441200,
        "level": 3
    },
    {
        "id": 441226,
        "region_name": "德庆县",
        "parent_id": 441200,
        "level": 3
    },
    {
        "id": 441284,
        "region_name": "四会市",
        "parent_id": 441200,
        "level": 3
    },
    {
        "id": 441300,
        "region_name": "惠州市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 441302,
        "region_name": "惠城区",
        "parent_id": 441300,
        "level": 3
    },
    {
        "id": 441303,
        "region_name": "惠阳区",
        "parent_id": 441300,
        "level": 3
    },
    {
        "id": 441322,
        "region_name": "博罗县",
        "parent_id": 441300,
        "level": 3
    },
    {
        "id": 441323,
        "region_name": "惠东县",
        "parent_id": 441300,
        "level": 3
    },
    {
        "id": 441324,
        "region_name": "龙门县",
        "parent_id": 441300,
        "level": 3
    },
    {
        "id": 441400,
        "region_name": "梅州市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 441402,
        "region_name": "梅江区",
        "parent_id": 441400,
        "level": 3
    },
    {
        "id": 441403,
        "region_name": "梅县区",
        "parent_id": 441400,
        "level": 3
    },
    {
        "id": 441422,
        "region_name": "大埔县",
        "parent_id": 441400,
        "level": 3
    },
    {
        "id": 441423,
        "region_name": "丰顺县",
        "parent_id": 441400,
        "level": 3
    },
    {
        "id": 441424,
        "region_name": "五华县",
        "parent_id": 441400,
        "level": 3
    },
    {
        "id": 441426,
        "region_name": "平远县",
        "parent_id": 441400,
        "level": 3
    },
    {
        "id": 441427,
        "region_name": "蕉岭县",
        "parent_id": 441400,
        "level": 3
    },
    {
        "id": 441481,
        "region_name": "兴宁市",
        "parent_id": 441400,
        "level": 3
    },
    {
        "id": 441500,
        "region_name": "汕尾市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 441502,
        "region_name": "城区",
        "parent_id": 441500,
        "level": 3
    },
    {
        "id": 441521,
        "region_name": "海丰县",
        "parent_id": 441500,
        "level": 3
    },
    {
        "id": 441523,
        "region_name": "陆河县",
        "parent_id": 441500,
        "level": 3
    },
    {
        "id": 441581,
        "region_name": "陆丰市",
        "parent_id": 441500,
        "level": 3
    },
    {
        "id": 441600,
        "region_name": "河源市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 441602,
        "region_name": "源城区",
        "parent_id": 441600,
        "level": 3
    },
    {
        "id": 441621,
        "region_name": "紫金县",
        "parent_id": 441600,
        "level": 3
    },
    {
        "id": 441622,
        "region_name": "龙川县",
        "parent_id": 441600,
        "level": 3
    },
    {
        "id": 441623,
        "region_name": "连平县",
        "parent_id": 441600,
        "level": 3
    },
    {
        "id": 441624,
        "region_name": "和平县",
        "parent_id": 441600,
        "level": 3
    },
    {
        "id": 441625,
        "region_name": "东源县",
        "parent_id": 441600,
        "level": 3
    },
    {
        "id": 441700,
        "region_name": "阳江市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 441702,
        "region_name": "江城区",
        "parent_id": 441700,
        "level": 3
    },
    {
        "id": 441704,
        "region_name": "阳东区",
        "parent_id": 441700,
        "level": 3
    },
    {
        "id": 441721,
        "region_name": "阳西县",
        "parent_id": 441700,
        "level": 3
    },
    {
        "id": 441781,
        "region_name": "阳春市",
        "parent_id": 441700,
        "level": 3
    },
    {
        "id": 441800,
        "region_name": "清远市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 441802,
        "region_name": "清城区",
        "parent_id": 441800,
        "level": 3
    },
    {
        "id": 441803,
        "region_name": "清新区",
        "parent_id": 441800,
        "level": 3
    },
    {
        "id": 441821,
        "region_name": "佛冈县",
        "parent_id": 441800,
        "level": 3
    },
    {
        "id": 441823,
        "region_name": "阳山县",
        "parent_id": 441800,
        "level": 3
    },
    {
        "id": 441825,
        "region_name": "连山壮族瑶族自治县",
        "parent_id": 441800,
        "level": 3
    },
    {
        "id": 441826,
        "region_name": "连南瑶族自治县",
        "parent_id": 441800,
        "level": 3
    },
    {
        "id": 441881,
        "region_name": "英德市",
        "parent_id": 441800,
        "level": 3
    },
    {
        "id": 441882,
        "region_name": "连州市",
        "parent_id": 441800,
        "level": 3
    },
    {
        "id": 441900,
        "region_name": "东莞市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 441901,
        "region_name": "市辖区",
        "parent_id": 441900,
        "level": 3
    },
    {
        "id": 442000,
        "region_name": "中山市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 442001,
        "region_name": "市辖区",
        "parent_id": 442000,
        "level": 3
    },
    {
        "id": 445100,
        "region_name": "潮州市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 445102,
        "region_name": "湘桥区",
        "parent_id": 445100,
        "level": 3
    },
    {
        "id": 445103,
        "region_name": "潮安区",
        "parent_id": 445100,
        "level": 3
    },
    {
        "id": 445122,
        "region_name": "饶平县",
        "parent_id": 445100,
        "level": 3
    },
    {
        "id": 445200,
        "region_name": "揭阳市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 445202,
        "region_name": "榕城区",
        "parent_id": 445200,
        "level": 3
    },
    {
        "id": 445203,
        "region_name": "揭东区",
        "parent_id": 445200,
        "level": 3
    },
    {
        "id": 445222,
        "region_name": "揭西县",
        "parent_id": 445200,
        "level": 3
    },
    {
        "id": 445224,
        "region_name": "惠来县",
        "parent_id": 445200,
        "level": 3
    },
    {
        "id": 445281,
        "region_name": "普宁市",
        "parent_id": 445200,
        "level": 3
    },
    {
        "id": 445300,
        "region_name": "云浮市",
        "parent_id": 440000,
        "level": 2
    },
    {
        "id": 445302,
        "region_name": "云城区",
        "parent_id": 445300,
        "level": 3
    },
    {
        "id": 445303,
        "region_name": "云安区",
        "parent_id": 445300,
        "level": 3
    },
    {
        "id": 445321,
        "region_name": "新兴县",
        "parent_id": 445300,
        "level": 3
    },
    {
        "id": 445322,
        "region_name": "郁南县",
        "parent_id": 445300,
        "level": 3
    },
    {
        "id": 445381,
        "region_name": "罗定市",
        "parent_id": 445300,
        "level": 3
    },
    {
        "id": 450000,
        "region_name": "广西壮族自治区",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 450100,
        "region_name": "南宁市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 450102,
        "region_name": "兴宁区",
        "parent_id": 450100,
        "level": 3
    },
    {
        "id": 450103,
        "region_name": "青秀区",
        "parent_id": 450100,
        "level": 3
    },
    {
        "id": 450105,
        "region_name": "江南区",
        "parent_id": 450100,
        "level": 3
    },
    {
        "id": 450107,
        "region_name": "西乡塘区",
        "parent_id": 450100,
        "level": 3
    },
    {
        "id": 450108,
        "region_name": "良庆区",
        "parent_id": 450100,
        "level": 3
    },
    {
        "id": 450109,
        "region_name": "邕宁区",
        "parent_id": 450100,
        "level": 3
    },
    {
        "id": 450110,
        "region_name": "武鸣区",
        "parent_id": 450100,
        "level": 3
    },
    {
        "id": 450123,
        "region_name": "隆安县",
        "parent_id": 450100,
        "level": 3
    },
    {
        "id": 450124,
        "region_name": "马山县",
        "parent_id": 450100,
        "level": 3
    },
    {
        "id": 450125,
        "region_name": "上林县",
        "parent_id": 450100,
        "level": 3
    },
    {
        "id": 450126,
        "region_name": "宾阳县",
        "parent_id": 450100,
        "level": 3
    },
    {
        "id": 450127,
        "region_name": "横县",
        "parent_id": 450100,
        "level": 3
    },
    {
        "id": 450200,
        "region_name": "柳州市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 450202,
        "region_name": "城中区",
        "parent_id": 450200,
        "level": 3
    },
    {
        "id": 450203,
        "region_name": "鱼峰区",
        "parent_id": 450200,
        "level": 3
    },
    {
        "id": 450204,
        "region_name": "柳南区",
        "parent_id": 450200,
        "level": 3
    },
    {
        "id": 450205,
        "region_name": "柳北区",
        "parent_id": 450200,
        "level": 3
    },
    {
        "id": 450206,
        "region_name": "柳江区",
        "parent_id": 450200,
        "level": 3
    },
    {
        "id": 450222,
        "region_name": "柳城县",
        "parent_id": 450200,
        "level": 3
    },
    {
        "id": 450223,
        "region_name": "鹿寨县",
        "parent_id": 450200,
        "level": 3
    },
    {
        "id": 450224,
        "region_name": "融安县",
        "parent_id": 450200,
        "level": 3
    },
    {
        "id": 450225,
        "region_name": "融水苗族自治县",
        "parent_id": 450200,
        "level": 3
    },
    {
        "id": 450226,
        "region_name": "三江侗族自治县",
        "parent_id": 450200,
        "level": 3
    },
    {
        "id": 450300,
        "region_name": "桂林市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 450302,
        "region_name": "秀峰区",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450303,
        "region_name": "叠彩区",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450304,
        "region_name": "象山区",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450305,
        "region_name": "七星区",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450311,
        "region_name": "雁山区",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450312,
        "region_name": "临桂区",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450321,
        "region_name": "阳朔县",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450323,
        "region_name": "灵川县",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450324,
        "region_name": "全州县",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450325,
        "region_name": "兴安县",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450326,
        "region_name": "永福县",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450327,
        "region_name": "灌阳县",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450328,
        "region_name": "龙胜各族自治县",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450329,
        "region_name": "资源县",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450330,
        "region_name": "平乐县",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450331,
        "region_name": "荔浦县",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450332,
        "region_name": "恭城瑶族自治县",
        "parent_id": 450300,
        "level": 3
    },
    {
        "id": 450400,
        "region_name": "梧州市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 450403,
        "region_name": "万秀区",
        "parent_id": 450400,
        "level": 3
    },
    {
        "id": 450405,
        "region_name": "长洲区",
        "parent_id": 450400,
        "level": 3
    },
    {
        "id": 450406,
        "region_name": "龙圩区",
        "parent_id": 450400,
        "level": 3
    },
    {
        "id": 450421,
        "region_name": "苍梧县",
        "parent_id": 450400,
        "level": 3
    },
    {
        "id": 450422,
        "region_name": "藤县",
        "parent_id": 450400,
        "level": 3
    },
    {
        "id": 450423,
        "region_name": "蒙山县",
        "parent_id": 450400,
        "level": 3
    },
    {
        "id": 450481,
        "region_name": "岑溪市",
        "parent_id": 450400,
        "level": 3
    },
    {
        "id": 450500,
        "region_name": "北海市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 450502,
        "region_name": "海城区",
        "parent_id": 450500,
        "level": 3
    },
    {
        "id": 450503,
        "region_name": "银海区",
        "parent_id": 450500,
        "level": 3
    },
    {
        "id": 450512,
        "region_name": "铁山港区",
        "parent_id": 450500,
        "level": 3
    },
    {
        "id": 450521,
        "region_name": "合浦县",
        "parent_id": 450500,
        "level": 3
    },
    {
        "id": 450600,
        "region_name": "防城港市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 450602,
        "region_name": "港口区",
        "parent_id": 450600,
        "level": 3
    },
    {
        "id": 450603,
        "region_name": "防城区",
        "parent_id": 450600,
        "level": 3
    },
    {
        "id": 450621,
        "region_name": "上思县",
        "parent_id": 450600,
        "level": 3
    },
    {
        "id": 450681,
        "region_name": "东兴市",
        "parent_id": 450600,
        "level": 3
    },
    {
        "id": 450700,
        "region_name": "钦州市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 450702,
        "region_name": "钦南区",
        "parent_id": 450700,
        "level": 3
    },
    {
        "id": 450703,
        "region_name": "钦北区",
        "parent_id": 450700,
        "level": 3
    },
    {
        "id": 450721,
        "region_name": "灵山县",
        "parent_id": 450700,
        "level": 3
    },
    {
        "id": 450722,
        "region_name": "浦北县",
        "parent_id": 450700,
        "level": 3
    },
    {
        "id": 450800,
        "region_name": "贵港市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 450802,
        "region_name": "港北区",
        "parent_id": 450800,
        "level": 3
    },
    {
        "id": 450803,
        "region_name": "港南区",
        "parent_id": 450800,
        "level": 3
    },
    {
        "id": 450804,
        "region_name": "覃塘区",
        "parent_id": 450800,
        "level": 3
    },
    {
        "id": 450821,
        "region_name": "平南县",
        "parent_id": 450800,
        "level": 3
    },
    {
        "id": 450881,
        "region_name": "桂平市",
        "parent_id": 450800,
        "level": 3
    },
    {
        "id": 450900,
        "region_name": "玉林市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 450902,
        "region_name": "玉州区",
        "parent_id": 450900,
        "level": 3
    },
    {
        "id": 450903,
        "region_name": "福绵区",
        "parent_id": 450900,
        "level": 3
    },
    {
        "id": 450921,
        "region_name": "容县",
        "parent_id": 450900,
        "level": 3
    },
    {
        "id": 450922,
        "region_name": "陆川县",
        "parent_id": 450900,
        "level": 3
    },
    {
        "id": 450923,
        "region_name": "博白县",
        "parent_id": 450900,
        "level": 3
    },
    {
        "id": 450924,
        "region_name": "兴业县",
        "parent_id": 450900,
        "level": 3
    },
    {
        "id": 450981,
        "region_name": "北流市",
        "parent_id": 450900,
        "level": 3
    },
    {
        "id": 451000,
        "region_name": "百色市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 451002,
        "region_name": "右江区",
        "parent_id": 451000,
        "level": 3
    },
    {
        "id": 451021,
        "region_name": "田阳县",
        "parent_id": 451000,
        "level": 3
    },
    {
        "id": 451022,
        "region_name": "田东县",
        "parent_id": 451000,
        "level": 3
    },
    {
        "id": 451023,
        "region_name": "平果县",
        "parent_id": 451000,
        "level": 3
    },
    {
        "id": 451024,
        "region_name": "德保县",
        "parent_id": 451000,
        "level": 3
    },
    {
        "id": 451026,
        "region_name": "那坡县",
        "parent_id": 451000,
        "level": 3
    },
    {
        "id": 451027,
        "region_name": "凌云县",
        "parent_id": 451000,
        "level": 3
    },
    {
        "id": 451028,
        "region_name": "乐业县",
        "parent_id": 451000,
        "level": 3
    },
    {
        "id": 451029,
        "region_name": "田林县",
        "parent_id": 451000,
        "level": 3
    },
    {
        "id": 451030,
        "region_name": "西林县",
        "parent_id": 451000,
        "level": 3
    },
    {
        "id": 451031,
        "region_name": "隆林各族自治县",
        "parent_id": 451000,
        "level": 3
    },
    {
        "id": 451081,
        "region_name": "靖西市",
        "parent_id": 451000,
        "level": 3
    },
    {
        "id": 451100,
        "region_name": "贺州市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 451102,
        "region_name": "八步区",
        "parent_id": 451100,
        "level": 3
    },
    {
        "id": 451103,
        "region_name": "平桂区",
        "parent_id": 451100,
        "level": 3
    },
    {
        "id": 451121,
        "region_name": "昭平县",
        "parent_id": 451100,
        "level": 3
    },
    {
        "id": 451122,
        "region_name": "钟山县",
        "parent_id": 451100,
        "level": 3
    },
    {
        "id": 451123,
        "region_name": "富川瑶族自治县",
        "parent_id": 451100,
        "level": 3
    },
    {
        "id": 451200,
        "region_name": "河池市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 451202,
        "region_name": "金城江区",
        "parent_id": 451200,
        "level": 3
    },
    {
        "id": 451203,
        "region_name": "宜州区",
        "parent_id": 451200,
        "level": 3
    },
    {
        "id": 451221,
        "region_name": "南丹县",
        "parent_id": 451200,
        "level": 3
    },
    {
        "id": 451222,
        "region_name": "天峨县",
        "parent_id": 451200,
        "level": 3
    },
    {
        "id": 451223,
        "region_name": "凤山县",
        "parent_id": 451200,
        "level": 3
    },
    {
        "id": 451224,
        "region_name": "东兰县",
        "parent_id": 451200,
        "level": 3
    },
    {
        "id": 451225,
        "region_name": "罗城仫佬族自治县",
        "parent_id": 451200,
        "level": 3
    },
    {
        "id": 451226,
        "region_name": "环江毛南族自治县",
        "parent_id": 451200,
        "level": 3
    },
    {
        "id": 451227,
        "region_name": "巴马瑶族自治县",
        "parent_id": 451200,
        "level": 3
    },
    {
        "id": 451228,
        "region_name": "都安瑶族自治县",
        "parent_id": 451200,
        "level": 3
    },
    {
        "id": 451229,
        "region_name": "大化瑶族自治县",
        "parent_id": 451200,
        "level": 3
    },
    {
        "id": 451300,
        "region_name": "来宾市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 451302,
        "region_name": "兴宾区",
        "parent_id": 451300,
        "level": 3
    },
    {
        "id": 451321,
        "region_name": "忻城县",
        "parent_id": 451300,
        "level": 3
    },
    {
        "id": 451322,
        "region_name": "象州县",
        "parent_id": 451300,
        "level": 3
    },
    {
        "id": 451323,
        "region_name": "武宣县",
        "parent_id": 451300,
        "level": 3
    },
    {
        "id": 451324,
        "region_name": "金秀瑶族自治县",
        "parent_id": 451300,
        "level": 3
    },
    {
        "id": 451381,
        "region_name": "合山市",
        "parent_id": 451300,
        "level": 3
    },
    {
        "id": 451400,
        "region_name": "崇左市",
        "parent_id": 450000,
        "level": 2
    },
    {
        "id": 451402,
        "region_name": "江州区",
        "parent_id": 451400,
        "level": 3
    },
    {
        "id": 451421,
        "region_name": "扶绥县",
        "parent_id": 451400,
        "level": 3
    },
    {
        "id": 451422,
        "region_name": "宁明县",
        "parent_id": 451400,
        "level": 3
    },
    {
        "id": 451423,
        "region_name": "龙州县",
        "parent_id": 451400,
        "level": 3
    },
    {
        "id": 451424,
        "region_name": "大新县",
        "parent_id": 451400,
        "level": 3
    },
    {
        "id": 451425,
        "region_name": "天等县",
        "parent_id": 451400,
        "level": 3
    },
    {
        "id": 451481,
        "region_name": "凭祥市",
        "parent_id": 451400,
        "level": 3
    },
    {
        "id": 460000,
        "region_name": "海南省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 460100,
        "region_name": "海口市",
        "parent_id": 460000,
        "level": 2
    },
    {
        "id": 460105,
        "region_name": "秀英区",
        "parent_id": 460100,
        "level": 3
    },
    {
        "id": 460106,
        "region_name": "龙华区",
        "parent_id": 460100,
        "level": 3
    },
    {
        "id": 460107,
        "region_name": "琼山区",
        "parent_id": 460100,
        "level": 3
    },
    {
        "id": 460108,
        "region_name": "美兰区",
        "parent_id": 460100,
        "level": 3
    },
    {
        "id": 460200,
        "region_name": "三亚市",
        "parent_id": 460000,
        "level": 2
    },
    {
        "id": 460202,
        "region_name": "海棠区",
        "parent_id": 460200,
        "level": 3
    },
    {
        "id": 460203,
        "region_name": "吉阳区",
        "parent_id": 460200,
        "level": 3
    },
    {
        "id": 460204,
        "region_name": "天涯区",
        "parent_id": 460200,
        "level": 3
    },
    {
        "id": 460205,
        "region_name": "崖州区",
        "parent_id": 460200,
        "level": 3
    },
    {
        "id": 460300,
        "region_name": "三沙市",
        "parent_id": 460000,
        "level": 2
    },
    {
        "id": 460301,
        "region_name": "市辖区",
        "parent_id": 460300,
        "level": 3
    },
    {
        "id": 460400,
        "region_name": "儋州市",
        "parent_id": 460000,
        "level": 2
    },
    {
        "id": 460401,
        "region_name": "市辖区",
        "parent_id": 460400,
        "level": 3
    },
    {
        "id": 469000,
        "region_name": "直辖县市",
        "parent_id": 460000,
        "level": 2
    },
    {
        "id": 469001,
        "region_name": "五指山市",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469002,
        "region_name": "琼海市",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469005,
        "region_name": "文昌市",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469006,
        "region_name": "万宁市",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469007,
        "region_name": "东方市",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469021,
        "region_name": "定安县",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469022,
        "region_name": "屯昌县",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469023,
        "region_name": "澄迈县",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469024,
        "region_name": "临高县",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469025,
        "region_name": "白沙黎族自治县",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469026,
        "region_name": "昌江黎族自治县",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469027,
        "region_name": "乐东黎族自治县",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469028,
        "region_name": "陵水黎族自治县",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469029,
        "region_name": "保亭黎族苗族自治县",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 469030,
        "region_name": "琼中黎族苗族自治县",
        "parent_id": 469000,
        "level": 3
    },
    {
        "id": 500000,
        "region_name": "重庆市",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 500100,
        "region_name": "重庆市",
        "parent_id": 500000,
        "level": 2
    },
    {
        "id": 500101,
        "region_name": "万州区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500102,
        "region_name": "涪陵区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500103,
        "region_name": "渝中区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500104,
        "region_name": "大渡口区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500105,
        "region_name": "江北区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500106,
        "region_name": "沙坪坝区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500107,
        "region_name": "九龙坡区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500108,
        "region_name": "南岸区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500109,
        "region_name": "北碚区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500110,
        "region_name": "綦江区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500111,
        "region_name": "大足区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500112,
        "region_name": "渝北区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500113,
        "region_name": "巴南区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500114,
        "region_name": "黔江区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500115,
        "region_name": "长寿区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500116,
        "region_name": "江津区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500117,
        "region_name": "合川区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500118,
        "region_name": "永川区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500119,
        "region_name": "南川区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500120,
        "region_name": "璧山区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500151,
        "region_name": "铜梁区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500152,
        "region_name": "潼南区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500153,
        "region_name": "荣昌区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500154,
        "region_name": "开州区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500155,
        "region_name": "梁平区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500156,
        "region_name": "武隆区",
        "parent_id": 500100,
        "level": 3
    },
    {
        "id": 500229,
        "region_name": "城口县",
        "parent_id": 500200,
        "level": 3
    },
    {
        "id": 500230,
        "region_name": "丰都县",
        "parent_id": 500200,
        "level": 3
    },
    {
        "id": 500231,
        "region_name": "垫江县",
        "parent_id": 500200,
        "level": 3
    },
    {
        "id": 500233,
        "region_name": "忠县",
        "parent_id": 500200,
        "level": 3
    },
    {
        "id": 500235,
        "region_name": "云阳县",
        "parent_id": 500200,
        "level": 3
    },
    {
        "id": 500236,
        "region_name": "奉节县",
        "parent_id": 500200,
        "level": 3
    },
    {
        "id": 500237,
        "region_name": "巫山县",
        "parent_id": 500200,
        "level": 3
    },
    {
        "id": 500238,
        "region_name": "巫溪县",
        "parent_id": 500200,
        "level": 3
    },
    {
        "id": 500240,
        "region_name": "石柱土家族自治县",
        "parent_id": 500200,
        "level": 3
    },
    {
        "id": 500241,
        "region_name": "秀山土家族苗族自治县",
        "parent_id": 500200,
        "level": 3
    },
    {
        "id": 500242,
        "region_name": "酉阳土家族苗族自治县",
        "parent_id": 500200,
        "level": 3
    },
    {
        "id": 500243,
        "region_name": "彭水苗族土家族自治县",
        "parent_id": 500200,
        "level": 3
    },
    {
        "id": 510000,
        "region_name": "四川省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 510100,
        "region_name": "成都市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 510104,
        "region_name": "锦江区",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510105,
        "region_name": "青羊区",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510106,
        "region_name": "金牛区",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510107,
        "region_name": "武侯区",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510108,
        "region_name": "成华区",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510112,
        "region_name": "龙泉驿区",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510113,
        "region_name": "青白江区",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510114,
        "region_name": "新都区",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510115,
        "region_name": "温江区",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510116,
        "region_name": "双流区",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510117,
        "region_name": "郫都区",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510121,
        "region_name": "金堂县",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510129,
        "region_name": "大邑县",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510131,
        "region_name": "蒲江县",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510132,
        "region_name": "新津县",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510181,
        "region_name": "都江堰市",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510182,
        "region_name": "彭州市",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510183,
        "region_name": "邛崃市",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510184,
        "region_name": "崇州市",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510185,
        "region_name": "简阳市",
        "parent_id": 510100,
        "level": 3
    },
    {
        "id": 510300,
        "region_name": "自贡市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 510302,
        "region_name": "自流井区",
        "parent_id": 510300,
        "level": 3
    },
    {
        "id": 510303,
        "region_name": "贡井区",
        "parent_id": 510300,
        "level": 3
    },
    {
        "id": 510304,
        "region_name": "大安区",
        "parent_id": 510300,
        "level": 3
    },
    {
        "id": 510311,
        "region_name": "沿滩区",
        "parent_id": 510300,
        "level": 3
    },
    {
        "id": 510321,
        "region_name": "荣县",
        "parent_id": 510300,
        "level": 3
    },
    {
        "id": 510322,
        "region_name": "富顺县",
        "parent_id": 510300,
        "level": 3
    },
    {
        "id": 510400,
        "region_name": "攀枝花市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 510402,
        "region_name": "东区",
        "parent_id": 510400,
        "level": 3
    },
    {
        "id": 510403,
        "region_name": "西区",
        "parent_id": 510400,
        "level": 3
    },
    {
        "id": 510411,
        "region_name": "仁和区",
        "parent_id": 510400,
        "level": 3
    },
    {
        "id": 510421,
        "region_name": "米易县",
        "parent_id": 510400,
        "level": 3
    },
    {
        "id": 510422,
        "region_name": "盐边县",
        "parent_id": 510400,
        "level": 3
    },
    {
        "id": 510500,
        "region_name": "泸州市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 510502,
        "region_name": "江阳区",
        "parent_id": 510500,
        "level": 3
    },
    {
        "id": 510503,
        "region_name": "纳溪区",
        "parent_id": 510500,
        "level": 3
    },
    {
        "id": 510504,
        "region_name": "龙马潭区",
        "parent_id": 510500,
        "level": 3
    },
    {
        "id": 510521,
        "region_name": "泸县",
        "parent_id": 510500,
        "level": 3
    },
    {
        "id": 510522,
        "region_name": "合江县",
        "parent_id": 510500,
        "level": 3
    },
    {
        "id": 510524,
        "region_name": "叙永县",
        "parent_id": 510500,
        "level": 3
    },
    {
        "id": 510525,
        "region_name": "古蔺县",
        "parent_id": 510500,
        "level": 3
    },
    {
        "id": 510600,
        "region_name": "德阳市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 510603,
        "region_name": "旌阳区",
        "parent_id": 510600,
        "level": 3
    },
    {
        "id": 510604,
        "region_name": "罗江区",
        "parent_id": 510600,
        "level": 3
    },
    {
        "id": 510623,
        "region_name": "中江县",
        "parent_id": 510600,
        "level": 3
    },
    {
        "id": 510681,
        "region_name": "广汉市",
        "parent_id": 510600,
        "level": 3
    },
    {
        "id": 510682,
        "region_name": "什邡市",
        "parent_id": 510600,
        "level": 3
    },
    {
        "id": 510683,
        "region_name": "绵竹市",
        "parent_id": 510600,
        "level": 3
    },
    {
        "id": 510700,
        "region_name": "绵阳市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 510703,
        "region_name": "涪城区",
        "parent_id": 510700,
        "level": 3
    },
    {
        "id": 510704,
        "region_name": "游仙区",
        "parent_id": 510700,
        "level": 3
    },
    {
        "id": 510705,
        "region_name": "安州区",
        "parent_id": 510700,
        "level": 3
    },
    {
        "id": 510722,
        "region_name": "三台县",
        "parent_id": 510700,
        "level": 3
    },
    {
        "id": 510723,
        "region_name": "盐亭县",
        "parent_id": 510700,
        "level": 3
    },
    {
        "id": 510725,
        "region_name": "梓潼县",
        "parent_id": 510700,
        "level": 3
    },
    {
        "id": 510726,
        "region_name": "北川羌族自治县",
        "parent_id": 510700,
        "level": 3
    },
    {
        "id": 510727,
        "region_name": "平武县",
        "parent_id": 510700,
        "level": 3
    },
    {
        "id": 510781,
        "region_name": "江油市",
        "parent_id": 510700,
        "level": 3
    },
    {
        "id": 510800,
        "region_name": "广元市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 510802,
        "region_name": "利州区",
        "parent_id": 510800,
        "level": 3
    },
    {
        "id": 510811,
        "region_name": "昭化区",
        "parent_id": 510800,
        "level": 3
    },
    {
        "id": 510812,
        "region_name": "朝天区",
        "parent_id": 510800,
        "level": 3
    },
    {
        "id": 510821,
        "region_name": "旺苍县",
        "parent_id": 510800,
        "level": 3
    },
    {
        "id": 510822,
        "region_name": "青川县",
        "parent_id": 510800,
        "level": 3
    },
    {
        "id": 510823,
        "region_name": "剑阁县",
        "parent_id": 510800,
        "level": 3
    },
    {
        "id": 510824,
        "region_name": "苍溪县",
        "parent_id": 510800,
        "level": 3
    },
    {
        "id": 510900,
        "region_name": "遂宁市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 510903,
        "region_name": "船山区",
        "parent_id": 510900,
        "level": 3
    },
    {
        "id": 510904,
        "region_name": "安居区",
        "parent_id": 510900,
        "level": 3
    },
    {
        "id": 510921,
        "region_name": "蓬溪县",
        "parent_id": 510900,
        "level": 3
    },
    {
        "id": 510922,
        "region_name": "射洪县",
        "parent_id": 510900,
        "level": 3
    },
    {
        "id": 510923,
        "region_name": "大英县",
        "parent_id": 510900,
        "level": 3
    },
    {
        "id": 511000,
        "region_name": "内江市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 511002,
        "region_name": "市中区",
        "parent_id": 511000,
        "level": 3
    },
    {
        "id": 511011,
        "region_name": "东兴区",
        "parent_id": 511000,
        "level": 3
    },
    {
        "id": 511024,
        "region_name": "威远县",
        "parent_id": 511000,
        "level": 3
    },
    {
        "id": 511025,
        "region_name": "资中县",
        "parent_id": 511000,
        "level": 3
    },
    {
        "id": 511083,
        "region_name": "隆昌市",
        "parent_id": 511000,
        "level": 3
    },
    {
        "id": 511100,
        "region_name": "乐山市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 511102,
        "region_name": "市中区",
        "parent_id": 511100,
        "level": 3
    },
    {
        "id": 511111,
        "region_name": "沙湾区",
        "parent_id": 511100,
        "level": 3
    },
    {
        "id": 511112,
        "region_name": "五通桥区",
        "parent_id": 511100,
        "level": 3
    },
    {
        "id": 511113,
        "region_name": "金口河区",
        "parent_id": 511100,
        "level": 3
    },
    {
        "id": 511123,
        "region_name": "犍为县",
        "parent_id": 511100,
        "level": 3
    },
    {
        "id": 511124,
        "region_name": "井研县",
        "parent_id": 511100,
        "level": 3
    },
    {
        "id": 511126,
        "region_name": "夹江县",
        "parent_id": 511100,
        "level": 3
    },
    {
        "id": 511129,
        "region_name": "沐川县",
        "parent_id": 511100,
        "level": 3
    },
    {
        "id": 511132,
        "region_name": "峨边彝族自治县",
        "parent_id": 511100,
        "level": 3
    },
    {
        "id": 511133,
        "region_name": "马边彝族自治县",
        "parent_id": 511100,
        "level": 3
    },
    {
        "id": 511181,
        "region_name": "峨眉山市",
        "parent_id": 511100,
        "level": 3
    },
    {
        "id": 511300,
        "region_name": "南充市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 511302,
        "region_name": "顺庆区",
        "parent_id": 511300,
        "level": 3
    },
    {
        "id": 511303,
        "region_name": "高坪区",
        "parent_id": 511300,
        "level": 3
    },
    {
        "id": 511304,
        "region_name": "嘉陵区",
        "parent_id": 511300,
        "level": 3
    },
    {
        "id": 511321,
        "region_name": "南部县",
        "parent_id": 511300,
        "level": 3
    },
    {
        "id": 511322,
        "region_name": "营山县",
        "parent_id": 511300,
        "level": 3
    },
    {
        "id": 511323,
        "region_name": "蓬安县",
        "parent_id": 511300,
        "level": 3
    },
    {
        "id": 511324,
        "region_name": "仪陇县",
        "parent_id": 511300,
        "level": 3
    },
    {
        "id": 511325,
        "region_name": "西充县",
        "parent_id": 511300,
        "level": 3
    },
    {
        "id": 511381,
        "region_name": "阆中市",
        "parent_id": 511300,
        "level": 3
    },
    {
        "id": 511400,
        "region_name": "眉山市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 511402,
        "region_name": "东坡区",
        "parent_id": 511400,
        "level": 3
    },
    {
        "id": 511403,
        "region_name": "彭山区",
        "parent_id": 511400,
        "level": 3
    },
    {
        "id": 511421,
        "region_name": "仁寿县",
        "parent_id": 511400,
        "level": 3
    },
    {
        "id": 511423,
        "region_name": "洪雅县",
        "parent_id": 511400,
        "level": 3
    },
    {
        "id": 511424,
        "region_name": "丹棱县",
        "parent_id": 511400,
        "level": 3
    },
    {
        "id": 511425,
        "region_name": "青神县",
        "parent_id": 511400,
        "level": 3
    },
    {
        "id": 511500,
        "region_name": "宜宾市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 511502,
        "region_name": "翠屏区",
        "parent_id": 511500,
        "level": 3
    },
    {
        "id": 511503,
        "region_name": "南溪区",
        "parent_id": 511500,
        "level": 3
    },
    {
        "id": 511521,
        "region_name": "宜宾县",
        "parent_id": 511500,
        "level": 3
    },
    {
        "id": 511523,
        "region_name": "江安县",
        "parent_id": 511500,
        "level": 3
    },
    {
        "id": 511524,
        "region_name": "长宁县",
        "parent_id": 511500,
        "level": 3
    },
    {
        "id": 511525,
        "region_name": "高县",
        "parent_id": 511500,
        "level": 3
    },
    {
        "id": 511526,
        "region_name": "珙县",
        "parent_id": 511500,
        "level": 3
    },
    {
        "id": 511527,
        "region_name": "筠连县",
        "parent_id": 511500,
        "level": 3
    },
    {
        "id": 511528,
        "region_name": "兴文县",
        "parent_id": 511500,
        "level": 3
    },
    {
        "id": 511529,
        "region_name": "屏山县",
        "parent_id": 511500,
        "level": 3
    },
    {
        "id": 511600,
        "region_name": "广安市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 511602,
        "region_name": "广安区",
        "parent_id": 511600,
        "level": 3
    },
    {
        "id": 511603,
        "region_name": "前锋区",
        "parent_id": 511600,
        "level": 3
    },
    {
        "id": 511621,
        "region_name": "岳池县",
        "parent_id": 511600,
        "level": 3
    },
    {
        "id": 511622,
        "region_name": "武胜县",
        "parent_id": 511600,
        "level": 3
    },
    {
        "id": 511623,
        "region_name": "邻水县",
        "parent_id": 511600,
        "level": 3
    },
    {
        "id": 511681,
        "region_name": "华蓥市",
        "parent_id": 511600,
        "level": 3
    },
    {
        "id": 511700,
        "region_name": "达州市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 511702,
        "region_name": "通川区",
        "parent_id": 511700,
        "level": 3
    },
    {
        "id": 511703,
        "region_name": "达川区",
        "parent_id": 511700,
        "level": 3
    },
    {
        "id": 511722,
        "region_name": "宣汉县",
        "parent_id": 511700,
        "level": 3
    },
    {
        "id": 511723,
        "region_name": "开江县",
        "parent_id": 511700,
        "level": 3
    },
    {
        "id": 511724,
        "region_name": "大竹县",
        "parent_id": 511700,
        "level": 3
    },
    {
        "id": 511725,
        "region_name": "渠县",
        "parent_id": 511700,
        "level": 3
    },
    {
        "id": 511781,
        "region_name": "万源市",
        "parent_id": 511700,
        "level": 3
    },
    {
        "id": 511800,
        "region_name": "雅安市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 511802,
        "region_name": "雨城区",
        "parent_id": 511800,
        "level": 3
    },
    {
        "id": 511803,
        "region_name": "名山区",
        "parent_id": 511800,
        "level": 3
    },
    {
        "id": 511822,
        "region_name": "荥经县",
        "parent_id": 511800,
        "level": 3
    },
    {
        "id": 511823,
        "region_name": "汉源县",
        "parent_id": 511800,
        "level": 3
    },
    {
        "id": 511824,
        "region_name": "石棉县",
        "parent_id": 511800,
        "level": 3
    },
    {
        "id": 511825,
        "region_name": "天全县",
        "parent_id": 511800,
        "level": 3
    },
    {
        "id": 511826,
        "region_name": "芦山县",
        "parent_id": 511800,
        "level": 3
    },
    {
        "id": 511827,
        "region_name": "宝兴县",
        "parent_id": 511800,
        "level": 3
    },
    {
        "id": 511900,
        "region_name": "巴中市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 511902,
        "region_name": "巴州区",
        "parent_id": 511900,
        "level": 3
    },
    {
        "id": 511903,
        "region_name": "恩阳区",
        "parent_id": 511900,
        "level": 3
    },
    {
        "id": 511921,
        "region_name": "通江县",
        "parent_id": 511900,
        "level": 3
    },
    {
        "id": 511922,
        "region_name": "南江县",
        "parent_id": 511900,
        "level": 3
    },
    {
        "id": 511923,
        "region_name": "平昌县",
        "parent_id": 511900,
        "level": 3
    },
    {
        "id": 512000,
        "region_name": "资阳市",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 512002,
        "region_name": "雁江区",
        "parent_id": 512000,
        "level": 3
    },
    {
        "id": 512021,
        "region_name": "安岳县",
        "parent_id": 512000,
        "level": 3
    },
    {
        "id": 512022,
        "region_name": "乐至县",
        "parent_id": 512000,
        "level": 3
    },
    {
        "id": 513200,
        "region_name": "阿坝藏族羌族自治州",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 513201,
        "region_name": "马尔康市",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513221,
        "region_name": "汶川县",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513222,
        "region_name": "理县",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513223,
        "region_name": "茂县",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513224,
        "region_name": "松潘县",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513225,
        "region_name": "九寨沟县",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513226,
        "region_name": "金川县",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513227,
        "region_name": "小金县",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513228,
        "region_name": "黑水县",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513230,
        "region_name": "壤塘县",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513231,
        "region_name": "阿坝县",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513232,
        "region_name": "若尔盖县",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513233,
        "region_name": "红原县",
        "parent_id": 513200,
        "level": 3
    },
    {
        "id": 513300,
        "region_name": "甘孜藏族自治州",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 513301,
        "region_name": "康定市",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513322,
        "region_name": "泸定县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513323,
        "region_name": "丹巴县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513324,
        "region_name": "九龙县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513325,
        "region_name": "雅江县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513326,
        "region_name": "道孚县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513327,
        "region_name": "炉霍县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513328,
        "region_name": "甘孜县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513329,
        "region_name": "新龙县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513330,
        "region_name": "德格县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513331,
        "region_name": "白玉县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513332,
        "region_name": "石渠县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513333,
        "region_name": "色达县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513334,
        "region_name": "理塘县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513335,
        "region_name": "巴塘县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513336,
        "region_name": "乡城县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513337,
        "region_name": "稻城县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513338,
        "region_name": "得荣县",
        "parent_id": 513300,
        "level": 3
    },
    {
        "id": 513400,
        "region_name": "凉山彝族自治州",
        "parent_id": 510000,
        "level": 2
    },
    {
        "id": 513401,
        "region_name": "西昌市",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513422,
        "region_name": "木里藏族自治县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513423,
        "region_name": "盐源县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513424,
        "region_name": "德昌县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513425,
        "region_name": "会理县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513426,
        "region_name": "会东县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513427,
        "region_name": "宁南县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513428,
        "region_name": "普格县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513429,
        "region_name": "布拖县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513430,
        "region_name": "金阳县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513431,
        "region_name": "昭觉县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513432,
        "region_name": "喜德县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513433,
        "region_name": "冕宁县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513434,
        "region_name": "越西县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513435,
        "region_name": "甘洛县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513436,
        "region_name": "美姑县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 513437,
        "region_name": "雷波县",
        "parent_id": 513400,
        "level": 3
    },
    {
        "id": 520000,
        "region_name": "贵州省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 520100,
        "region_name": "贵阳市",
        "parent_id": 520000,
        "level": 2
    },
    {
        "id": 520102,
        "region_name": "南明区",
        "parent_id": 520100,
        "level": 3
    },
    {
        "id": 520103,
        "region_name": "云岩区",
        "parent_id": 520100,
        "level": 3
    },
    {
        "id": 520111,
        "region_name": "花溪区",
        "parent_id": 520100,
        "level": 3
    },
    {
        "id": 520112,
        "region_name": "乌当区",
        "parent_id": 520100,
        "level": 3
    },
    {
        "id": 520113,
        "region_name": "白云区",
        "parent_id": 520100,
        "level": 3
    },
    {
        "id": 520115,
        "region_name": "观山湖区",
        "parent_id": 520100,
        "level": 3
    },
    {
        "id": 520121,
        "region_name": "开阳县",
        "parent_id": 520100,
        "level": 3
    },
    {
        "id": 520122,
        "region_name": "息烽县",
        "parent_id": 520100,
        "level": 3
    },
    {
        "id": 520123,
        "region_name": "修文县",
        "parent_id": 520100,
        "level": 3
    },
    {
        "id": 520181,
        "region_name": "清镇市",
        "parent_id": 520100,
        "level": 3
    },
    {
        "id": 520200,
        "region_name": "六盘水市",
        "parent_id": 520000,
        "level": 2
    },
    {
        "id": 520201,
        "region_name": "钟山区",
        "parent_id": 520200,
        "level": 3
    },
    {
        "id": 520203,
        "region_name": "六枝特区",
        "parent_id": 520200,
        "level": 3
    },
    {
        "id": 520221,
        "region_name": "水城县",
        "parent_id": 520200,
        "level": 3
    },
    {
        "id": 520281,
        "region_name": "盘州市",
        "parent_id": 520200,
        "level": 3
    },
    {
        "id": 520300,
        "region_name": "遵义市",
        "parent_id": 520000,
        "level": 2
    },
    {
        "id": 520302,
        "region_name": "红花岗区",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520303,
        "region_name": "汇川区",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520304,
        "region_name": "播州区",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520322,
        "region_name": "桐梓县",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520323,
        "region_name": "绥阳县",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520324,
        "region_name": "正安县",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520325,
        "region_name": "道真仡佬族苗族自治县",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520326,
        "region_name": "务川仡佬族苗族自治县",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520327,
        "region_name": "凤冈县",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520328,
        "region_name": "湄潭县",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520329,
        "region_name": "余庆县",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520330,
        "region_name": "习水县",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520381,
        "region_name": "赤水市",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520382,
        "region_name": "仁怀市",
        "parent_id": 520300,
        "level": 3
    },
    {
        "id": 520400,
        "region_name": "安顺市",
        "parent_id": 520000,
        "level": 2
    },
    {
        "id": 520402,
        "region_name": "西秀区",
        "parent_id": 520400,
        "level": 3
    },
    {
        "id": 520403,
        "region_name": "平坝区",
        "parent_id": 520400,
        "level": 3
    },
    {
        "id": 520422,
        "region_name": "普定县",
        "parent_id": 520400,
        "level": 3
    },
    {
        "id": 520423,
        "region_name": "镇宁布依族苗族自治县",
        "parent_id": 520400,
        "level": 3
    },
    {
        "id": 520424,
        "region_name": "关岭布依族苗族自治县",
        "parent_id": 520400,
        "level": 3
    },
    {
        "id": 520425,
        "region_name": "紫云苗族布依族自治县",
        "parent_id": 520400,
        "level": 3
    },
    {
        "id": 520500,
        "region_name": "毕节市",
        "parent_id": 520000,
        "level": 2
    },
    {
        "id": 520502,
        "region_name": "七星关区",
        "parent_id": 520500,
        "level": 3
    },
    {
        "id": 520521,
        "region_name": "大方县",
        "parent_id": 520500,
        "level": 3
    },
    {
        "id": 520522,
        "region_name": "黔西县",
        "parent_id": 520500,
        "level": 3
    },
    {
        "id": 520523,
        "region_name": "金沙县",
        "parent_id": 520500,
        "level": 3
    },
    {
        "id": 520524,
        "region_name": "织金县",
        "parent_id": 520500,
        "level": 3
    },
    {
        "id": 520525,
        "region_name": "纳雍县",
        "parent_id": 520500,
        "level": 3
    },
    {
        "id": 520526,
        "region_name": "威宁彝族回族苗族自治县",
        "parent_id": 520500,
        "level": 3
    },
    {
        "id": 520527,
        "region_name": "赫章县",
        "parent_id": 520500,
        "level": 3
    },
    {
        "id": 520600,
        "region_name": "铜仁市",
        "parent_id": 520000,
        "level": 2
    },
    {
        "id": 520602,
        "region_name": "碧江区",
        "parent_id": 520600,
        "level": 3
    },
    {
        "id": 520603,
        "region_name": "万山区",
        "parent_id": 520600,
        "level": 3
    },
    {
        "id": 520621,
        "region_name": "江口县",
        "parent_id": 520600,
        "level": 3
    },
    {
        "id": 520622,
        "region_name": "玉屏侗族自治县",
        "parent_id": 520600,
        "level": 3
    },
    {
        "id": 520623,
        "region_name": "石阡县",
        "parent_id": 520600,
        "level": 3
    },
    {
        "id": 520624,
        "region_name": "思南县",
        "parent_id": 520600,
        "level": 3
    },
    {
        "id": 520625,
        "region_name": "印江土家族苗族自治县",
        "parent_id": 520600,
        "level": 3
    },
    {
        "id": 520626,
        "region_name": "德江县",
        "parent_id": 520600,
        "level": 3
    },
    {
        "id": 520627,
        "region_name": "沿河土家族自治县",
        "parent_id": 520600,
        "level": 3
    },
    {
        "id": 520628,
        "region_name": "松桃苗族自治县",
        "parent_id": 520600,
        "level": 3
    },
    {
        "id": 522300,
        "region_name": "黔西南布依族苗族自治州",
        "parent_id": 520000,
        "level": 2
    },
    {
        "id": 522301,
        "region_name": "兴义市",
        "parent_id": 522300,
        "level": 3
    },
    {
        "id": 522322,
        "region_name": "兴仁县",
        "parent_id": 522300,
        "level": 3
    },
    {
        "id": 522323,
        "region_name": "普安县",
        "parent_id": 522300,
        "level": 3
    },
    {
        "id": 522324,
        "region_name": "晴隆县",
        "parent_id": 522300,
        "level": 3
    },
    {
        "id": 522325,
        "region_name": "贞丰县",
        "parent_id": 522300,
        "level": 3
    },
    {
        "id": 522326,
        "region_name": "望谟县",
        "parent_id": 522300,
        "level": 3
    },
    {
        "id": 522327,
        "region_name": "册亨县",
        "parent_id": 522300,
        "level": 3
    },
    {
        "id": 522328,
        "region_name": "安龙县",
        "parent_id": 522300,
        "level": 3
    },
    {
        "id": 522600,
        "region_name": "黔东南苗族侗族自治州",
        "parent_id": 520000,
        "level": 2
    },
    {
        "id": 522601,
        "region_name": "凯里市",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522622,
        "region_name": "黄平县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522623,
        "region_name": "施秉县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522624,
        "region_name": "三穗县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522625,
        "region_name": "镇远县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522626,
        "region_name": "岑巩县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522627,
        "region_name": "天柱县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522628,
        "region_name": "锦屏县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522629,
        "region_name": "剑河县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522630,
        "region_name": "台江县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522631,
        "region_name": "黎平县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522632,
        "region_name": "榕江县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522633,
        "region_name": "从江县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522634,
        "region_name": "雷山县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522635,
        "region_name": "麻江县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522636,
        "region_name": "丹寨县",
        "parent_id": 522600,
        "level": 3
    },
    {
        "id": 522700,
        "region_name": "黔南布依族苗族自治州",
        "parent_id": 520000,
        "level": 2
    },
    {
        "id": 522701,
        "region_name": "都匀市",
        "parent_id": 522700,
        "level": 3
    },
    {
        "id": 522702,
        "region_name": "福泉市",
        "parent_id": 522700,
        "level": 3
    },
    {
        "id": 522722,
        "region_name": "荔波县",
        "parent_id": 522700,
        "level": 3
    },
    {
        "id": 522723,
        "region_name": "贵定县",
        "parent_id": 522700,
        "level": 3
    },
    {
        "id": 522725,
        "region_name": "瓮安县",
        "parent_id": 522700,
        "level": 3
    },
    {
        "id": 522726,
        "region_name": "独山县",
        "parent_id": 522700,
        "level": 3
    },
    {
        "id": 522727,
        "region_name": "平塘县",
        "parent_id": 522700,
        "level": 3
    },
    {
        "id": 522728,
        "region_name": "罗甸县",
        "parent_id": 522700,
        "level": 3
    },
    {
        "id": 522729,
        "region_name": "长顺县",
        "parent_id": 522700,
        "level": 3
    },
    {
        "id": 522730,
        "region_name": "龙里县",
        "parent_id": 522700,
        "level": 3
    },
    {
        "id": 522731,
        "region_name": "惠水县",
        "parent_id": 522700,
        "level": 3
    },
    {
        "id": 522732,
        "region_name": "三都水族自治县",
        "parent_id": 522700,
        "level": 3
    },
    {
        "id": 530000,
        "region_name": "云南省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 530100,
        "region_name": "昆明市",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 530102,
        "region_name": "五华区",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530103,
        "region_name": "盘龙区",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530111,
        "region_name": "官渡区",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530112,
        "region_name": "西山区",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530113,
        "region_name": "东川区",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530114,
        "region_name": "呈贡区",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530115,
        "region_name": "晋宁区",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530124,
        "region_name": "富民县",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530125,
        "region_name": "宜良县",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530126,
        "region_name": "石林彝族自治县",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530127,
        "region_name": "嵩明县",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530128,
        "region_name": "禄劝彝族苗族自治县",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530129,
        "region_name": "寻甸回族彝族自治县",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530181,
        "region_name": "安宁市",
        "parent_id": 530100,
        "level": 3
    },
    {
        "id": 530300,
        "region_name": "曲靖市",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 530302,
        "region_name": "麒麟区",
        "parent_id": 530300,
        "level": 3
    },
    {
        "id": 530303,
        "region_name": "沾益区",
        "parent_id": 530300,
        "level": 3
    },
    {
        "id": 530304,
        "region_name": "马龙区",
        "parent_id": 530300,
        "level": 3
    },
    {
        "id": 530322,
        "region_name": "陆良县",
        "parent_id": 530300,
        "level": 3
    },
    {
        "id": 530323,
        "region_name": "师宗县",
        "parent_id": 530300,
        "level": 3
    },
    {
        "id": 530324,
        "region_name": "罗平县",
        "parent_id": 530300,
        "level": 3
    },
    {
        "id": 530325,
        "region_name": "富源县",
        "parent_id": 530300,
        "level": 3
    },
    {
        "id": 530326,
        "region_name": "会泽县",
        "parent_id": 530300,
        "level": 3
    },
    {
        "id": 530381,
        "region_name": "宣威市",
        "parent_id": 530300,
        "level": 3
    },
    {
        "id": 530400,
        "region_name": "玉溪市",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 530402,
        "region_name": "红塔区",
        "parent_id": 530400,
        "level": 3
    },
    {
        "id": 530403,
        "region_name": "江川区",
        "parent_id": 530400,
        "level": 3
    },
    {
        "id": 530422,
        "region_name": "澄江县",
        "parent_id": 530400,
        "level": 3
    },
    {
        "id": 530423,
        "region_name": "通海县",
        "parent_id": 530400,
        "level": 3
    },
    {
        "id": 530424,
        "region_name": "华宁县",
        "parent_id": 530400,
        "level": 3
    },
    {
        "id": 530425,
        "region_name": "易门县",
        "parent_id": 530400,
        "level": 3
    },
    {
        "id": 530426,
        "region_name": "峨山彝族自治县",
        "parent_id": 530400,
        "level": 3
    },
    {
        "id": 530427,
        "region_name": "新平彝族傣族自治县",
        "parent_id": 530400,
        "level": 3
    },
    {
        "id": 530428,
        "region_name": "元江哈尼族彝族傣族自治县",
        "parent_id": 530400,
        "level": 3
    },
    {
        "id": 530500,
        "region_name": "保山市",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 530502,
        "region_name": "隆阳区",
        "parent_id": 530500,
        "level": 3
    },
    {
        "id": 530521,
        "region_name": "施甸县",
        "parent_id": 530500,
        "level": 3
    },
    {
        "id": 530523,
        "region_name": "龙陵县",
        "parent_id": 530500,
        "level": 3
    },
    {
        "id": 530524,
        "region_name": "昌宁县",
        "parent_id": 530500,
        "level": 3
    },
    {
        "id": 530581,
        "region_name": "腾冲市",
        "parent_id": 530500,
        "level": 3
    },
    {
        "id": 530600,
        "region_name": "昭通市",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 530602,
        "region_name": "昭阳区",
        "parent_id": 530600,
        "level": 3
    },
    {
        "id": 530621,
        "region_name": "鲁甸县",
        "parent_id": 530600,
        "level": 3
    },
    {
        "id": 530622,
        "region_name": "巧家县",
        "parent_id": 530600,
        "level": 3
    },
    {
        "id": 530623,
        "region_name": "盐津县",
        "parent_id": 530600,
        "level": 3
    },
    {
        "id": 530624,
        "region_name": "大关县",
        "parent_id": 530600,
        "level": 3
    },
    {
        "id": 530625,
        "region_name": "永善县",
        "parent_id": 530600,
        "level": 3
    },
    {
        "id": 530626,
        "region_name": "绥江县",
        "parent_id": 530600,
        "level": 3
    },
    {
        "id": 530627,
        "region_name": "镇雄县",
        "parent_id": 530600,
        "level": 3
    },
    {
        "id": 530628,
        "region_name": "彝良县",
        "parent_id": 530600,
        "level": 3
    },
    {
        "id": 530629,
        "region_name": "威信县",
        "parent_id": 530600,
        "level": 3
    },
    {
        "id": 530630,
        "region_name": "水富县",
        "parent_id": 530600,
        "level": 3
    },
    {
        "id": 530700,
        "region_name": "丽江市",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 530702,
        "region_name": "古城区",
        "parent_id": 530700,
        "level": 3
    },
    {
        "id": 530721,
        "region_name": "玉龙纳西族自治县",
        "parent_id": 530700,
        "level": 3
    },
    {
        "id": 530722,
        "region_name": "永胜县",
        "parent_id": 530700,
        "level": 3
    },
    {
        "id": 530723,
        "region_name": "华坪县",
        "parent_id": 530700,
        "level": 3
    },
    {
        "id": 530724,
        "region_name": "宁蒗彝族自治县",
        "parent_id": 530700,
        "level": 3
    },
    {
        "id": 530800,
        "region_name": "普洱市",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 530802,
        "region_name": "思茅区",
        "parent_id": 530800,
        "level": 3
    },
    {
        "id": 530821,
        "region_name": "宁洱哈尼族彝族自治县",
        "parent_id": 530800,
        "level": 3
    },
    {
        "id": 530822,
        "region_name": "墨江哈尼族自治县",
        "parent_id": 530800,
        "level": 3
    },
    {
        "id": 530823,
        "region_name": "景东彝族自治县",
        "parent_id": 530800,
        "level": 3
    },
    {
        "id": 530824,
        "region_name": "景谷傣族彝族自治县",
        "parent_id": 530800,
        "level": 3
    },
    {
        "id": 530825,
        "region_name": "镇沅彝族哈尼族拉祜族自治县",
        "parent_id": 530800,
        "level": 3
    },
    {
        "id": 530826,
        "region_name": "江城哈尼族彝族自治县",
        "parent_id": 530800,
        "level": 3
    },
    {
        "id": 530827,
        "region_name": "孟连傣族拉祜族佤族自治县",
        "parent_id": 530800,
        "level": 3
    },
    {
        "id": 530828,
        "region_name": "澜沧拉祜族自治县",
        "parent_id": 530800,
        "level": 3
    },
    {
        "id": 530829,
        "region_name": "西盟佤族自治县",
        "parent_id": 530800,
        "level": 3
    },
    {
        "id": 530900,
        "region_name": "临沧市",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 530902,
        "region_name": "临翔区",
        "parent_id": 530900,
        "level": 3
    },
    {
        "id": 530921,
        "region_name": "凤庆县",
        "parent_id": 530900,
        "level": 3
    },
    {
        "id": 530922,
        "region_name": "云县",
        "parent_id": 530900,
        "level": 3
    },
    {
        "id": 530923,
        "region_name": "永德县",
        "parent_id": 530900,
        "level": 3
    },
    {
        "id": 530924,
        "region_name": "镇康县",
        "parent_id": 530900,
        "level": 3
    },
    {
        "id": 530925,
        "region_name": "双江拉祜族佤族布朗族傣族自治县",
        "parent_id": 530900,
        "level": 3
    },
    {
        "id": 530926,
        "region_name": "耿马傣族佤族自治县",
        "parent_id": 530900,
        "level": 3
    },
    {
        "id": 530927,
        "region_name": "沧源佤族自治县",
        "parent_id": 530900,
        "level": 3
    },
    {
        "id": 532300,
        "region_name": "楚雄彝族自治州",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 532301,
        "region_name": "楚雄市",
        "parent_id": 532300,
        "level": 3
    },
    {
        "id": 532322,
        "region_name": "双柏县",
        "parent_id": 532300,
        "level": 3
    },
    {
        "id": 532323,
        "region_name": "牟定县",
        "parent_id": 532300,
        "level": 3
    },
    {
        "id": 532324,
        "region_name": "南华县",
        "parent_id": 532300,
        "level": 3
    },
    {
        "id": 532325,
        "region_name": "姚安县",
        "parent_id": 532300,
        "level": 3
    },
    {
        "id": 532326,
        "region_name": "大姚县",
        "parent_id": 532300,
        "level": 3
    },
    {
        "id": 532327,
        "region_name": "永仁县",
        "parent_id": 532300,
        "level": 3
    },
    {
        "id": 532328,
        "region_name": "元谋县",
        "parent_id": 532300,
        "level": 3
    },
    {
        "id": 532329,
        "region_name": "武定县",
        "parent_id": 532300,
        "level": 3
    },
    {
        "id": 532331,
        "region_name": "禄丰县",
        "parent_id": 532300,
        "level": 3
    },
    {
        "id": 532500,
        "region_name": "红河哈尼族彝族自治州",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 532501,
        "region_name": "个旧市",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532502,
        "region_name": "开远市",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532503,
        "region_name": "蒙自市",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532504,
        "region_name": "弥勒市",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532523,
        "region_name": "屏边苗族自治县",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532524,
        "region_name": "建水县",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532525,
        "region_name": "石屏县",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532527,
        "region_name": "泸西县",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532528,
        "region_name": "元阳县",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532529,
        "region_name": "红河县",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532530,
        "region_name": "金平苗族瑶族傣族自治县",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532531,
        "region_name": "绿春县",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532532,
        "region_name": "河口瑶族自治县",
        "parent_id": 532500,
        "level": 3
    },
    {
        "id": 532600,
        "region_name": "文山壮族苗族自治州",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 532601,
        "region_name": "文山市",
        "parent_id": 532600,
        "level": 3
    },
    {
        "id": 532622,
        "region_name": "砚山县",
        "parent_id": 532600,
        "level": 3
    },
    {
        "id": 532623,
        "region_name": "西畴县",
        "parent_id": 532600,
        "level": 3
    },
    {
        "id": 532624,
        "region_name": "麻栗坡县",
        "parent_id": 532600,
        "level": 3
    },
    {
        "id": 532625,
        "region_name": "马关县",
        "parent_id": 532600,
        "level": 3
    },
    {
        "id": 532626,
        "region_name": "丘北县",
        "parent_id": 532600,
        "level": 3
    },
    {
        "id": 532627,
        "region_name": "广南县",
        "parent_id": 532600,
        "level": 3
    },
    {
        "id": 532628,
        "region_name": "富宁县",
        "parent_id": 532600,
        "level": 3
    },
    {
        "id": 532800,
        "region_name": "西双版纳傣族自治州",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 532801,
        "region_name": "景洪市",
        "parent_id": 532800,
        "level": 3
    },
    {
        "id": 532822,
        "region_name": "勐海县",
        "parent_id": 532800,
        "level": 3
    },
    {
        "id": 532823,
        "region_name": "勐腊县",
        "parent_id": 532800,
        "level": 3
    },
    {
        "id": 532900,
        "region_name": "大理白族自治州",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 532901,
        "region_name": "大理市",
        "parent_id": 532900,
        "level": 3
    },
    {
        "id": 532922,
        "region_name": "漾濞彝族自治县",
        "parent_id": 532900,
        "level": 3
    },
    {
        "id": 532923,
        "region_name": "祥云县",
        "parent_id": 532900,
        "level": 3
    },
    {
        "id": 532924,
        "region_name": "宾川县",
        "parent_id": 532900,
        "level": 3
    },
    {
        "id": 532925,
        "region_name": "弥渡县",
        "parent_id": 532900,
        "level": 3
    },
    {
        "id": 532926,
        "region_name": "南涧彝族自治县",
        "parent_id": 532900,
        "level": 3
    },
    {
        "id": 532927,
        "region_name": "巍山彝族回族自治县",
        "parent_id": 532900,
        "level": 3
    },
    {
        "id": 532928,
        "region_name": "永平县",
        "parent_id": 532900,
        "level": 3
    },
    {
        "id": 532929,
        "region_name": "云龙县",
        "parent_id": 532900,
        "level": 3
    },
    {
        "id": 532930,
        "region_name": "洱源县",
        "parent_id": 532900,
        "level": 3
    },
    {
        "id": 532931,
        "region_name": "剑川县",
        "parent_id": 532900,
        "level": 3
    },
    {
        "id": 532932,
        "region_name": "鹤庆县",
        "parent_id": 532900,
        "level": 3
    },
    {
        "id": 533100,
        "region_name": "德宏傣族景颇族自治州",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 533102,
        "region_name": "瑞丽市",
        "parent_id": 533100,
        "level": 3
    },
    {
        "id": 533103,
        "region_name": "芒市",
        "parent_id": 533100,
        "level": 3
    },
    {
        "id": 533122,
        "region_name": "梁河县",
        "parent_id": 533100,
        "level": 3
    },
    {
        "id": 533123,
        "region_name": "盈江县",
        "parent_id": 533100,
        "level": 3
    },
    {
        "id": 533124,
        "region_name": "陇川县",
        "parent_id": 533100,
        "level": 3
    },
    {
        "id": 533300,
        "region_name": "怒江傈僳族自治州",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 533301,
        "region_name": "泸水市",
        "parent_id": 533300,
        "level": 3
    },
    {
        "id": 533323,
        "region_name": "福贡县",
        "parent_id": 533300,
        "level": 3
    },
    {
        "id": 533324,
        "region_name": "贡山独龙族怒族自治县",
        "parent_id": 533300,
        "level": 3
    },
    {
        "id": 533325,
        "region_name": "兰坪白族普米族自治县",
        "parent_id": 533300,
        "level": 3
    },
    {
        "id": 533400,
        "region_name": "迪庆藏族自治州",
        "parent_id": 530000,
        "level": 2
    },
    {
        "id": 533401,
        "region_name": "香格里拉市",
        "parent_id": 533400,
        "level": 3
    },
    {
        "id": 533422,
        "region_name": "德钦县",
        "parent_id": 533400,
        "level": 3
    },
    {
        "id": 533423,
        "region_name": "维西傈僳族自治县",
        "parent_id": 533400,
        "level": 3
    },
    {
        "id": 540000,
        "region_name": "西藏自治区",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 540100,
        "region_name": "拉萨市",
        "parent_id": 540000,
        "level": 2
    },
    {
        "id": 540102,
        "region_name": "城关区",
        "parent_id": 540100,
        "level": 3
    },
    {
        "id": 540103,
        "region_name": "堆龙德庆区",
        "parent_id": 540100,
        "level": 3
    },
    {
        "id": 540104,
        "region_name": "达孜区",
        "parent_id": 540100,
        "level": 3
    },
    {
        "id": 540121,
        "region_name": "林周县",
        "parent_id": 540100,
        "level": 3
    },
    {
        "id": 540122,
        "region_name": "当雄县",
        "parent_id": 540100,
        "level": 3
    },
    {
        "id": 540123,
        "region_name": "尼木县",
        "parent_id": 540100,
        "level": 3
    },
    {
        "id": 540124,
        "region_name": "曲水县",
        "parent_id": 540100,
        "level": 3
    },
    {
        "id": 540127,
        "region_name": "墨竹工卡县",
        "parent_id": 540100,
        "level": 3
    },
    {
        "id": 540200,
        "region_name": "日喀则市",
        "parent_id": 540000,
        "level": 2
    },
    {
        "id": 540202,
        "region_name": "桑珠孜区",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540221,
        "region_name": "南木林县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540222,
        "region_name": "江孜县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540223,
        "region_name": "定日县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540224,
        "region_name": "萨迦县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540225,
        "region_name": "拉孜县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540226,
        "region_name": "昂仁县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540227,
        "region_name": "谢通门县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540228,
        "region_name": "白朗县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540229,
        "region_name": "仁布县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540230,
        "region_name": "康马县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540231,
        "region_name": "定结县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540232,
        "region_name": "仲巴县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540233,
        "region_name": "亚东县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540234,
        "region_name": "吉隆县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540235,
        "region_name": "聂拉木县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540236,
        "region_name": "萨嘎县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540237,
        "region_name": "岗巴县",
        "parent_id": 540200,
        "level": 3
    },
    {
        "id": 540300,
        "region_name": "昌都市",
        "parent_id": 540000,
        "level": 2
    },
    {
        "id": 540302,
        "region_name": "卡若区",
        "parent_id": 540300,
        "level": 3
    },
    {
        "id": 540321,
        "region_name": "江达县",
        "parent_id": 540300,
        "level": 3
    },
    {
        "id": 540322,
        "region_name": "贡觉县",
        "parent_id": 540300,
        "level": 3
    },
    {
        "id": 540323,
        "region_name": "类乌齐县",
        "parent_id": 540300,
        "level": 3
    },
    {
        "id": 540324,
        "region_name": "丁青县",
        "parent_id": 540300,
        "level": 3
    },
    {
        "id": 540325,
        "region_name": "察雅县",
        "parent_id": 540300,
        "level": 3
    },
    {
        "id": 540326,
        "region_name": "八宿县",
        "parent_id": 540300,
        "level": 3
    },
    {
        "id": 540327,
        "region_name": "左贡县",
        "parent_id": 540300,
        "level": 3
    },
    {
        "id": 540328,
        "region_name": "芒康县",
        "parent_id": 540300,
        "level": 3
    },
    {
        "id": 540329,
        "region_name": "洛隆县",
        "parent_id": 540300,
        "level": 3
    },
    {
        "id": 540330,
        "region_name": "边坝县",
        "parent_id": 540300,
        "level": 3
    },
    {
        "id": 540400,
        "region_name": "林芝市",
        "parent_id": 540000,
        "level": 2
    },
    {
        "id": 540402,
        "region_name": "巴宜区",
        "parent_id": 540400,
        "level": 3
    },
    {
        "id": 540421,
        "region_name": "工布江达县",
        "parent_id": 540400,
        "level": 3
    },
    {
        "id": 540422,
        "region_name": "米林县",
        "parent_id": 540400,
        "level": 3
    },
    {
        "id": 540423,
        "region_name": "墨脱县",
        "parent_id": 540400,
        "level": 3
    },
    {
        "id": 540424,
        "region_name": "波密县",
        "parent_id": 540400,
        "level": 3
    },
    {
        "id": 540425,
        "region_name": "察隅县",
        "parent_id": 540400,
        "level": 3
    },
    {
        "id": 540426,
        "region_name": "朗县",
        "parent_id": 540400,
        "level": 3
    },
    {
        "id": 540500,
        "region_name": "山南市",
        "parent_id": 540000,
        "level": 2
    },
    {
        "id": 540502,
        "region_name": "乃东区",
        "parent_id": 540500,
        "level": 3
    },
    {
        "id": 540521,
        "region_name": "扎囊县",
        "parent_id": 540500,
        "level": 3
    },
    {
        "id": 540522,
        "region_name": "贡嘎县",
        "parent_id": 540500,
        "level": 3
    },
    {
        "id": 540523,
        "region_name": "桑日县",
        "parent_id": 540500,
        "level": 3
    },
    {
        "id": 540524,
        "region_name": "琼结县",
        "parent_id": 540500,
        "level": 3
    },
    {
        "id": 540525,
        "region_name": "曲松县",
        "parent_id": 540500,
        "level": 3
    },
    {
        "id": 540526,
        "region_name": "措美县",
        "parent_id": 540500,
        "level": 3
    },
    {
        "id": 540527,
        "region_name": "洛扎县",
        "parent_id": 540500,
        "level": 3
    },
    {
        "id": 540528,
        "region_name": "加查县",
        "parent_id": 540500,
        "level": 3
    },
    {
        "id": 540529,
        "region_name": "隆子县",
        "parent_id": 540500,
        "level": 3
    },
    {
        "id": 540530,
        "region_name": "错那县",
        "parent_id": 540500,
        "level": 3
    },
    {
        "id": 540531,
        "region_name": "浪卡子县",
        "parent_id": 540500,
        "level": 3
    },
    {
        "id": 540600,
        "region_name": "那曲市",
        "parent_id": 540000,
        "level": 2
    },
    {
        "id": 540602,
        "region_name": "色尼区",
        "parent_id": 540600,
        "level": 3
    },
    {
        "id": 540621,
        "region_name": "嘉黎县 ",
        "parent_id": 540600,
        "level": 3
    },
    {
        "id": 540622,
        "region_name": "比如县 ",
        "parent_id": 540600,
        "level": 3
    },
    {
        "id": 540623,
        "region_name": "聂荣县 ",
        "parent_id": 540600,
        "level": 3
    },
    {
        "id": 540624,
        "region_name": "安多县 ",
        "parent_id": 540600,
        "level": 3
    },
    {
        "id": 540625,
        "region_name": "申扎县 ",
        "parent_id": 540600,
        "level": 3
    },
    {
        "id": 540626,
        "region_name": "索县   ",
        "parent_id": 540600,
        "level": 3
    },
    {
        "id": 540627,
        "region_name": "班戈县 ",
        "parent_id": 540600,
        "level": 3
    },
    {
        "id": 540628,
        "region_name": "巴青县 ",
        "parent_id": 540600,
        "level": 3
    },
    {
        "id": 540629,
        "region_name": "尼玛县 ",
        "parent_id": 540600,
        "level": 3
    },
    {
        "id": 540630,
        "region_name": "双湖县 ",
        "parent_id": 540600,
        "level": 3
    },
    {
        "id": 542500,
        "region_name": "阿里地区",
        "parent_id": 540000,
        "level": 2
    },
    {
        "id": 542521,
        "region_name": "普兰县",
        "parent_id": 542500,
        "level": 3
    },
    {
        "id": 542522,
        "region_name": "札达县",
        "parent_id": 542500,
        "level": 3
    },
    {
        "id": 542523,
        "region_name": "噶尔县",
        "parent_id": 542500,
        "level": 3
    },
    {
        "id": 542524,
        "region_name": "日土县",
        "parent_id": 542500,
        "level": 3
    },
    {
        "id": 542525,
        "region_name": "革吉县",
        "parent_id": 542500,
        "level": 3
    },
    {
        "id": 542526,
        "region_name": "改则县",
        "parent_id": 542500,
        "level": 3
    },
    {
        "id": 542527,
        "region_name": "措勤县",
        "parent_id": 542500,
        "level": 3
    },
    {
        "id": 610000,
        "region_name": "陕西省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 610100,
        "region_name": "西安市",
        "parent_id": 610000,
        "level": 2
    },
    {
        "id": 610102,
        "region_name": "新城区",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610103,
        "region_name": "碑林区",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610104,
        "region_name": "莲湖区",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610111,
        "region_name": "灞桥区",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610112,
        "region_name": "未央区",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610113,
        "region_name": "雁塔区",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610114,
        "region_name": "阎良区",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610115,
        "region_name": "临潼区",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610116,
        "region_name": "长安区",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610117,
        "region_name": "高陵区",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610118,
        "region_name": "鄠邑区",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610122,
        "region_name": "蓝田县",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610124,
        "region_name": "周至县",
        "parent_id": 610100,
        "level": 3
    },
    {
        "id": 610200,
        "region_name": "铜川市",
        "parent_id": 610000,
        "level": 2
    },
    {
        "id": 610202,
        "region_name": "王益区",
        "parent_id": 610200,
        "level": 3
    },
    {
        "id": 610203,
        "region_name": "印台区",
        "parent_id": 610200,
        "level": 3
    },
    {
        "id": 610204,
        "region_name": "耀州区",
        "parent_id": 610200,
        "level": 3
    },
    {
        "id": 610222,
        "region_name": "宜君县",
        "parent_id": 610200,
        "level": 3
    },
    {
        "id": 610300,
        "region_name": "宝鸡市",
        "parent_id": 610000,
        "level": 2
    },
    {
        "id": 610302,
        "region_name": "渭滨区",
        "parent_id": 610300,
        "level": 3
    },
    {
        "id": 610303,
        "region_name": "金台区",
        "parent_id": 610300,
        "level": 3
    },
    {
        "id": 610304,
        "region_name": "陈仓区",
        "parent_id": 610300,
        "level": 3
    },
    {
        "id": 610322,
        "region_name": "凤翔县",
        "parent_id": 610300,
        "level": 3
    },
    {
        "id": 610323,
        "region_name": "岐山县",
        "parent_id": 610300,
        "level": 3
    },
    {
        "id": 610324,
        "region_name": "扶风县",
        "parent_id": 610300,
        "level": 3
    },
    {
        "id": 610326,
        "region_name": "眉县",
        "parent_id": 610300,
        "level": 3
    },
    {
        "id": 610327,
        "region_name": "陇县",
        "parent_id": 610300,
        "level": 3
    },
    {
        "id": 610328,
        "region_name": "千阳县",
        "parent_id": 610300,
        "level": 3
    },
    {
        "id": 610329,
        "region_name": "麟游县",
        "parent_id": 610300,
        "level": 3
    },
    {
        "id": 610330,
        "region_name": "凤县",
        "parent_id": 610300,
        "level": 3
    },
    {
        "id": 610331,
        "region_name": "太白县",
        "parent_id": 610300,
        "level": 3
    },
    {
        "id": 610400,
        "region_name": "咸阳市",
        "parent_id": 610000,
        "level": 2
    },
    {
        "id": 610402,
        "region_name": "秦都区",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610403,
        "region_name": "杨陵区",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610404,
        "region_name": "渭城区",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610422,
        "region_name": "三原县",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610423,
        "region_name": "泾阳县",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610424,
        "region_name": "乾县",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610425,
        "region_name": "礼泉县",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610426,
        "region_name": "永寿县",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610428,
        "region_name": "长武县",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610429,
        "region_name": "旬邑县",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610430,
        "region_name": "淳化县",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610431,
        "region_name": "武功县",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610481,
        "region_name": "兴平市",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610482,
        "region_name": "彬州市",
        "parent_id": 610400,
        "level": 3
    },
    {
        "id": 610500,
        "region_name": "渭南市",
        "parent_id": 610000,
        "level": 2
    },
    {
        "id": 610502,
        "region_name": "临渭区",
        "parent_id": 610500,
        "level": 3
    },
    {
        "id": 610503,
        "region_name": "华州区",
        "parent_id": 610500,
        "level": 3
    },
    {
        "id": 610522,
        "region_name": "潼关县",
        "parent_id": 610500,
        "level": 3
    },
    {
        "id": 610523,
        "region_name": "大荔县",
        "parent_id": 610500,
        "level": 3
    },
    {
        "id": 610524,
        "region_name": "合阳县",
        "parent_id": 610500,
        "level": 3
    },
    {
        "id": 610525,
        "region_name": "澄城县",
        "parent_id": 610500,
        "level": 3
    },
    {
        "id": 610526,
        "region_name": "蒲城县",
        "parent_id": 610500,
        "level": 3
    },
    {
        "id": 610527,
        "region_name": "白水县",
        "parent_id": 610500,
        "level": 3
    },
    {
        "id": 610528,
        "region_name": "富平县",
        "parent_id": 610500,
        "level": 3
    },
    {
        "id": 610581,
        "region_name": "韩城市",
        "parent_id": 610500,
        "level": 3
    },
    {
        "id": 610582,
        "region_name": "华阴市",
        "parent_id": 610500,
        "level": 3
    },
    {
        "id": 610600,
        "region_name": "延安市",
        "parent_id": 610000,
        "level": 2
    },
    {
        "id": 610602,
        "region_name": "宝塔区",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610603,
        "region_name": "安塞区",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610621,
        "region_name": "延长县",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610622,
        "region_name": "延川县",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610623,
        "region_name": "子长县",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610625,
        "region_name": "志丹县",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610626,
        "region_name": "吴起县",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610627,
        "region_name": "甘泉县",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610628,
        "region_name": "富县",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610629,
        "region_name": "洛川县",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610630,
        "region_name": "宜川县",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610631,
        "region_name": "黄龙县",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610632,
        "region_name": "黄陵县",
        "parent_id": 610600,
        "level": 3
    },
    {
        "id": 610700,
        "region_name": "汉中市",
        "parent_id": 610000,
        "level": 2
    },
    {
        "id": 610702,
        "region_name": "汉台区",
        "parent_id": 610700,
        "level": 3
    },
    {
        "id": 610703,
        "region_name": "南郑区",
        "parent_id": 610700,
        "level": 3
    },
    {
        "id": 610722,
        "region_name": "城固县",
        "parent_id": 610700,
        "level": 3
    },
    {
        "id": 610723,
        "region_name": "洋县",
        "parent_id": 610700,
        "level": 3
    },
    {
        "id": 610724,
        "region_name": "西乡县",
        "parent_id": 610700,
        "level": 3
    },
    {
        "id": 610725,
        "region_name": "勉县",
        "parent_id": 610700,
        "level": 3
    },
    {
        "id": 610726,
        "region_name": "宁强县",
        "parent_id": 610700,
        "level": 3
    },
    {
        "id": 610727,
        "region_name": "略阳县",
        "parent_id": 610700,
        "level": 3
    },
    {
        "id": 610728,
        "region_name": "镇巴县",
        "parent_id": 610700,
        "level": 3
    },
    {
        "id": 610729,
        "region_name": "留坝县",
        "parent_id": 610700,
        "level": 3
    },
    {
        "id": 610730,
        "region_name": "佛坪县",
        "parent_id": 610700,
        "level": 3
    },
    {
        "id": 610800,
        "region_name": "榆林市",
        "parent_id": 610000,
        "level": 2
    },
    {
        "id": 610802,
        "region_name": "榆阳区",
        "parent_id": 610800,
        "level": 3
    },
    {
        "id": 610803,
        "region_name": "横山区",
        "parent_id": 610800,
        "level": 3
    },
    {
        "id": 610822,
        "region_name": "府谷县",
        "parent_id": 610800,
        "level": 3
    },
    {
        "id": 610824,
        "region_name": "靖边县",
        "parent_id": 610800,
        "level": 3
    },
    {
        "id": 610825,
        "region_name": "定边县",
        "parent_id": 610800,
        "level": 3
    },
    {
        "id": 610826,
        "region_name": "绥德县",
        "parent_id": 610800,
        "level": 3
    },
    {
        "id": 610827,
        "region_name": "米脂县",
        "parent_id": 610800,
        "level": 3
    },
    {
        "id": 610828,
        "region_name": "佳县",
        "parent_id": 610800,
        "level": 3
    },
    {
        "id": 610829,
        "region_name": "吴堡县",
        "parent_id": 610800,
        "level": 3
    },
    {
        "id": 610830,
        "region_name": "清涧县",
        "parent_id": 610800,
        "level": 3
    },
    {
        "id": 610831,
        "region_name": "子洲县",
        "parent_id": 610800,
        "level": 3
    },
    {
        "id": 610881,
        "region_name": "神木市",
        "parent_id": 610800,
        "level": 3
    },
    {
        "id": 610900,
        "region_name": "安康市",
        "parent_id": 610000,
        "level": 2
    },
    {
        "id": 610902,
        "region_name": "汉滨区",
        "parent_id": 610900,
        "level": 3
    },
    {
        "id": 610921,
        "region_name": "汉阴县",
        "parent_id": 610900,
        "level": 3
    },
    {
        "id": 610922,
        "region_name": "石泉县",
        "parent_id": 610900,
        "level": 3
    },
    {
        "id": 610923,
        "region_name": "宁陕县",
        "parent_id": 610900,
        "level": 3
    },
    {
        "id": 610924,
        "region_name": "紫阳县",
        "parent_id": 610900,
        "level": 3
    },
    {
        "id": 610925,
        "region_name": "岚皋县",
        "parent_id": 610900,
        "level": 3
    },
    {
        "id": 610926,
        "region_name": "平利县",
        "parent_id": 610900,
        "level": 3
    },
    {
        "id": 610927,
        "region_name": "镇坪县",
        "parent_id": 610900,
        "level": 3
    },
    {
        "id": 610928,
        "region_name": "旬阳县",
        "parent_id": 610900,
        "level": 3
    },
    {
        "id": 610929,
        "region_name": "白河县",
        "parent_id": 610900,
        "level": 3
    },
    {
        "id": 611000,
        "region_name": "商洛市",
        "parent_id": 610000,
        "level": 2
    },
    {
        "id": 611002,
        "region_name": "商州区",
        "parent_id": 611000,
        "level": 3
    },
    {
        "id": 611021,
        "region_name": "洛南县",
        "parent_id": 611000,
        "level": 3
    },
    {
        "id": 611022,
        "region_name": "丹凤县",
        "parent_id": 611000,
        "level": 3
    },
    {
        "id": 611023,
        "region_name": "商南县",
        "parent_id": 611000,
        "level": 3
    },
    {
        "id": 611024,
        "region_name": "山阳县",
        "parent_id": 611000,
        "level": 3
    },
    {
        "id": 611025,
        "region_name": "镇安县",
        "parent_id": 611000,
        "level": 3
    },
    {
        "id": 611026,
        "region_name": "柞水县",
        "parent_id": 611000,
        "level": 3
    },
    {
        "id": 620000,
        "region_name": "甘肃省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 620100,
        "region_name": "兰州市",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 620102,
        "region_name": "城关区",
        "parent_id": 620100,
        "level": 3
    },
    {
        "id": 620103,
        "region_name": "七里河区",
        "parent_id": 620100,
        "level": 3
    },
    {
        "id": 620104,
        "region_name": "西固区",
        "parent_id": 620100,
        "level": 3
    },
    {
        "id": 620105,
        "region_name": "安宁区",
        "parent_id": 620100,
        "level": 3
    },
    {
        "id": 620111,
        "region_name": "红古区",
        "parent_id": 620100,
        "level": 3
    },
    {
        "id": 620121,
        "region_name": "永登县",
        "parent_id": 620100,
        "level": 3
    },
    {
        "id": 620122,
        "region_name": "皋兰县",
        "parent_id": 620100,
        "level": 3
    },
    {
        "id": 620123,
        "region_name": "榆中县",
        "parent_id": 620100,
        "level": 3
    },
    {
        "id": 620200,
        "region_name": "嘉峪关市",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 620201,
        "region_name": "市辖区",
        "parent_id": 620200,
        "level": 3
    },
    {
        "id": 620300,
        "region_name": "金昌市",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 620302,
        "region_name": "金川区",
        "parent_id": 620300,
        "level": 3
    },
    {
        "id": 620321,
        "region_name": "永昌县",
        "parent_id": 620300,
        "level": 3
    },
    {
        "id": 620400,
        "region_name": "白银市",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 620402,
        "region_name": "白银区",
        "parent_id": 620400,
        "level": 3
    },
    {
        "id": 620403,
        "region_name": "平川区",
        "parent_id": 620400,
        "level": 3
    },
    {
        "id": 620421,
        "region_name": "靖远县",
        "parent_id": 620400,
        "level": 3
    },
    {
        "id": 620422,
        "region_name": "会宁县",
        "parent_id": 620400,
        "level": 3
    },
    {
        "id": 620423,
        "region_name": "景泰县",
        "parent_id": 620400,
        "level": 3
    },
    {
        "id": 620500,
        "region_name": "天水市",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 620502,
        "region_name": "秦州区",
        "parent_id": 620500,
        "level": 3
    },
    {
        "id": 620503,
        "region_name": "麦积区",
        "parent_id": 620500,
        "level": 3
    },
    {
        "id": 620521,
        "region_name": "清水县",
        "parent_id": 620500,
        "level": 3
    },
    {
        "id": 620522,
        "region_name": "秦安县",
        "parent_id": 620500,
        "level": 3
    },
    {
        "id": 620523,
        "region_name": "甘谷县",
        "parent_id": 620500,
        "level": 3
    },
    {
        "id": 620524,
        "region_name": "武山县",
        "parent_id": 620500,
        "level": 3
    },
    {
        "id": 620525,
        "region_name": "张家川回族自治县",
        "parent_id": 620500,
        "level": 3
    },
    {
        "id": 620600,
        "region_name": "武威市",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 620602,
        "region_name": "凉州区",
        "parent_id": 620600,
        "level": 3
    },
    {
        "id": 620621,
        "region_name": "民勤县",
        "parent_id": 620600,
        "level": 3
    },
    {
        "id": 620622,
        "region_name": "古浪县",
        "parent_id": 620600,
        "level": 3
    },
    {
        "id": 620623,
        "region_name": "天祝藏族自治县",
        "parent_id": 620600,
        "level": 3
    },
    {
        "id": 620700,
        "region_name": "张掖市",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 620702,
        "region_name": "甘州区",
        "parent_id": 620700,
        "level": 3
    },
    {
        "id": 620721,
        "region_name": "肃南裕固族自治县",
        "parent_id": 620700,
        "level": 3
    },
    {
        "id": 620722,
        "region_name": "民乐县",
        "parent_id": 620700,
        "level": 3
    },
    {
        "id": 620723,
        "region_name": "临泽县",
        "parent_id": 620700,
        "level": 3
    },
    {
        "id": 620724,
        "region_name": "高台县",
        "parent_id": 620700,
        "level": 3
    },
    {
        "id": 620725,
        "region_name": "山丹县",
        "parent_id": 620700,
        "level": 3
    },
    {
        "id": 620800,
        "region_name": "平凉市",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 620802,
        "region_name": "崆峒区",
        "parent_id": 620800,
        "level": 3
    },
    {
        "id": 620821,
        "region_name": "泾川县",
        "parent_id": 620800,
        "level": 3
    },
    {
        "id": 620822,
        "region_name": "灵台县",
        "parent_id": 620800,
        "level": 3
    },
    {
        "id": 620823,
        "region_name": "崇信县",
        "parent_id": 620800,
        "level": 3
    },
    {
        "id": 620824,
        "region_name": "华亭县",
        "parent_id": 620800,
        "level": 3
    },
    {
        "id": 620825,
        "region_name": "庄浪县",
        "parent_id": 620800,
        "level": 3
    },
    {
        "id": 620826,
        "region_name": "静宁县",
        "parent_id": 620800,
        "level": 3
    },
    {
        "id": 620900,
        "region_name": "酒泉市",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 620902,
        "region_name": "肃州区",
        "parent_id": 620900,
        "level": 3
    },
    {
        "id": 620921,
        "region_name": "金塔县",
        "parent_id": 620900,
        "level": 3
    },
    {
        "id": 620922,
        "region_name": "瓜州县",
        "parent_id": 620900,
        "level": 3
    },
    {
        "id": 620923,
        "region_name": "肃北蒙古族自治县",
        "parent_id": 620900,
        "level": 3
    },
    {
        "id": 620924,
        "region_name": "阿克塞哈萨克族自治县",
        "parent_id": 620900,
        "level": 3
    },
    {
        "id": 620981,
        "region_name": "玉门市",
        "parent_id": 620900,
        "level": 3
    },
    {
        "id": 620982,
        "region_name": "敦煌市",
        "parent_id": 620900,
        "level": 3
    },
    {
        "id": 621000,
        "region_name": "庆阳市",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 621002,
        "region_name": "西峰区",
        "parent_id": 621000,
        "level": 3
    },
    {
        "id": 621021,
        "region_name": "庆城县",
        "parent_id": 621000,
        "level": 3
    },
    {
        "id": 621022,
        "region_name": "环县",
        "parent_id": 621000,
        "level": 3
    },
    {
        "id": 621023,
        "region_name": "华池县",
        "parent_id": 621000,
        "level": 3
    },
    {
        "id": 621024,
        "region_name": "合水县",
        "parent_id": 621000,
        "level": 3
    },
    {
        "id": 621025,
        "region_name": "正宁县",
        "parent_id": 621000,
        "level": 3
    },
    {
        "id": 621026,
        "region_name": "宁县",
        "parent_id": 621000,
        "level": 3
    },
    {
        "id": 621027,
        "region_name": "镇原县",
        "parent_id": 621000,
        "level": 3
    },
    {
        "id": 621100,
        "region_name": "定西市",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 621102,
        "region_name": "安定区",
        "parent_id": 621100,
        "level": 3
    },
    {
        "id": 621121,
        "region_name": "通渭县",
        "parent_id": 621100,
        "level": 3
    },
    {
        "id": 621122,
        "region_name": "陇西县",
        "parent_id": 621100,
        "level": 3
    },
    {
        "id": 621123,
        "region_name": "渭源县",
        "parent_id": 621100,
        "level": 3
    },
    {
        "id": 621124,
        "region_name": "临洮县",
        "parent_id": 621100,
        "level": 3
    },
    {
        "id": 621125,
        "region_name": "漳县",
        "parent_id": 621100,
        "level": 3
    },
    {
        "id": 621126,
        "region_name": "岷县",
        "parent_id": 621100,
        "level": 3
    },
    {
        "id": 621200,
        "region_name": "陇南市",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 621202,
        "region_name": "武都区",
        "parent_id": 621200,
        "level": 3
    },
    {
        "id": 621221,
        "region_name": "成县",
        "parent_id": 621200,
        "level": 3
    },
    {
        "id": 621222,
        "region_name": "文县",
        "parent_id": 621200,
        "level": 3
    },
    {
        "id": 621223,
        "region_name": "宕昌县",
        "parent_id": 621200,
        "level": 3
    },
    {
        "id": 621224,
        "region_name": "康县",
        "parent_id": 621200,
        "level": 3
    },
    {
        "id": 621225,
        "region_name": "西和县",
        "parent_id": 621200,
        "level": 3
    },
    {
        "id": 621226,
        "region_name": "礼县",
        "parent_id": 621200,
        "level": 3
    },
    {
        "id": 621227,
        "region_name": "徽县",
        "parent_id": 621200,
        "level": 3
    },
    {
        "id": 621228,
        "region_name": "两当县",
        "parent_id": 621200,
        "level": 3
    },
    {
        "id": 622900,
        "region_name": "临夏回族自治州",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 622901,
        "region_name": "临夏市",
        "parent_id": 622900,
        "level": 3
    },
    {
        "id": 622921,
        "region_name": "临夏县",
        "parent_id": 622900,
        "level": 3
    },
    {
        "id": 622922,
        "region_name": "康乐县",
        "parent_id": 622900,
        "level": 3
    },
    {
        "id": 622923,
        "region_name": "永靖县",
        "parent_id": 622900,
        "level": 3
    },
    {
        "id": 622924,
        "region_name": "广河县",
        "parent_id": 622900,
        "level": 3
    },
    {
        "id": 622925,
        "region_name": "和政县",
        "parent_id": 622900,
        "level": 3
    },
    {
        "id": 622926,
        "region_name": "东乡族自治县",
        "parent_id": 622900,
        "level": 3
    },
    {
        "id": 622927,
        "region_name": "积石山保安族东乡族撒拉族自治县",
        "parent_id": 622900,
        "level": 3
    },
    {
        "id": 623000,
        "region_name": "甘南藏族自治州",
        "parent_id": 620000,
        "level": 2
    },
    {
        "id": 623001,
        "region_name": "合作市",
        "parent_id": 623000,
        "level": 3
    },
    {
        "id": 623021,
        "region_name": "临潭县",
        "parent_id": 623000,
        "level": 3
    },
    {
        "id": 623022,
        "region_name": "卓尼县",
        "parent_id": 623000,
        "level": 3
    },
    {
        "id": 623023,
        "region_name": "舟曲县",
        "parent_id": 623000,
        "level": 3
    },
    {
        "id": 623024,
        "region_name": "迭部县",
        "parent_id": 623000,
        "level": 3
    },
    {
        "id": 623025,
        "region_name": "玛曲县",
        "parent_id": 623000,
        "level": 3
    },
    {
        "id": 623026,
        "region_name": "碌曲县",
        "parent_id": 623000,
        "level": 3
    },
    {
        "id": 623027,
        "region_name": "夏河县",
        "parent_id": 623000,
        "level": 3
    },
    {
        "id": 630000,
        "region_name": "青海省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 630100,
        "region_name": "西宁市",
        "parent_id": 630000,
        "level": 2
    },
    {
        "id": 630102,
        "region_name": "城东区",
        "parent_id": 630100,
        "level": 3
    },
    {
        "id": 630103,
        "region_name": "城中区",
        "parent_id": 630100,
        "level": 3
    },
    {
        "id": 630104,
        "region_name": "城西区",
        "parent_id": 630100,
        "level": 3
    },
    {
        "id": 630105,
        "region_name": "城北区",
        "parent_id": 630100,
        "level": 3
    },
    {
        "id": 630121,
        "region_name": "大通回族土族自治县",
        "parent_id": 630100,
        "level": 3
    },
    {
        "id": 630122,
        "region_name": "湟中县",
        "parent_id": 630100,
        "level": 3
    },
    {
        "id": 630123,
        "region_name": "湟源县",
        "parent_id": 630100,
        "level": 3
    },
    {
        "id": 630200,
        "region_name": "海东市",
        "parent_id": 630000,
        "level": 2
    },
    {
        "id": 630202,
        "region_name": "乐都区",
        "parent_id": 630200,
        "level": 3
    },
    {
        "id": 630203,
        "region_name": "平安区",
        "parent_id": 630200,
        "level": 3
    },
    {
        "id": 630222,
        "region_name": "民和回族土族自治县",
        "parent_id": 630200,
        "level": 3
    },
    {
        "id": 630223,
        "region_name": "互助土族自治县",
        "parent_id": 630200,
        "level": 3
    },
    {
        "id": 630224,
        "region_name": "化隆回族自治县",
        "parent_id": 630200,
        "level": 3
    },
    {
        "id": 630225,
        "region_name": "循化撒拉族自治县",
        "parent_id": 630200,
        "level": 3
    },
    {
        "id": 632200,
        "region_name": "海北藏族自治州",
        "parent_id": 630000,
        "level": 2
    },
    {
        "id": 632221,
        "region_name": "门源回族自治县",
        "parent_id": 632200,
        "level": 3
    },
    {
        "id": 632222,
        "region_name": "祁连县",
        "parent_id": 632200,
        "level": 3
    },
    {
        "id": 632223,
        "region_name": "海晏县",
        "parent_id": 632200,
        "level": 3
    },
    {
        "id": 632224,
        "region_name": "刚察县",
        "parent_id": 632200,
        "level": 3
    },
    {
        "id": 632300,
        "region_name": "黄南藏族自治州",
        "parent_id": 630000,
        "level": 2
    },
    {
        "id": 632321,
        "region_name": "同仁县",
        "parent_id": 632300,
        "level": 3
    },
    {
        "id": 632322,
        "region_name": "尖扎县",
        "parent_id": 632300,
        "level": 3
    },
    {
        "id": 632323,
        "region_name": "泽库县",
        "parent_id": 632300,
        "level": 3
    },
    {
        "id": 632324,
        "region_name": "河南蒙古族自治县",
        "parent_id": 632300,
        "level": 3
    },
    {
        "id": 632500,
        "region_name": "海南藏族自治州",
        "parent_id": 630000,
        "level": 2
    },
    {
        "id": 632521,
        "region_name": "共和县",
        "parent_id": 632500,
        "level": 3
    },
    {
        "id": 632522,
        "region_name": "同德县",
        "parent_id": 632500,
        "level": 3
    },
    {
        "id": 632523,
        "region_name": "贵德县",
        "parent_id": 632500,
        "level": 3
    },
    {
        "id": 632524,
        "region_name": "兴海县",
        "parent_id": 632500,
        "level": 3
    },
    {
        "id": 632525,
        "region_name": "贵南县",
        "parent_id": 632500,
        "level": 3
    },
    {
        "id": 632600,
        "region_name": "果洛藏族自治州",
        "parent_id": 630000,
        "level": 2
    },
    {
        "id": 632621,
        "region_name": "玛沁县",
        "parent_id": 632600,
        "level": 3
    },
    {
        "id": 632622,
        "region_name": "班玛县",
        "parent_id": 632600,
        "level": 3
    },
    {
        "id": 632623,
        "region_name": "甘德县",
        "parent_id": 632600,
        "level": 3
    },
    {
        "id": 632624,
        "region_name": "达日县",
        "parent_id": 632600,
        "level": 3
    },
    {
        "id": 632625,
        "region_name": "久治县",
        "parent_id": 632600,
        "level": 3
    },
    {
        "id": 632626,
        "region_name": "玛多县",
        "parent_id": 632600,
        "level": 3
    },
    {
        "id": 632700,
        "region_name": "玉树藏族自治州",
        "parent_id": 630000,
        "level": 2
    },
    {
        "id": 632701,
        "region_name": "玉树市",
        "parent_id": 632700,
        "level": 3
    },
    {
        "id": 632722,
        "region_name": "杂多县",
        "parent_id": 632700,
        "level": 3
    },
    {
        "id": 632723,
        "region_name": "称多县",
        "parent_id": 632700,
        "level": 3
    },
    {
        "id": 632724,
        "region_name": "治多县",
        "parent_id": 632700,
        "level": 3
    },
    {
        "id": 632725,
        "region_name": "囊谦县",
        "parent_id": 632700,
        "level": 3
    },
    {
        "id": 632726,
        "region_name": "曲麻莱县",
        "parent_id": 632700,
        "level": 3
    },
    {
        "id": 632800,
        "region_name": "海西蒙古族藏族自治州",
        "parent_id": 630000,
        "level": 2
    },
    {
        "id": 632801,
        "region_name": "格尔木市",
        "parent_id": 632800,
        "level": 3
    },
    {
        "id": 632802,
        "region_name": "德令哈市",
        "parent_id": 632800,
        "level": 3
    },
    {
        "id": 632821,
        "region_name": "乌兰县",
        "parent_id": 632800,
        "level": 3
    },
    {
        "id": 632822,
        "region_name": "都兰县",
        "parent_id": 632800,
        "level": 3
    },
    {
        "id": 632823,
        "region_name": "天峻县",
        "parent_id": 632800,
        "level": 3
    },
    {
        "id": 640000,
        "region_name": "宁夏回族自治区",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 640100,
        "region_name": "银川市",
        "parent_id": 640000,
        "level": 2
    },
    {
        "id": 640104,
        "region_name": "兴庆区",
        "parent_id": 640100,
        "level": 3
    },
    {
        "id": 640105,
        "region_name": "西夏区",
        "parent_id": 640100,
        "level": 3
    },
    {
        "id": 640106,
        "region_name": "金凤区",
        "parent_id": 640100,
        "level": 3
    },
    {
        "id": 640121,
        "region_name": "永宁县",
        "parent_id": 640100,
        "level": 3
    },
    {
        "id": 640122,
        "region_name": "贺兰县",
        "parent_id": 640100,
        "level": 3
    },
    {
        "id": 640181,
        "region_name": "灵武市",
        "parent_id": 640100,
        "level": 3
    },
    {
        "id": 640200,
        "region_name": "石嘴山市",
        "parent_id": 640000,
        "level": 2
    },
    {
        "id": 640202,
        "region_name": "大武口区",
        "parent_id": 640200,
        "level": 3
    },
    {
        "id": 640205,
        "region_name": "惠农区",
        "parent_id": 640200,
        "level": 3
    },
    {
        "id": 640221,
        "region_name": "平罗县",
        "parent_id": 640200,
        "level": 3
    },
    {
        "id": 640300,
        "region_name": "吴忠市",
        "parent_id": 640000,
        "level": 2
    },
    {
        "id": 640302,
        "region_name": "利通区",
        "parent_id": 640300,
        "level": 3
    },
    {
        "id": 640303,
        "region_name": "红寺堡区",
        "parent_id": 640300,
        "level": 3
    },
    {
        "id": 640323,
        "region_name": "盐池县",
        "parent_id": 640300,
        "level": 3
    },
    {
        "id": 640324,
        "region_name": "同心县",
        "parent_id": 640300,
        "level": 3
    },
    {
        "id": 640381,
        "region_name": "青铜峡市",
        "parent_id": 640300,
        "level": 3
    },
    {
        "id": 640400,
        "region_name": "固原市",
        "parent_id": 640000,
        "level": 2
    },
    {
        "id": 640402,
        "region_name": "原州区",
        "parent_id": 640400,
        "level": 3
    },
    {
        "id": 640422,
        "region_name": "西吉县",
        "parent_id": 640400,
        "level": 3
    },
    {
        "id": 640423,
        "region_name": "隆德县",
        "parent_id": 640400,
        "level": 3
    },
    {
        "id": 640424,
        "region_name": "泾源县",
        "parent_id": 640400,
        "level": 3
    },
    {
        "id": 640425,
        "region_name": "彭阳县",
        "parent_id": 640400,
        "level": 3
    },
    {
        "id": 640500,
        "region_name": "中卫市",
        "parent_id": 640000,
        "level": 2
    },
    {
        "id": 640502,
        "region_name": "沙坡头区",
        "parent_id": 640500,
        "level": 3
    },
    {
        "id": 640521,
        "region_name": "中宁县",
        "parent_id": 640500,
        "level": 3
    },
    {
        "id": 640522,
        "region_name": "海原县",
        "parent_id": 640500,
        "level": 3
    },
    {
        "id": 650000,
        "region_name": "新疆维吾尔自治区",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 650100,
        "region_name": "乌鲁木齐市",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 650102,
        "region_name": "天山区",
        "parent_id": 650100,
        "level": 3
    },
    {
        "id": 650103,
        "region_name": "沙依巴克区",
        "parent_id": 650100,
        "level": 3
    },
    {
        "id": 650104,
        "region_name": "新市区",
        "parent_id": 650100,
        "level": 3
    },
    {
        "id": 650105,
        "region_name": "水磨沟区",
        "parent_id": 650100,
        "level": 3
    },
    {
        "id": 650106,
        "region_name": "头屯河区",
        "parent_id": 650100,
        "level": 3
    },
    {
        "id": 650107,
        "region_name": "达坂城区",
        "parent_id": 650100,
        "level": 3
    },
    {
        "id": 650109,
        "region_name": "米东区",
        "parent_id": 650100,
        "level": 3
    },
    {
        "id": 650121,
        "region_name": "乌鲁木齐县",
        "parent_id": 650100,
        "level": 3
    },
    {
        "id": 650200,
        "region_name": "克拉玛依市",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 650202,
        "region_name": "独山子区",
        "parent_id": 650200,
        "level": 3
    },
    {
        "id": 650203,
        "region_name": "克拉玛依区",
        "parent_id": 650200,
        "level": 3
    },
    {
        "id": 650204,
        "region_name": "白碱滩区",
        "parent_id": 650200,
        "level": 3
    },
    {
        "id": 650205,
        "region_name": "乌尔禾区",
        "parent_id": 650200,
        "level": 3
    },
    {
        "id": 650400,
        "region_name": "吐鲁番市",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 650402,
        "region_name": "高昌区",
        "parent_id": 650400,
        "level": 3
    },
    {
        "id": 650421,
        "region_name": "鄯善县",
        "parent_id": 650400,
        "level": 3
    },
    {
        "id": 650422,
        "region_name": "托克逊县",
        "parent_id": 650400,
        "level": 3
    },
    {
        "id": 650500,
        "region_name": "哈密市",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 650502,
        "region_name": "伊州区",
        "parent_id": 650500,
        "level": 3
    },
    {
        "id": 650521,
        "region_name": "巴里坤哈萨克自治县",
        "parent_id": 650500,
        "level": 3
    },
    {
        "id": 650522,
        "region_name": "伊吾县",
        "parent_id": 650500,
        "level": 3
    },
    {
        "id": 652300,
        "region_name": "昌吉回族自治州",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 652301,
        "region_name": "昌吉市",
        "parent_id": 652300,
        "level": 3
    },
    {
        "id": 652302,
        "region_name": "阜康市",
        "parent_id": 652300,
        "level": 3
    },
    {
        "id": 652323,
        "region_name": "呼图壁县",
        "parent_id": 652300,
        "level": 3
    },
    {
        "id": 652324,
        "region_name": "玛纳斯县",
        "parent_id": 652300,
        "level": 3
    },
    {
        "id": 652325,
        "region_name": "奇台县",
        "parent_id": 652300,
        "level": 3
    },
    {
        "id": 652327,
        "region_name": "吉木萨尔县",
        "parent_id": 652300,
        "level": 3
    },
    {
        "id": 652328,
        "region_name": "木垒哈萨克自治县",
        "parent_id": 652300,
        "level": 3
    },
    {
        "id": 652700,
        "region_name": "博尔塔拉蒙古自治州",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 652701,
        "region_name": "博乐市",
        "parent_id": 652700,
        "level": 3
    },
    {
        "id": 652702,
        "region_name": "阿拉山口市",
        "parent_id": 652700,
        "level": 3
    },
    {
        "id": 652722,
        "region_name": "精河县",
        "parent_id": 652700,
        "level": 3
    },
    {
        "id": 652723,
        "region_name": "温泉县",
        "parent_id": 652700,
        "level": 3
    },
    {
        "id": 652800,
        "region_name": "巴音郭楞蒙古自治州",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 652801,
        "region_name": "库尔勒市",
        "parent_id": 652800,
        "level": 3
    },
    {
        "id": 652822,
        "region_name": "轮台县",
        "parent_id": 652800,
        "level": 3
    },
    {
        "id": 652823,
        "region_name": "尉犁县",
        "parent_id": 652800,
        "level": 3
    },
    {
        "id": 652824,
        "region_name": "若羌县",
        "parent_id": 652800,
        "level": 3
    },
    {
        "id": 652825,
        "region_name": "且末县",
        "parent_id": 652800,
        "level": 3
    },
    {
        "id": 652826,
        "region_name": "焉耆回族自治县",
        "parent_id": 652800,
        "level": 3
    },
    {
        "id": 652827,
        "region_name": "和静县",
        "parent_id": 652800,
        "level": 3
    },
    {
        "id": 652828,
        "region_name": "和硕县",
        "parent_id": 652800,
        "level": 3
    },
    {
        "id": 652829,
        "region_name": "博湖县",
        "parent_id": 652800,
        "level": 3
    },
    {
        "id": 652900,
        "region_name": "阿克苏地区",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 652901,
        "region_name": "阿克苏市",
        "parent_id": 652900,
        "level": 3
    },
    {
        "id": 652922,
        "region_name": "温宿县",
        "parent_id": 652900,
        "level": 3
    },
    {
        "id": 652923,
        "region_name": "库车县",
        "parent_id": 652900,
        "level": 3
    },
    {
        "id": 652924,
        "region_name": "沙雅县",
        "parent_id": 652900,
        "level": 3
    },
    {
        "id": 652925,
        "region_name": "新和县",
        "parent_id": 652900,
        "level": 3
    },
    {
        "id": 652926,
        "region_name": "拜城县",
        "parent_id": 652900,
        "level": 3
    },
    {
        "id": 652927,
        "region_name": "乌什县",
        "parent_id": 652900,
        "level": 3
    },
    {
        "id": 652928,
        "region_name": "阿瓦提县",
        "parent_id": 652900,
        "level": 3
    },
    {
        "id": 652929,
        "region_name": "柯坪县",
        "parent_id": 652900,
        "level": 3
    },
    {
        "id": 653000,
        "region_name": "克孜勒苏柯尔克孜自治州",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 653001,
        "region_name": "阿图什市",
        "parent_id": 653000,
        "level": 3
    },
    {
        "id": 653022,
        "region_name": "阿克陶县",
        "parent_id": 653000,
        "level": 3
    },
    {
        "id": 653023,
        "region_name": "阿合奇县",
        "parent_id": 653000,
        "level": 3
    },
    {
        "id": 653024,
        "region_name": "乌恰县",
        "parent_id": 653000,
        "level": 3
    },
    {
        "id": 653100,
        "region_name": "喀什地区",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 653101,
        "region_name": "喀什市",
        "parent_id": 653100,
        "level": 3
    },
    {
        "id": 653121,
        "region_name": "疏附县",
        "parent_id": 653100,
        "level": 3
    },
    {
        "id": 653122,
        "region_name": "疏勒县",
        "parent_id": 653100,
        "level": 3
    },
    {
        "id": 653123,
        "region_name": "英吉沙县",
        "parent_id": 653100,
        "level": 3
    },
    {
        "id": 653124,
        "region_name": "泽普县",
        "parent_id": 653100,
        "level": 3
    },
    {
        "id": 653125,
        "region_name": "莎车县",
        "parent_id": 653100,
        "level": 3
    },
    {
        "id": 653126,
        "region_name": "叶城县",
        "parent_id": 653100,
        "level": 3
    },
    {
        "id": 653127,
        "region_name": "麦盖提县",
        "parent_id": 653100,
        "level": 3
    },
    {
        "id": 653128,
        "region_name": "岳普湖县",
        "parent_id": 653100,
        "level": 3
    },
    {
        "id": 653129,
        "region_name": "伽师县",
        "parent_id": 653100,
        "level": 3
    },
    {
        "id": 653130,
        "region_name": "巴楚县",
        "parent_id": 653100,
        "level": 3
    },
    {
        "id": 653131,
        "region_name": "塔什库尔干塔吉克自治县",
        "parent_id": 653100,
        "level": 3
    },
    {
        "id": 653200,
        "region_name": "和田地区",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 653201,
        "region_name": "和田市",
        "parent_id": 653200,
        "level": 3
    },
    {
        "id": 653221,
        "region_name": "和田县",
        "parent_id": 653200,
        "level": 3
    },
    {
        "id": 653222,
        "region_name": "墨玉县",
        "parent_id": 653200,
        "level": 3
    },
    {
        "id": 653223,
        "region_name": "皮山县",
        "parent_id": 653200,
        "level": 3
    },
    {
        "id": 653224,
        "region_name": "洛浦县",
        "parent_id": 653200,
        "level": 3
    },
    {
        "id": 653225,
        "region_name": "策勒县",
        "parent_id": 653200,
        "level": 3
    },
    {
        "id": 653226,
        "region_name": "于田县",
        "parent_id": 653200,
        "level": 3
    },
    {
        "id": 653227,
        "region_name": "民丰县",
        "parent_id": 653200,
        "level": 3
    },
    {
        "id": 654000,
        "region_name": "伊犁哈萨克自治州",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 654002,
        "region_name": "伊宁市",
        "parent_id": 654000,
        "level": 3
    },
    {
        "id": 654003,
        "region_name": "奎屯市",
        "parent_id": 654000,
        "level": 3
    },
    {
        "id": 654004,
        "region_name": "霍尔果斯市",
        "parent_id": 654000,
        "level": 3
    },
    {
        "id": 654021,
        "region_name": "伊宁县",
        "parent_id": 654000,
        "level": 3
    },
    {
        "id": 654022,
        "region_name": "察布查尔锡伯自治县",
        "parent_id": 654000,
        "level": 3
    },
    {
        "id": 654023,
        "region_name": "霍城县",
        "parent_id": 654000,
        "level": 3
    },
    {
        "id": 654024,
        "region_name": "巩留县",
        "parent_id": 654000,
        "level": 3
    },
    {
        "id": 654025,
        "region_name": "新源县",
        "parent_id": 654000,
        "level": 3
    },
    {
        "id": 654026,
        "region_name": "昭苏县",
        "parent_id": 654000,
        "level": 3
    },
    {
        "id": 654027,
        "region_name": "特克斯县",
        "parent_id": 654000,
        "level": 3
    },
    {
        "id": 654028,
        "region_name": "尼勒克县",
        "parent_id": 654000,
        "level": 3
    },
    {
        "id": 654200,
        "region_name": "塔城地区",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 654201,
        "region_name": "塔城市",
        "parent_id": 654200,
        "level": 3
    },
    {
        "id": 654202,
        "region_name": "乌苏市",
        "parent_id": 654200,
        "level": 3
    },
    {
        "id": 654221,
        "region_name": "额敏县",
        "parent_id": 654200,
        "level": 3
    },
    {
        "id": 654223,
        "region_name": "沙湾县",
        "parent_id": 654200,
        "level": 3
    },
    {
        "id": 654224,
        "region_name": "托里县",
        "parent_id": 654200,
        "level": 3
    },
    {
        "id": 654225,
        "region_name": "裕民县",
        "parent_id": 654200,
        "level": 3
    },
    {
        "id": 654226,
        "region_name": "和布克赛尔蒙古自治县",
        "parent_id": 654200,
        "level": 3
    },
    {
        "id": 654300,
        "region_name": "阿勒泰地区",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 654301,
        "region_name": "阿勒泰市",
        "parent_id": 654300,
        "level": 3
    },
    {
        "id": 654321,
        "region_name": "布尔津县",
        "parent_id": 654300,
        "level": 3
    },
    {
        "id": 654322,
        "region_name": "富蕴县",
        "parent_id": 654300,
        "level": 3
    },
    {
        "id": 654323,
        "region_name": "福海县",
        "parent_id": 654300,
        "level": 3
    },
    {
        "id": 654324,
        "region_name": "哈巴河县",
        "parent_id": 654300,
        "level": 3
    },
    {
        "id": 654325,
        "region_name": "青河县",
        "parent_id": 654300,
        "level": 3
    },
    {
        "id": 654326,
        "region_name": "吉木乃县",
        "parent_id": 654300,
        "level": 3
    },
    {
        "id": 659000,
        "region_name": "直辖县市",
        "parent_id": 650000,
        "level": 2
    },
    {
        "id": 659001,
        "region_name": "石河子市",
        "parent_id": 659000,
        "level": 3
    },
    {
        "id": 659002,
        "region_name": "阿拉尔市",
        "parent_id": 659000,
        "level": 3
    },
    {
        "id": 659003,
        "region_name": "图木舒克市",
        "parent_id": 659000,
        "level": 3
    },
    {
        "id": 659004,
        "region_name": "五家渠市",
        "parent_id": 659000,
        "level": 3
    },
    {
        "id": 659005,
        "region_name": "北屯市",
        "parent_id": 659000,
        "level": 3
    },
    {
        "id": 659006,
        "region_name": "铁门关市",
        "parent_id": 659000,
        "level": 3
    },
    {
        "id": 659007,
        "region_name": "双河市",
        "parent_id": 659000,
        "level": 3
    },
    {
        "id": 659008,
        "region_name": "可克达拉市",
        "parent_id": 659000,
        "level": 3
    },
    {
        "id": 659009,
        "region_name": "昆玉市",
        "parent_id": 659000,
        "level": 3
    },
    {
        "id": 710000,
        "region_name": "台湾省",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 810000,
        "region_name": "香港特别行政区",
        "parent_id": 0,
        "level": 1
    },
    {
        "id": 820000,
        "region_name": "澳门特别行政区",
        "parent_id": 0,
        "level": 1
    }
]
export default regionData